{
    "registries": {
        "ability_light_type": {
            "4A77B6AA-17C7-DDA6-C5ED-28DD38513C48": {
                "item_id": "4A77B6AA-17C7-DDA6-C5ED-28DD38513C48",
                "item_name": "Create Candlelight",
                "variable_name": "create_candlelight"
            },
            "105BDD18-BC99-9F5D-F92F-3D5DAC8C235A": {
                "item_id": "105BDD18-BC99-9F5D-F92F-3D5DAC8C235A",
                "item_name": "Create Torchlight",
                "variable_name": "create_torchlight"
            },
            "55D75BB2-ABF3-BB28-34FC-72A1B4FFEE02": {
                "item_id": "55D75BB2-ABF3-BB28-34FC-72A1B4FFEE02",
                "item_name": "Create Brightlight",
                "variable_name": "create_brightlight"
            }
        },
        "aoe_type": {
            "C53BE2B6-07EA-4B3B-9664-1AD286C44AF9": {
                "item_id": "C53BE2B6-07EA-4B3B-9664-1AD286C44AF9",
                "item_name": "Circle",
                "variable_name": "circle"
            },
            "0FEF0148-6B62-4601-A8A1-A5A1A22905D8": {
                "item_id": "0FEF0148-6B62-4601-A8A1-A5A1A22905D8",
                "item_name": "Cone",
                "variable_name": "cone"
            },
            "0DBFA54E-F921-4835-B159-2A4AEFA62408": {
                "item_id": "0DBFA54E-F921-4835-B159-2A4AEFA62408",
                "item_name": "Cube",
                "variable_name": "cube"
            },
            "E8B770D7-1BC3-4035-A29C-B99047884CC1": {
                "item_id": "E8B770D7-1BC3-4035-A29C-B99047884CC1",
                "item_name": "Cylinder",
                "variable_name": "cylinder"
            },
            "56D1C490-B589-4B17-889A-59D866E38D54": {
                "item_id": "56D1C490-B589-4B17-889A-59D866E38D54",
                "item_name": "Line",
                "variable_name": "line"
            },
            "981032B8-4F0B-43C9-8D98-67C693E4DB42": {
                "item_id": "981032B8-4F0B-43C9-8D98-67C693E4DB42",
                "item_name": "Sphere",
                "variable_name": "sphere"
            },
            "3F14BF23-09A6-4C05-AFD9-EE0CCD2596A3": {
                "item_id": "3F14BF23-09A6-4C05-AFD9-EE0CCD2596A3",
                "item_name": "Square",
                "variable_name": "square"
            }
        },
        "armor_type": {
            "D7B3BAD1-9675-4993-8E25-0C834977966E": {
                "item_id": "D7B3BAD1-9675-4993-8E25-0C834977966E",
                "item_name": "Natural",
                "item_type": "armor_type",
                "variable_name": "natural"
            },
            "D33CD865-4B66-4843-9AE5-9AFCA1133253": {
                "item_id": "D33CD865-4B66-4843-9AE5-9AFCA1133253",
                "item_name": "Light",
                "item_type": "armor_type",
                "variable_name": "light"
            },
            "FEC16F4D-6309-48A5-82E4-833EF06A0E54": {
                "item_id": "FEC16F4D-6309-48A5-82E4-833EF06A0E54",
                "item_name": "Medium",
                "item_type": "armor_type",
                "variable_name": "medium"
            },
            "F94A6EAD-BC5A-466D-B27B-7688423B4332": {
                "item_id": "F94A6EAD-BC5A-466D-B27B-7688423B4332",
                "item_name": "Heavy",
                "item_type": "armor_type",
                "variable_name": "heavy"
            },
            "376E7991-D1E3-D280-5186-F09AE6F90CD8": {
                "item_id": "376E7991-D1E3-D280-5186-F09AE6F90CD8",
                "item_name": "Shield",
                "item_type": "armor_type",
                "variable_name": "shield"
            }
        },
        "campaign_difficulty": {
            "FDC86C34-8F96-3361-E0A9-FCFAFF0522D9": {
                "item_id": "FDC86C34-8F96-3361-E0A9-FCFAFF0522D9",
                "item_name": "Campaign Difficulty Easy",
                "item_type": "campaign_difficulty",
                "variable_name": "campaign_difficulty_easy"
            },
            "410CC547-393F-0922-9C58-48F618A27742": {
                "item_id": "410CC547-393F-0922-9C58-48F618A27742",
                "item_name": "Campaign Difficulty Normal",
                "item_type": "campaign_difficulty",
                "variable_name": "campaign_difficulty_normal"
            },
            "DF66C93B-B190-4A4C-8E15-72E79D8F7C08": {
                "item_id": "DF66C93B-B190-4A4C-8E15-72E79D8F7C08",
                "item_name": "Campaign Difficulty Hardcore",
                "item_type": "campaign_difficulty",
                "variable_name": "campaign_difficulty_hardcore"
            }
        },
        "campaign_house_rule_type": {
            "51219FD2-350B-3C07-16B1-C0382B0C4EB3": {
                "item_id": "51219FD2-350B-3C07-16B1-C0382B0C4EB3",
                "item_name": "Magic: Overcasting",
                "item_type": "campaign_house_rule_type",
                "variable_name": "magic_overcasting_all_casters"
            },
            "0B99F086-B50F-236E-CBBD-AB4E617E75E8": {
                "item_id": "0B99F086-B50F-236E-CBBD-AB4E617E75E8",
                "item_name": "Combat: No Called Shots",
                "item_type": "campaign_house_rule_type",
                "variable_name": "combat_no_called_shots"
            },
            "6AE51489-5732-6F8B-3ACC-45B0B9118F3C": {
                "item_id": "6AE51489-5732-6F8B-3ACC-45B0B9118F3C",
                "item_name": "Damage: Exploding Dice",
                "item_type": "campaign_house_rule_type",
                "variable_name": "exploding_damage_dice"
            },
            "2087C1FB-57E3-2E51-AC0E-6FF8C15629AA": {
                "item_id": "2087C1FB-57E3-2E51-AC0E-6FF8C15629AA",
                "item_name": "Critical Hits: Maximum Dice (default)",
                "item_type": "campaign_house_rule_type",
                "variable_name": "critical_hits_maximum_dice"
            },
            "6CFB808D-D8BE-7A0C-E2E2-03F68E26DDA8": {
                "item_id": "6CFB808D-D8BE-7A0C-E2E2-03F68E26DDA8",
                "item_name": "Critical Hits: Rolled Dice",
                "item_type": "campaign_house_rule_type",
                "variable_name": "critical_hits_rolled_dice"
            },
            "726E0917-9257-23FD-A18C-C07B4C00B8A1": {
                "item_id": "726E0917-9257-23FD-A18C-C07B4C00B8A1",
                "item_name": "Critical Hits: Doubled Damage",
                "item_type": "campaign_house_rule_type",
                "variable_name": "critical_hits_doubled_damage"
            },
            "6C85D904-D3AE-5680-666F-5FC49A4FFF4D": {
                "item_id": "6C85D904-D3AE-5680-666F-5FC49A4FFF4D",
                "item_name": "Critical Hits: Improved Damage - Remarkable (20 x 2)",
                "item_type": "campaign_house_rule_type",
                "variable_name": "critical_hits_improved_damage_remarkable"
            },
            "71221E94-E2E8-EF30-EE0E-8E4C53860250": {
                "item_id": "71221E94-E2E8-EF30-EE0E-8E4C53860250",
                "item_name": "Critical Hits: Improved Damage - World-shaking (20 x 3)",
                "item_type": "campaign_house_rule_type",
                "variable_name": "critical_hits_improved_damage_world_shaking"
            },
            "FFFE4F7F-0018-4961-5BB9-2B69268CD48E": {
                "item_id": "FFFE4F7F-0018-4961-5BB9-2B69268CD48E",
                "item_name": "Critical Hits: Maimed",
                "item_type": "campaign_house_rule_type",
                "variable_name": "maimed_on_crit_fortitude_save"
            },
            "0A0B2172-AF81-5D5B-188C-294D5DDB7B74": {
                "item_id": "0A0B2172-AF81-5D5B-188C-294D5DDB7B74",
                "item_name": "Dying Rolls: Maimed",
                "item_type": "campaign_house_rule_type",
                "variable_name": "maimed_on_dying_stratum_fail_by_5"
            },
            "D5E5FD24-26D9-76BB-1223-003C98D07F69": {
                "item_id": "D5E5FD24-26D9-76BB-1223-003C98D07F69",
                "item_name": "Massive Damage: Maimed",
                "item_type": "campaign_house_rule_type",
                "variable_name": "maimed_on_massive_damage_fortitude_save"
            },
            "F1F5285D-E498-4B20-956C-C4CC51015DFC": {
                "item_id": "F1F5285D-E498-4B20-956C-C4CC51015DFC",
                "item_name": "Inventory: No Encumbrance",
                "item_type": "campaign_house_rule_type",
                "variable_name": "no_encumbrance"
            },
            "03788F23-69EB-9DA7-1D4C-C07B93A33070": {
                "item_id": "03788F23-69EB-9DA7-1D4C-C07B93A33070",
                "item_name": "Unhide Meta Rolls",
                "item_type": "campaign_house_rule_type",
                "variable_name": "unhide_meta_rolls"
            }
        },
        "caster_type": {
            "A18765B6-F35A-47E2-F112-DF1582C37B37": {
                "item_id": "A18765B6-F35A-47E2-F112-DF1582C37B37",
                "item_name": "Full Caster",
                "item_type": "caster_type",
                "variable_name": "full_caster"
            },
            "E8FB3E1F-2B16-4889-831C-99FC9E34853E": {
                "item_id": "E8FB3E1F-2B16-4889-831C-99FC9E34853E",
                "item_name": "Half Caster",
                "item_type": "caster_type",
                "variable_name": "half_caster"
            },
            "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B": {
                "item_id": "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B",
                "item_name": "No Bending Powers",
                "item_type": "caster_type",
                "variable_name": "no_bending_powers"
            }
        },
        "custom_ability_type": {
            "C79A906F-BA10-B705-1CB9-6A7C5DFAEBEF": {
                "item_id": "C79A906F-BA10-B705-1CB9-6A7C5DFAEBEF",
                "item_name": "Custom Full Ability",
                "item_type": "full_ability",
                "variable_name": "custom_full_ability",
                "aps_ability": 3
            },
            "E350D4F5-B29D-17C0-4AB4-0CAA0398C74A": {
                "item_id": "E350D4F5-B29D-17C0-4AB4-0CAA0398C74A",
                "item_name": "Custom Ability",
                "item_type": "ability",
                "variable_name": "custom_ability",
                "aps_ability": 2
            },
            "41FF250E-4146-C8C2-1324-DD6911BDB372": {
                "item_id": "41FF250E-4146-C8C2-1324-DD6911BDB372",
                "item_name": "Custom Quick Ability",
                "item_type": "quick_ability",
                "variable_name": "custom_quick_ability",
                "aps_ability": 1
            },
            "EEB78637-0F73-8369-D230-8C29512B759E": {
                "item_id": "EEB78637-0F73-8369-D230-8C29512B759E",
                "item_name": "Custom Free Ability",
                "item_type": "free_ability",
                "variable_name": "custom_free_ability",
                "aps_ability": 0
            },
            "BF71B9FC-32EF-29EF-9560-7219EBE600CD": {
                "item_id": "BF71B9FC-32EF-29EF-9560-7219EBE600CD",
                "item_name": "Custom Reaction Ability",
                "item_type": "reaction_ability",
                "variable_name": "custom_reaction_ability",
                "aps_ability": "r"
            }
        },
        "damage_type": {
            "F66879A9-5BDC-4996-8419-AF162CFCDC5F": {
                "item_id": "F66879A9-5BDC-4996-8419-AF162CFCDC5F",
                "item_name": "Acid",
                "variable_name": "acid",
                "hex_color_code": "#BAC475"
            },
            "0C528CF8-1B5A-453C-9BDE-73CBBC239A2A": {
                "item_id": "0C528CF8-1B5A-453C-9BDE-73CBBC239A2A",
                "item_name": "Bludgeoning",
                "variable_name": "bludgeoning",
                "hex_color_code": "#FF007F"
            },
            "8C455214-9F98-43C7-B9BC-1C74EE60805D": {
                "item_id": "8C455214-9F98-43C7-B9BC-1C74EE60805D",
                "item_name": "Cold",
                "variable_name": "cold",
                "hex_color_code": "#5D7984"
            },
            "A8469481-849E-4BBA-986E-7C418DCA06A1": {
                "item_id": "A8469481-849E-4BBA-986E-7C418DCA06A1",
                "item_name": "Fire",
                "variable_name": "fire",
                "hex_color_code": "#FF0000"
            },
            "25F9052F-B963-43CB-991E-EB315E08A549": {
                "item_id": "25F9052F-B963-43CB-991E-EB315E08A549",
                "item_name": "Force",
                "variable_name": "force",
                "hex_color_code": "#864745"
            },
            "944EC0D7-3320-42B1-B28D-68980DAA9719": {
                "item_id": "944EC0D7-3320-42B1-B28D-68980DAA9719",
                "item_name": "Lightning",
                "variable_name": "lightning",
                "hex_color_code": "#5A6998"
            },
            "D66B715F-E086-4C4B-A887-4BDB38AE32EB": {
                "item_id": "D66B715F-E086-4C4B-A887-4BDB38AE32EB",
                "item_name": "Necrotic",
                "variable_name": "necrotic",
                "hex_color_code": "#ADCEA1"
            },
            "C62E5227-0AB4-4C34-9058-DE97E36B0706": {
                "item_id": "C62E5227-0AB4-4C34-9058-DE97E36B0706",
                "item_name": "Piercing",
                "variable_name": "piercing",
                "hex_color_code": "#B2B2B2"
            },
            "4EBFF986-A4AA-4709-BE68-E97D29B66D18": {
                "item_id": "4EBFF986-A4AA-4709-BE68-E97D29B66D18",
                "item_name": "Poison",
                "variable_name": "poison",
                "hex_color_code": "#BDCA78"
            },
            "B61FDA44-4707-4539-B39B-54FA1FCBAA71": {
                "item_id": "B61FDA44-4707-4539-B39B-54FA1FCBAA71",
                "item_name": "Psychic",
                "variable_name": "psychic",
                "hex_color_code": "#CBB3C7"
            },
            "5850D66F-70E8-467D-9A5C-93464A5A12C4": {
                "item_id": "5850D66F-70E8-467D-9A5C-93464A5A12C4",
                "item_name": "Radiant",
                "variable_name": "radiant",
                "hex_color_code": "#FFFF00"
            },
            "422B9C6D-9558-47CD-AC21-1FB3B45EF33E": {
                "item_id": "422B9C6D-9558-47CD-AC21-1FB3B45EF33E",
                "item_name": "Slashing",
                "variable_name": "slashing",
                "hex_color_code": "#FF00FF"
            },
            "F79CF36E-F439-44C3-9668-050683A30F1C": {
                "item_id": "F79CF36E-F439-44C3-9668-050683A30F1C",
                "item_name": "Thunder",
                "variable_name": "thunder",
                "hex_color_code": "#746086"
            }
        },
        "environment_type": {
            "D0E5D185-0E49-FBE3-EFA9-E99CADDE7B0C": {
                "item_id": "D0E5D185-0E49-FBE3-EFA9-E99CADDE7B0C",
                "item_name": "Arctic",
                "variable_name": "arctic"
            },
            "F66F5044-B272-A3B0-0432-7E39B27A25B1": {
                "item_id": "F66F5044-B272-A3B0-0432-7E39B27A25B1",
                "item_name": "Coast",
                "variable_name": "coast"
            },
            "7EA716CF-ABCE-CD3C-0B9E-2310BB8C9DD8": {
                "item_id": "7EA716CF-ABCE-CD3C-0B9E-2310BB8C9DD8",
                "item_name": "Desert",
                "variable_name": "desert"
            },
            "1A7C5177-77E3-F1A5-0423-D09C137CA2A4": {
                "item_id": "1A7C5177-77E3-F1A5-0423-D09C137CA2A4",
                "item_name": "Forest",
                "variable_name": "forest"
            },
            "0F7BF513-E0CF-822A-C0ED-12F4ECC03F47": {
                "item_id": "0F7BF513-E0CF-822A-C0ED-12F4ECC03F47",
                "item_name": "Grassland",
                "variable_name": "grassland"
            },
            "E7E1210B-7197-DD1F-5324-5FAA39395450": {
                "item_id": "E7E1210B-7197-DD1F-5324-5FAA39395450",
                "item_name": "Hill",
                "variable_name": "hill"
            },
            "19817552-D32A-4B97-B404-745927E1B764": {
                "item_id": "19817552-D32A-4B97-B404-745927E1B764",
                "item_name": "Mountain",
                "variable_name": "mountain"
            },
            "FD2AC285-7609-49D5-B6BD-3287F920472F": {
                "item_id": "FD2AC285-7609-49D5-B6BD-3287F920472F",
                "item_name": "Swamp",
                "variable_name": "swamp"
            },
            "38FB8933-47F6-4A79-60CF-14E80BCF9BF5": {
                "item_id": "38FB8933-47F6-4A79-60CF-14E80BCF9BF5",
                "item_name": "Underground",
                "variable_name": "underground"
            },
            "19BCE18F-E1DC-D359-48A0-3B789741E058": {
                "item_id": "19BCE18F-E1DC-D359-48A0-3B789741E058",
                "item_name": "Underwater",
                "variable_name": "underwater"
            },
            "16333E5C-F1C9-163E-B688-05A05BE0B099": {
                "item_id": "16333E5C-F1C9-163E-B688-05A05BE0B099",
                "item_name": "Urban",
                "variable_name": "urban"
            },
            "D4CA3D58-2C59-4515-AF01-169E7890F0D3": {
                "item_id": "D4CA3D58-2C59-4515-AF01-169E7890F0D3",
                "item_name": "Planar",
                "variable_name": "planar"
            },
            "C8867600-ACD9-4088-A886-F6AB2BFA6FBB": {
                "item_id": "C8867600-ACD9-4088-A886-F6AB2BFA6FBB",
                "item_name": "Outer Space",
                "variable_name": "outer_space"
            }
        },
        "equipment_icon": {
            "85F756FF-CC55-B50E-A749-A13FAAA8982E": {
                "item_id": "85F756FF-CC55-B50E-A749-A13FAAA8982E",
                "item_name": "Cuirass Armors",
                "variable_name": "cuirass_armors"
            },
            "77D5AFC0-C991-B98A-2AD9-6922ED094BF7": {
                "item_id": "77D5AFC0-C991-B98A-2AD9-6922ED094BF7",
                "item_name": "Half Plate Armors",
                "variable_name": "half_plate_armors"
            },
            "6A43A001-E717-DE2A-E533-944C20F70C77": {
                "item_id": "6A43A001-E717-DE2A-E533-944C20F70C77",
                "item_name": "Plate Armors",
                "variable_name": "plate_armors"
            },
            "C65C0AB8-0129-04D8-5C9E-8BCDECCFC127": {
                "item_id": "C65C0AB8-0129-04D8-5C9E-8BCDECCFC127",
                "item_name": "Gambeson Armors",
                "variable_name": "gambeson_armors"
            },
            "75F431B7-2E3C-988E-29F1-A927118BE424": {
                "item_id": "75F431B7-2E3C-988E-29F1-A927118BE424",
                "item_name": "Leather Jerkin Armors",
                "variable_name": "leather_jerkin_armors"
            },
            "6BE03831-B72C-6FE3-7E4E-48EB6DC9B511": {
                "item_id": "6BE03831-B72C-6FE3-7E4E-48EB6DC9B511",
                "item_name": "Brigandine Armors",
                "variable_name": "brigandine_armors"
            },
            "EBC29BD4-10ED-12BD-5E78-854A8AD232E2": {
                "item_id": "EBC29BD4-10ED-12BD-5E78-854A8AD232E2",
                "item_name": "Hauberk Armors",
                "variable_name": "hauberk_armors"
            },
            "798563E1-EB82-4ECE-CB48-9E459B509F92": {
                "item_id": "798563E1-EB82-4ECE-CB48-9E459B509F92",
                "item_name": "Lamellar Armors",
                "variable_name": "lamellar_armors"
            },
            "5F2B5D56-CA98-B407-B99E-131460AA2F0C": {
                "item_id": "5F2B5D56-CA98-B407-B99E-131460AA2F0C",
                "item_name": "Mail Shirt Armors",
                "variable_name": "mail_shirt_armors"
            },
            "AF8EA876-DA09-2032-DF5C-3C950DBF7CB2": {
                "item_id": "AF8EA876-DA09-2032-DF5C-3C950DBF7CB2",
                "item_name": "Bucklers",
                "variable_name": "bucklers"
            },
            "F14311B1-5B45-9E9A-E12A-42C0E4915F41": {
                "item_id": "F14311B1-5B45-9E9A-E12A-42C0E4915F41",
                "item_name": "Bulwarks",
                "variable_name": "bulwarks"
            },
            "1CE8960D-FD6A-6E6F-C963-01C0CAC1AC71": {
                "item_id": "1CE8960D-FD6A-6E6F-C963-01C0CAC1AC71",
                "item_name": "Cavalry Shields",
                "variable_name": "cavalry_shields"
            },
            "ABAA9AC7-0274-E299-16A7-E5136837CF2E": {
                "item_id": "ABAA9AC7-0274-E299-16A7-E5136837CF2E",
                "item_name": "Heavy Shields",
                "variable_name": "heavy_shields"
            },
            "21DE8157-5C1E-33F2-7E52-B27A97C551B8": {
                "item_id": "21DE8157-5C1E-33F2-7E52-B27A97C551B8",
                "item_name": "Kite Shields",
                "variable_name": "kite_shields"
            },
            "D748B500-AEC7-8AA4-B103-3020410FB3DF": {
                "item_id": "D748B500-AEC7-8AA4-B103-3020410FB3DF",
                "item_name": "Light Shields",
                "variable_name": "light_shields"
            },
            "B7312FF1-9F2F-49BF-81E2-BC601D582541": {
                "item_id": "B7312FF1-9F2F-49BF-81E2-BC601D582541",
                "item_name": "Medium Shields",
                "variable_name": "medium_shields"
            },
            "B614B04E-2AB9-6FB2-56D4-84B8675B074E": {
                "item_id": "B614B04E-2AB9-6FB2-56D4-84B8675B074E",
                "item_name": "Tower Shields",
                "variable_name": "tower_shields"
            },
            "337317A4-1CEB-37C7-699F-1A0A02A31709": {
                "item_id": "337317A4-1CEB-37C7-699F-1A0A02A31709",
                "item_name": "Natural Armors",
                "variable_name": "natural_armors"
            },
            "AB7DEAAE-62BF-4996-A510-5F2B192F8F14": {
                "item_id": "AB7DEAAE-62BF-4996-A510-5F2B192F8F14",
                "item_name": "Natural Weapons",
                "variable_name": "natural_weapons"
            },
            "6284CE8F-C929-7161-EC43-923DE40F4968": {
                "item_id": "6284CE8F-C929-7161-EC43-923DE40F4968",
                "item_name": "Clubs",
                "variable_name": "clubs"
            },
            "48C941BC-2E9A-CAD8-1DA7-D90AE8DB1768": {
                "item_id": "48C941BC-2E9A-CAD8-1DA7-D90AE8DB1768",
                "item_name": "Sickles",
                "variable_name": "sickles"
            },
            "742A06CA-5870-FA3B-603A-AEE94F5102F5": {
                "item_id": "742A06CA-5870-FA3B-603A-AEE94F5102F5",
                "item_name": "Whips",
                "variable_name": "whips"
            },
            "50740150-28E8-FB76-88BD-216B02569D3F": {
                "item_id": "50740150-28E8-FB76-88BD-216B02569D3F",
                "item_name": "Daggers",
                "variable_name": "daggers"
            },
            "67EFA62C-3A5C-9FEE-D54D-EF7615C063F4": {
                "item_id": "67EFA62C-3A5C-9FEE-D54D-EF7615C063F4",
                "item_name": "Light Hammers",
                "variable_name": "hammers_light"
            },
            "57B8F98F-460E-7D39-C495-D2E26439391C": {
                "item_id": "57B8F98F-460E-7D39-C495-D2E26439391C",
                "item_name": "Shortswords",
                "variable_name": "shortswords"
            },
            "AFFA2CC1-0468-ABBC-2FA3-40597B8B374D": {
                "item_id": "AFFA2CC1-0468-ABBC-2FA3-40597B8B374D",
                "item_name": "Scimitars",
                "variable_name": "scimitars"
            },
            "5E58B1EB-B2AD-5F54-B4DD-D8DDA5E8BCE3": {
                "item_id": "5E58B1EB-B2AD-5F54-B4DD-D8DDA5E8BCE3",
                "item_name": "Maces",
                "variable_name": "maces"
            },
            "859394A9-EE4A-BD9A-C5A9-7FCD150E7344": {
                "item_id": "859394A9-EE4A-BD9A-C5A9-7FCD150E7344",
                "item_name": "Handaxes",
                "variable_name": "handaxes"
            },
            "2FB5E21A-7A0A-E4B8-604D-3A0A60A34172": {
                "item_id": "2FB5E21A-7A0A-E4B8-604D-3A0A60A34172",
                "item_name": "Javelins",
                "variable_name": "javelins"
            },
            "12D25118-B86A-80A5-01BC-C9427BD83D17": {
                "item_id": "12D25118-B86A-80A5-01BC-C9427BD83D17",
                "item_name": "Quarterstaffs",
                "variable_name": "quarterstaffs"
            },
            "7D08EF0E-0D7D-8CB0-70FA-0C741AF438E5": {
                "item_id": "7D08EF0E-0D7D-8CB0-70FA-0C741AF438E5",
                "item_name": "Spears",
                "variable_name": "spears"
            },
            "CF8B21A5-32CE-7E43-22E3-ABC56C457628": {
                "item_id": "CF8B21A5-32CE-7E43-22E3-ABC56C457628",
                "item_name": "Tridents",
                "variable_name": "tridents"
            },
            "2F238366-80B8-2BCF-EC81-387CE1A5D4DF": {
                "item_id": "2F238366-80B8-2BCF-EC81-387CE1A5D4DF",
                "item_name": "Rapiers",
                "variable_name": "rapiers"
            },
            "622AEA0A-D1A6-FB1C-83B4-FC67807D9197": {
                "item_id": "622AEA0A-D1A6-FB1C-83B4-FC67807D9197",
                "item_name": "War Picks",
                "variable_name": "war_picks"
            },
            "AD9D5036-D2CF-1C6A-9785-CCB5D35B96B5": {
                "item_id": "AD9D5036-D2CF-1C6A-9785-CCB5D35B96B5",
                "item_name": "Morningstars",
                "variable_name": "morningstars"
            },
            "D5906717-7237-CA1D-B089-18CF323A04DB": {
                "item_id": "D5906717-7237-CA1D-B089-18CF323A04DB",
                "item_name": "Flails",
                "variable_name": "flails"
            },
            "B5ECBC44-BAB8-E6B2-0D1C-CC2A5082BDD2": {
                "item_id": "B5ECBC44-BAB8-E6B2-0D1C-CC2A5082BDD2",
                "item_name": "Greatclubs",
                "variable_name": "greatclubs"
            },
            "E48B1524-C478-E245-AF07-2A1A145EE4D5": {
                "item_id": "E48B1524-C478-E245-AF07-2A1A145EE4D5",
                "item_name": "Longswords",
                "variable_name": "longswords"
            },
            "1B08D135-FE7B-4180-6F38-A1FEEF733355": {
                "item_id": "1B08D135-FE7B-4180-6F38-A1FEEF733355",
                "item_name": "Battleaxes",
                "variable_name": "battleaxes"
            },
            "3AC99772-BF88-6507-8360-EE3EAFC7540F": {
                "item_id": "3AC99772-BF88-6507-8360-EE3EAFC7540F",
                "item_name": "Warhammers",
                "variable_name": "warhammers"
            },
            "864FC3D6-0B39-7F59-0274-09B98850A41F": {
                "item_id": "864FC3D6-0B39-7F59-0274-09B98850A41F",
                "item_name": "Glaives",
                "variable_name": "glaives"
            },
            "5B8E8F69-AB95-617A-5E82-8F9C4D2C2485": {
                "item_id": "5B8E8F69-AB95-617A-5E82-8F9C4D2C2485",
                "item_name": "Halberds",
                "variable_name": "halberds"
            },
            "E4FB85CE-C211-BE13-B674-A2A591384C11": {
                "item_id": "E4FB85CE-C211-BE13-B674-A2A591384C11",
                "item_name": "Pikes",
                "variable_name": "pikes"
            },
            "7FA88F1A-084A-4A05-1B5D-27B56EDDED6F": {
                "item_id": "7FA88F1A-084A-4A05-1B5D-27B56EDDED6F",
                "item_name": "Greataxes",
                "variable_name": "greataxes"
            },
            "545EB766-1371-C2E2-2664-0C191EAC9C3F": {
                "item_id": "545EB766-1371-C2E2-2664-0C191EAC9C3F",
                "item_name": "Lances",
                "variable_name": "lances"
            },
            "26BF8308-1F2B-656E-FF25-9EB2D1E0EEE0": {
                "item_id": "26BF8308-1F2B-656E-FF25-9EB2D1E0EEE0",
                "item_name": "Double Bladed Scimitars",
                "variable_name": "double_bladed_scimitars"
            },
            "FB124CCD-B381-452B-CAA1-B598E90A8534": {
                "item_id": "FB124CCD-B381-452B-CAA1-B598E90A8534",
                "item_name": "Greatswords",
                "variable_name": "greatswords"
            },
            "44A52695-9CD1-804C-9ABA-178B70704D59": {
                "item_id": "44A52695-9CD1-804C-9ABA-178B70704D59",
                "item_name": "Mauls",
                "variable_name": "mauls"
            },
            "8C25C0CD-AF02-6648-A158-87F4DEBB8651": {
                "item_id": "8C25C0CD-AF02-6648-A158-87F4DEBB8651",
                "item_name": "Light Crossbows",
                "variable_name": "crossbows_light"
            },
            "488EE738-F198-9F9E-4F9F-FE26B06BA64F": {
                "item_id": "488EE738-F198-9F9E-4F9F-FE26B06BA64F",
                "item_name": "Nets",
                "variable_name": "nets"
            },
            "D80255AC-6D02-0158-0796-76D110DE7778": {
                "item_id": "D80255AC-6D02-0158-0796-76D110DE7778",
                "item_name": "Blowguns",
                "variable_name": "blowguns"
            },
            "9F33304D-BEB8-86B5-3928-A4D98293DF97": {
                "item_id": "9F33304D-BEB8-86B5-3928-A4D98293DF97",
                "item_name": "Darts",
                "variable_name": "darts"
            },
            "D7BB53E2-0544-9AC9-7DD3-4FA47A12C80C": {
                "item_id": "D7BB53E2-0544-9AC9-7DD3-4FA47A12C80C",
                "item_name": "Slings",
                "variable_name": "slings"
            },
            "6C92300B-B840-9E37-BF4D-46A166407E7B": {
                "item_id": "6C92300B-B840-9E37-BF4D-46A166407E7B",
                "item_name": "Shortbows",
                "variable_name": "shortbows"
            },
            "E6CCEF87-419A-57CF-DC12-73324DB86CD1": {
                "item_id": "E6CCEF87-419A-57CF-DC12-73324DB86CD1",
                "item_name": "Hand Crossbows",
                "variable_name": "crossbows_hand"
            },
            "207C31FE-ABEE-96F1-2EA6-B98635F7D730": {
                "item_id": "207C31FE-ABEE-96F1-2EA6-B98635F7D730",
                "item_name": "Longbows",
                "variable_name": "longbows"
            },
            "7257525A-37A8-9DCE-1656-C7449FF2C305": {
                "item_id": "7257525A-37A8-9DCE-1656-C7449FF2C305",
                "item_name": "Heavy Crossbows",
                "variable_name": "crossbows_heavy"
            },
            "FCED5C37-344C-1B6A-7598-E682452C1AA9": {
                "item_id": "FCED5C37-344C-1B6A-7598-E682452C1AA9",
                "item_name": "Palm Pistols",
                "variable_name": "palm_pistols"
            },
            "60509B0C-A1BB-B005-C834-98E5ACE40BAB": {
                "item_id": "60509B0C-A1BB-B005-C834-98E5ACE40BAB",
                "item_name": "Pistols",
                "variable_name": "pistols"
            },
            "BCC74411-8516-A30B-B79A-1DBED89C61A6": {
                "item_id": "BCC74411-8516-A30B-B79A-1DBED89C61A6",
                "item_name": "Pepperboxes",
                "variable_name": "pepperboxes"
            },
            "3BBEE883-286A-4A08-3CCB-52F283348345": {
                "item_id": "3BBEE883-286A-4A08-3CCB-52F283348345",
                "item_name": "Muskets",
                "variable_name": "muskets"
            },
            "7F3F7FC7-0CCF-E01A-22BA-E0AA0A97686D": {
                "item_id": "7F3F7FC7-0CCF-E01A-22BA-E0AA0A97686D",
                "item_name": "Blunderbusses",
                "variable_name": "blunderbusses"
            },
            "5310DE5D-1453-5468-EBBA-B1132AB19394": {
                "item_id": "5310DE5D-1453-5468-EBBA-B1132AB19394",
                "item_name": "Hand Mortars",
                "variable_name": "hand_mortars"
            },
            "E54B8A46-A63F-AB3A-BAA9-C27826B0AF5F": {
                "item_id": "E54B8A46-A63F-AB3A-BAA9-C27826B0AF5F",
                "item_name": "Bad News",
                "variable_name": "bad_newses"
            },
            "2D837940-0143-4636-9871-406BF89DCB1D": {
                "item_id": "2D837940-0143-4636-9871-406BF89DCB1D",
                "item_name": "Gunlances",
                "variable_name": "gunlances"
            },
            "5C17EFAF-2F94-E2E4-02A2-791F241BD52B": {
                "item_id": "5C17EFAF-2F94-E2E4-02A2-791F241BD52B",
                "item_name": "Bladed Fans",
                "variable_name": "bladed_fans"
            },
            "81AF4123-10E6-8656-F9CA-DCE1AC3DC7E3": {
                "item_id": "81AF4123-10E6-8656-F9CA-DCE1AC3DC7E3",
                "item_name": "Rope Darts",
                "variable_name": "rope_darts"
            },
            "F187EE82-1D32-4C53-9F69-E59DDF33D7C7": {
                "item_id": "F187EE82-1D32-4C53-9F69-E59DDF33D7C7",
                "item_name": "Fist Weapons",
                "variable_name": "fist_weapons"
            },
            "40DDC931-6479-B773-293E-CE570E99B975": {
                "item_id": "40DDC931-6479-B773-293E-CE570E99B975",
                "item_name": "Bladed Umbrellas",
                "variable_name": "bladed_umbrellas"
            },
            "DE15C4F8-2710-8187-3788-2DA46D8724B8": {
                "item_id": "DE15C4F8-2710-8187-3788-2DA46D8724B8",
                "item_name": "Scythes",
                "variable_name": "scythes"
            },
            "B12431F6-BB7A-8079-002F-111914B9E65A": {
                "item_id": "B12431F6-BB7A-8079-002F-111914B9E65A",
                "item_name": "Colossal Melee Weapons",
                "variable_name": "colossal_melee_weapons"
            },
            "B66B3311-4A62-5531-D446-CE4A565FD181": {
                "item_id": "B66B3311-4A62-5531-D446-CE4A565FD181",
                "item_name": "Colossal Ranged Weapons",
                "variable_name": "colossal_ranged_weapons"
            }
        },
        "equipment_slot": {
            "F2D8C4B3-FA31-291C-995A-2046F84A289F": {
                "item_id": "F2D8C4B3-FA31-291C-995A-2046F84A289F",
                "item_name": "Air Around",
                "variable_name": "air_around",
                "slot_limit": 1
            },
            "0B279A55-5102-D704-8A57-0C1FF4989DFA": {
                "item_id": "0B279A55-5102-D704-8A57-0C1FF4989DFA",
                "item_name": "Armor",
                "variable_name": "armor",
                "slot_limit": 1
            },
            "F19F7A27-C0EE-DCFF-BD8F-2FA3CC03F7BB": {
                "item_id": "F19F7A27-C0EE-DCFF-BD8F-2FA3CC03F7BB",
                "item_name": "Back",
                "variable_name": "back",
                "slot_limit": 1
            },
            "E6D02ACB-D3E9-DD8B-762A-31FE8C8D898D": {
                "item_id": "E6D02ACB-D3E9-DD8B-762A-31FE8C8D898D",
                "item_name": "Both Hands",
                "variable_name": "both_hands",
                "slot_limit": 1
            },
            "BD255B29-389B-53DC-6116-072B1A8DDD5F": {
                "item_id": "BD255B29-389B-53DC-6116-072B1A8DDD5F",
                "item_name": "Bracers",
                "variable_name": "bracers",
                "slot_limit": 1
            },
            "C48555B1-E374-9AAD-8CA0-C55D07AD6776": {
                "item_id": "C48555B1-E374-9AAD-8CA0-C55D07AD6776",
                "item_name": "Breast",
                "variable_name": "breast",
                "slot_limit": 1
            },
            "6203F9AE-6699-AB57-B3C7-92864A79520C": {
                "item_id": "6203F9AE-6699-AB57-B3C7-92864A79520C",
                "item_name": "Cloak",
                "variable_name": "cloak",
                "slot_limit": 1
            },
            "3CAA3182-3DA6-F348-CEE3-09803F221466": {
                "item_id": "3CAA3182-3DA6-F348-CEE3-09803F221466",
                "item_name": "Clothing",
                "variable_name": "clothing",
                "slot_limit": 1
            },
            "94805078-0B0F-FD3F-77E4-AA6EE4D2E44D": {
                "item_id": "94805078-0B0F-FD3F-77E4-AA6EE4D2E44D",
                "item_name": "Feet",
                "variable_name": "feet",
                "slot_limit": 1
            },
            "3805BDD7-3461-DDDB-F445-922A5A992987": {
                "item_id": "3805BDD7-3461-DDDB-F445-922A5A992987",
                "item_name": "Head",
                "variable_name": "head",
                "slot_limit": 1
            },
            "AF43D701-0755-C7E2-D26F-44E6F64AC3E2": {
                "item_id": "AF43D701-0755-C7E2-D26F-44E6F64AC3E2",
                "item_name": "Legs",
                "variable_name": "legs",
                "slot_limit": 1
            },
            "CEF334BF-DE96-1BEA-F72A-A4C98FBF36AD": {
                "item_id": "CEF334BF-DE96-1BEA-F72A-A4C98FBF36AD",
                "item_name": "Main Hand",
                "variable_name": "main_hand",
                "slot_limit": 1
            },
            "3CA73C13-5DC3-0DDF-CAD8-98D1CF573844": {
                "item_id": "3CA73C13-5DC3-0DDF-CAD8-98D1CF573844",
                "item_name": "Natural Armor",
                "variable_name": "natural_armor",
                "slot_limit": 1
            },
            "5EDE9876-ED2B-3B93-C683-34428B5FDA5B": {
                "item_id": "5EDE9876-ED2B-3B93-C683-34428B5FDA5B",
                "item_name": "Neck",
                "variable_name": "neck",
                "slot_limit": 1
            },
            "4FF85144-67EC-9D87-AE28-15137A1A2481": {
                "item_id": "4FF85144-67EC-9D87-AE28-15137A1A2481",
                "item_name": "Off Hand",
                "variable_name": "off_hand",
                "slot_limit": 1
            },
            "3AD8CEE8-D487-68B1-33F0-CFE04336F9B8": {
                "item_id": "3AD8CEE8-D487-68B1-33F0-CFE04336F9B8",
                "item_name": "Ring",
                "variable_name": "ring",
                "slot_limit": 2
            },
            "16ABAE95-5D18-474D-ADFF-8C20FC2439F1": {
                "item_id": "16ABAE95-5D18-474D-ADFF-8C20FC2439F1",
                "item_name": "Tail",
                "variable_name": "tail",
                "slot_limit": 1
            },
            "B52059C5-526B-3F8C-E906-0D40FA23A593": {
                "item_id": "B52059C5-526B-3F8C-E906-0D40FA23A593",
                "item_name": "Waist",
                "variable_name": "waist",
                "slot_limit": 3
            }
        },
        "equipment_visual_mount": {
            "0BACFBA4-0921-41CB-B586-2B68D5BF391B": {
                "item_id": "0BACFBA4-0921-41CB-B586-2B68D5BF391B",
                "item_name": "Visual Mount \u2014 Worn",
                "variable_name": "worn",
                "icon_variable_name": "mount_worn",
                "mount_limit": 99
            },
            "34D0A902-F9A4-406A-A29E-61E55BE0F338": {
                "item_id": "34D0A902-F9A4-406A-A29E-61E55BE0F338",
                "item_name": "Visual Mount \u2014 Worn: Head",
                "variable_name": "worn_head",
                "icon_variable_name": "mount_worn_head",
                "mount_limit": 1
            },
            "11E3CC41-2645-4423-8841-8F4B531C4920": {
                "item_id": "11E3CC41-2645-4423-8841-8F4B531C4920",
                "item_name": "Visual Mount \u2014 Worn: Torso",
                "variable_name": "worn_torso",
                "icon_variable_name": "mount_worn_torso",
                "mount_limit": 1
            },
            "E3DFF047-0ACE-4C14-A204-3B32572EF1DE": {
                "item_id": "E3DFF047-0ACE-4C14-A204-3B32572EF1DE",
                "item_name": "Visual Mount \u2014 Worn: Hands",
                "variable_name": "worn_hands",
                "icon_variable_name": "mount_worn_hands",
                "mount_limit": 1
            },
            "CC4E28C3-8FD5-49D5-A537-6AAEE88756F7": {
                "item_id": "CC4E28C3-8FD5-49D5-A537-6AAEE88756F7",
                "item_name": "Visual Mount \u2014 Worn: Legs",
                "variable_name": "worn_legs",
                "icon_variable_name": "mount_worn_legs",
                "mount_limit": 1
            },
            "5E0B1C69-8936-4621-A2AE-9648E13384CB": {
                "item_id": "5E0B1C69-8936-4621-A2AE-9648E13384CB",
                "item_name": "Visual Mount \u2014 Worn: Feet",
                "variable_name": "worn_feet",
                "icon_variable_name": "mount_worn_feet",
                "mount_limit": 1
            },
            "BC829CD7-69F4-4A90-89AC-9DE78C740FE5": {
                "item_id": "BC829CD7-69F4-4A90-89AC-9DE78C740FE5",
                "item_name": "Visual Mount \u2014 Worn: Cloak",
                "variable_name": "worn_cloak",
                "icon_variable_name": "mount_worn_cloak",
                "mount_limit": 1
            },
            "633EA7B5-E49A-4DD5-9834-DEE5BCDF8AB7": {
                "item_id": "633EA7B5-E49A-4DD5-9834-DEE5BCDF8AB7",
                "item_name": "Visual Mount \u2014 Worn: Neck",
                "variable_name": "worn_neck",
                "icon_variable_name": "mount_worn_neck",
                "mount_limit": 1
            },
            "6BE8B58B-B97B-45B8-A34C-891EAAEB387D": {
                "item_id": "6BE8B58B-B97B-45B8-A34C-891EAAEB387D",
                "item_name": "Visual Mount \u2014 Back Primary",
                "variable_name": "back_primary",
                "icon_variable_name": "mount_back_primary",
                "mount_limit": 1
            },
            "2035E00A-331D-4B24-8C5E-E768E6753456": {
                "item_id": "2035E00A-331D-4B24-8C5E-E768E6753456",
                "item_name": "Visual Mount \u2014 Back Shield",
                "variable_name": "back_shield",
                "icon_variable_name": "mount_back_shield",
                "mount_limit": 1
            },
            "F99AF61A-D832-47CD-8464-E9AE0E1881BD": {
                "item_id": "F99AF61A-D832-47CD-8464-E9AE0E1881BD",
                "item_name": "Visual Mount \u2014 Back Bow",
                "variable_name": "back_bow",
                "icon_variable_name": "mount_back_bow",
                "mount_limit": 1
            },
            "F1A71448-07EF-462D-BF26-D3DB88F7E489": {
                "item_id": "F1A71448-07EF-462D-BF26-D3DB88F7E489",
                "item_name": "Visual Mount \u2014 Back Quiver",
                "variable_name": "back_quiver",
                "icon_variable_name": "mount_back_quiver",
                "mount_limit": 1
            },
            "EDBF0393-95BC-452B-9E23-7ACE3BA34840": {
                "item_id": "EDBF0393-95BC-452B-9E23-7ACE3BA34840",
                "item_name": "Visual Mount \u2014 Back Pack",
                "variable_name": "back_pack",
                "icon_variable_name": "mount_back_pack",
                "mount_limit": 1
            },
            "493D1395-4A04-4F3C-8398-2DBF56960FF8": {
                "item_id": "493D1395-4A04-4F3C-8398-2DBF56960FF8",
                "item_name": "Visual Mount \u2014 Left Hip",
                "variable_name": "hip_left",
                "icon_variable_name": "mount_hip_left",
                "mount_limit": 1
            },
            "3C23B69F-1A55-4665-B708-8F07398611AF": {
                "item_id": "3C23B69F-1A55-4665-B708-8F07398611AF",
                "item_name": "Visual Mount \u2014 Right Hip",
                "variable_name": "hip_right",
                "icon_variable_name": "mount_hip_right",
                "mount_limit": 1
            },
            "AE73EEDF-AC07-4330-B957-B10CFE4CD2E0": {
                "item_id": "AE73EEDF-AC07-4330-B957-B10CFE4CD2E0",
                "item_name": "Visual Mount \u2014 Either Hip",
                "variable_name": "hip_auto",
                "icon_variable_name": "mount_hip_auto",
                "mount_limit": 4
            },
            "5DAAF4FA-800F-491D-A79D-D8610EA58023": {
                "item_id": "5DAAF4FA-800F-491D-A79D-D8610EA58023",
                "item_name": "Visual Mount \u2014 Left Thigh",
                "variable_name": "thigh_left",
                "icon_variable_name": "mount_thigh_left",
                "mount_limit": 1
            },
            "A56D1DBB-C93E-4D84-83CF-BEE1701FD058": {
                "item_id": "A56D1DBB-C93E-4D84-83CF-BEE1701FD058",
                "item_name": "Visual Mount \u2014 Right Thigh",
                "variable_name": "thigh_right",
                "icon_variable_name": "mount_thigh_right",
                "mount_limit": 1
            },
            "ADD9FA87-2436-482D-8FDC-B5FB7AD9A3A5": {
                "item_id": "ADD9FA87-2436-482D-8FDC-B5FB7AD9A3A5",
                "item_name": "Visual Mount \u2014 Waist Belt",
                "variable_name": "waist",
                "icon_variable_name": "mount_waist",
                "mount_limit": 3
            },
            "9EC53644-1E56-43AC-B43C-C922FF6DD725": {
                "item_id": "9EC53644-1E56-43AC-B43C-C922FF6DD725",
                "item_name": "Visual Mount \u2014 Held Main Hand",
                "variable_name": "held_main",
                "icon_variable_name": "mount_held_main",
                "mount_limit": 1
            },
            "0066C87E-FCD4-4FF6-BE4B-A6D22F234565": {
                "item_id": "0066C87E-FCD4-4FF6-BE4B-A6D22F234565",
                "item_name": "Visual Mount \u2014 Held Off Hand",
                "variable_name": "held_off",
                "icon_variable_name": "mount_held_off",
                "mount_limit": 1
            },
            "69E469E1-0DF4-4F9B-9B41-D7BB5CB70A33": {
                "item_id": "69E469E1-0DF4-4F9B-9B41-D7BB5CB70A33",
                "item_name": "Visual Mount \u2014 Hidden",
                "variable_name": "hidden",
                "icon_variable_name": "mount_hidden",
                "mount_limit": 99
            }
        },
        "essence": {
            "22918408-67CC-4093-80E8-BF6FA8915C21": {
                "item_id": "22918408-67CC-4093-80E8-BF6FA8915C21",
                "item_name": "Body",
                "item_type": "essence",
                "variable_name": "body"
            },
            "63ABC96E-3804-4E1F-B38D-AABA3237B2D8": {
                "item_id": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8",
                "item_name": "Mind",
                "item_type": "essence",
                "variable_name": "mind"
            },
            "72F93730-134F-4CA2-8FC4-F2915F20CAC6": {
                "item_id": "72F93730-134F-4CA2-8FC4-F2915F20CAC6",
                "item_name": "Soul",
                "item_type": "essence",
                "variable_name": "soul"
            },
            "86792A8B-2070-4144-9C81-0D85706131DF": {
                "item_id": "86792A8B-2070-4144-9C81-0D85706131DF",
                "item_name": "Spirit",
                "item_type": "essence",
                "variable_name": "spirit"
            },
            "E769E451-65EE-3628-1A78-D12C9A3FF02B": {
                "item_id": "E769E451-65EE-3628-1A78-D12C9A3FF02B",
                "item_name": "Fortune",
                "item_type": "essence",
                "variable_name": "fortune"
            },
            "7B7E8F97-6843-57CF-422C-5930CFA98B06": {
                "item_id": "7B7E8F97-6843-57CF-422C-5930CFA98B06",
                "item_name": "Luck",
                "item_type": "essence",
                "variable_name": "luck"
            }
        },
        "gemstone_size": {
            "583B7BBA-A802-4830-931B-5417A8B25C0C": {
                "item_id": "583B7BBA-A802-4830-931B-5417A8B25C0C",
                "item_name": "Very Tiny",
                "variable_name": "very_tiny",
                "cost_gp_multiplier": 0.1,
                "weight_multiplier": 0.1,
                "weight": 12
            },
            "A288CEEA-0824-46AE-A5E9-2C45696B5569": {
                "item_id": "A288CEEA-0824-46AE-A5E9-2C45696B5569",
                "item_name": "Tiny",
                "variable_name": "tiny",
                "cost_gp_multiplier": 1,
                "weight_multiplier": 1,
                "weight": 40,
                "is_base": true
            },
            "C8777AD8-E02C-2769-FBF4-D3619BD0115F": {
                "item_id": "C8777AD8-E02C-2769-FBF4-D3619BD0115F",
                "item_name": "Small",
                "variable_name": "small",
                "cost_gp_multiplier": 3,
                "weight_multiplier": 3,
                "weight": 27
            },
            "3965A960-7C23-1C16-0C02-3CC45D6BCDBA": {
                "item_id": "3965A960-7C23-1C16-0C02-3CC45D6BCDBA",
                "item_name": "Medium",
                "variable_name": "medium",
                "cost_gp_multiplier": 8,
                "weight_multiplier": 8,
                "weight": 14
            },
            "94A30796-D243-60B2-5EA4-FC4E46684C90": {
                "item_id": "94A30796-D243-60B2-5EA4-FC4E46684C90",
                "item_name": "Large",
                "variable_name": "large",
                "cost_gp_multiplier": 20,
                "weight_multiplier": 20,
                "weight": 5
            },
            "D772138F-9019-AE08-4F3C-5DAAD6A35964": {
                "item_id": "D772138F-9019-AE08-4F3C-5DAAD6A35964",
                "item_name": "Very Large",
                "variable_name": "very_large",
                "cost_gp_multiplier": 50,
                "weight_multiplier": 50,
                "weight": 1.5
            },
            "A0E0814C-F954-9BD0-0053-8B5827491CEF": {
                "item_id": "A0E0814C-F954-9BD0-0053-8B5827491CEF",
                "item_name": "Huge",
                "variable_name": "huge",
                "cost_gp_multiplier": 120,
                "weight_multiplier": 120,
                "weight": 0.5
            },
            "FAC3A084-D93E-6918-9858-AEDEF3B11C89": {
                "item_id": "FAC3A084-D93E-6918-9858-AEDEF3B11C89",
                "item_name": "Colossal",
                "variable_name": "colossal",
                "cost_gp_multiplier": 300,
                "weight_multiplier": 300,
                "weight": 0
            }
        },
        "item_composition": {
            "BC99B1AB-2B2A-D2B8-5CED-B59DE8B285D1": {
                "item_id": "BC99B1AB-2B2A-D2B8-5CED-B59DE8B285D1",
                "item_name": "Adamantine",
                "item_type": "item_composition",
                "variable_name": "adamantine",
                "density_lb_ft3": 620,
                "cost_gp_ft3": 62000,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Adamantine composition."
            },
            "9D7016EF-6414-6BFC-7E70-9D5C49B242ED": {
                "item_id": "9D7016EF-6414-6BFC-7E70-9D5C49B242ED",
                "item_name": "Bone",
                "item_type": "item_composition",
                "variable_name": "bone",
                "density_lb_ft3": 112,
                "cost_gp_ft3": 11,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Bone composition."
            },
            "C81AF954-3771-F865-5F40-F5EEF3650011": {
                "item_id": "C81AF954-3771-F865-5F40-F5EEF3650011",
                "item_name": "Brass",
                "item_type": "item_composition",
                "variable_name": "brass",
                "density_lb_ft3": 530,
                "cost_gp_ft3": 40,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Brass composition."
            },
            "51FC55E0-49B1-09DD-FF18-216F752292AE": {
                "item_id": "51FC55E0-49B1-09DD-FF18-216F752292AE",
                "item_name": "Bronze",
                "item_type": "item_composition",
                "variable_name": "bronze",
                "density_lb_ft3": 550,
                "cost_gp_ft3": 40,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Bronze composition."
            },
            "918CE8D2-A017-E894-960D-FBF058E56F40": {
                "item_id": "918CE8D2-A017-E894-960D-FBF058E56F40",
                "item_name": "Cloth",
                "item_type": "item_composition",
                "variable_name": "cloth",
                "density_lb_ft3": 25,
                "cost_gp_ft3": 12,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Cloth composition.",
                "fragile_container_splash": true
            },
            "D1CB5DE2-99EE-1D31-0F67-9541BCDA3702": {
                "item_id": "D1CB5DE2-99EE-1D31-0F67-9541BCDA3702",
                "item_name": "Copper",
                "item_type": "item_composition",
                "variable_name": "copper",
                "density_lb_ft3": 559,
                "cost_gp_ft3": 56,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Copper composition."
            },
            "0EC0D80A-FD30-B083-8BD0-551CE52BD3E3": {
                "item_id": "0EC0D80A-FD30-B083-8BD0-551CE52BD3E3",
                "item_name": "Energy",
                "item_type": "item_composition",
                "variable_name": "energy",
                "density_lb_ft3": 0,
                "cost_gp_ft3": 0,
                "destroy_fate": "vanishes",
                "destroy_fate_detail": "No rubble; destroyed inventory removed."
            },
            "DE1072CB-5569-1510-2A91-37DF74F8DE27": {
                "item_id": "DE1072CB-5569-1510-2A91-37DF74F8DE27",
                "item_name": "Fiber",
                "item_type": "item_composition",
                "variable_name": "fiber",
                "density_lb_ft3": 20,
                "cost_gp_ft3": 4,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Fiber composition.",
                "fragile_container_splash": true
            },
            "F4175703-A404-247E-1049-22D61D8B2C72": {
                "item_id": "F4175703-A404-247E-1049-22D61D8B2C72",
                "item_name": "Flesh",
                "item_type": "item_composition",
                "variable_name": "flesh",
                "density_lb_ft3": 64,
                "cost_gp_ft3": 1,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Flesh composition."
            },
            "5BD53A88-7101-4176-3EE8-1BCA6F284C6E": {
                "item_id": "5BD53A88-7101-4176-3EE8-1BCA6F284C6E",
                "item_name": "Food",
                "item_type": "item_composition",
                "variable_name": "food",
                "density_lb_ft3": 55,
                "cost_gp_ft3": 5,
                "destroy_fate": "vanishes",
                "destroy_fate_detail": "No rubble; destroyed inventory removed.",
                "fragile_container_splash": true
            },
            "5AA759C7-EF04-7AA9-8955-0E50FEC7F543": {
                "item_id": "5AA759C7-EF04-7AA9-8955-0E50FEC7F543",
                "item_name": "Fur",
                "item_type": "item_composition",
                "variable_name": "fur",
                "density_lb_ft3": 18,
                "cost_gp_ft3": 90,
                "destroy_fate": "vanishes",
                "destroy_fate_detail": "No rubble; destroyed inventory removed."
            },
            "39D38A22-D343-AFCE-198E-0FEA6907C7BA": {
                "item_id": "39D38A22-D343-AFCE-198E-0FEA6907C7BA",
                "item_name": "Gas",
                "item_type": "item_composition",
                "variable_name": "gas",
                "density_lb_ft3": 0.08,
                "cost_gp_ft3": 0,
                "destroy_fate": "vanishes",
                "destroy_fate_detail": "No rubble; destroyed inventory removed."
            },
            "2048ACB7-43DD-C3FA-2792-FD32B985250B": {
                "item_id": "2048ACB7-43DD-C3FA-2792-FD32B985250B",
                "item_name": "Glass",
                "item_type": "item_composition",
                "variable_name": "glass",
                "density_lb_ft3": 156,
                "cost_gp_ft3": 78,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Glass composition.",
                "fragile_container_splash": true
            },
            "43A405AD-C6FB-B7C5-99B8-1D0720BEF481": {
                "item_id": "43A405AD-C6FB-B7C5-99B8-1D0720BEF481",
                "item_name": "Gold",
                "item_type": "item_composition",
                "variable_name": "gold",
                "density_lb_ft3": 1206,
                "cost_gp_ft3": 60300,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Gold composition."
            },
            "9DEF31B5-8E21-2372-FE2A-95DB8DF43BFE": {
                "item_id": "9DEF31B5-8E21-2372-FE2A-95DB8DF43BFE",
                "item_name": "Ice",
                "item_type": "item_composition",
                "variable_name": "ice",
                "density_lb_ft3": 57,
                "cost_gp_ft3": 0,
                "destroy_fate": "vanishes",
                "destroy_fate_detail": "Broken ice leaves no permanent rubble inventory; spell anchors own any residue."
            },
            "88389035-9618-33E7-8913-2D21DFA80313": {
                "item_id": "88389035-9618-33E7-8913-2D21DFA80313",
                "item_name": "Iron",
                "item_type": "item_composition",
                "variable_name": "iron",
                "density_lb_ft3": 491,
                "cost_gp_ft3": 10,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Iron composition."
            },
            "7231D794-2C8F-604D-D5D9-FE0DCA0AC4ED": {
                "item_id": "7231D794-2C8F-604D-D5D9-FE0DCA0AC4ED",
                "item_name": "Ironwood",
                "item_type": "item_composition",
                "variable_name": "ironwood",
                "density_lb_ft3": 75,
                "cost_gp_ft3": 750,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Ironwood composition."
            },
            "563615C1-273C-476B-9C9A-6672FD33FD5F": {
                "item_id": "563615C1-273C-476B-9C9A-6672FD33FD5F",
                "item_name": "Lead",
                "item_type": "item_composition",
                "variable_name": "lead",
                "density_lb_ft3": 708,
                "cost_gp_ft3": 7,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Lead composition."
            },
            "8A6D00FB-E8F4-3DDE-AFC9-EB7EE0F108D0": {
                "item_id": "8A6D00FB-E8F4-3DDE-AFC9-EB7EE0F108D0",
                "item_name": "Leather",
                "item_type": "item_composition",
                "variable_name": "leather",
                "density_lb_ft3": 56,
                "cost_gp_ft3": 56,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Leather composition."
            },
            "D8CB02A5-E748-07DB-E9B7-FE1DD0327DB5": {
                "item_id": "D8CB02A5-E748-07DB-E9B7-FE1DD0327DB5",
                "item_name": "Liquid",
                "item_type": "item_composition",
                "variable_name": "liquid",
                "density_lb_ft3": 62.4,
                "cost_gp_ft3": 6,
                "destroy_fate": "vanishes",
                "destroy_fate_detail": "No rubble; destroyed inventory removed."
            },
            "BFE82356-9958-D674-735F-51A3F2F48AAB": {
                "item_id": "BFE82356-9958-D674-735F-51A3F2F48AAB",
                "item_name": "Living",
                "item_type": "item_composition",
                "variable_name": "living",
                "density_lb_ft3": 64,
                "cost_gp_ft3": 1,
                "destroy_fate": "vanishes",
                "destroy_fate_detail": "No rubble; destroyed inventory removed."
            },
            "2A4F6284-66F5-8CA4-7740-E6869F9A4391": {
                "item_id": "2A4F6284-66F5-8CA4-7740-E6869F9A4391",
                "item_name": "Magical",
                "item_type": "item_composition",
                "variable_name": "magical",
                "density_lb_ft3": 0,
                "cost_gp_ft3": 0,
                "destroy_fate": "vanishes",
                "destroy_fate_detail": "No rubble; destroyed inventory removed."
            },
            "FDDEAE27-8828-BDA3-F4C2-53D1FB9D03F1": {
                "item_id": "FDDEAE27-8828-BDA3-F4C2-53D1FB9D03F1",
                "item_name": "Mithral",
                "item_type": "item_composition",
                "variable_name": "mithral",
                "density_lb_ft3": 105,
                "cost_gp_ft3": 24500,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Mithral composition."
            },
            "2F2D12CD-315E-74F7-413E-83C6B73AE77C": {
                "item_id": "2F2D12CD-315E-74F7-413E-83C6B73AE77C",
                "item_name": "Paper",
                "item_type": "item_composition",
                "variable_name": "paper",
                "density_lb_ft3": 47,
                "cost_gp_ft3": 94,
                "destroy_fate": "vanishes",
                "destroy_fate_detail": "No rubble; destroyed inventory removed.",
                "fragile_container_splash": true
            },
            "C0E90229-3470-BBD1-64BE-2A9875ACACCE": {
                "item_id": "C0E90229-3470-BBD1-64BE-2A9875ACACCE",
                "item_name": "Platinum",
                "item_type": "item_composition",
                "variable_name": "platinum",
                "density_lb_ft3": 1340,
                "cost_gp_ft3": 670000,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Platinum composition."
            },
            "19B5896D-0FF0-196F-B46E-B9F77A48F0A5": {
                "item_id": "19B5896D-0FF0-196F-B46E-B9F77A48F0A5",
                "item_name": "Silver",
                "item_type": "item_composition",
                "variable_name": "silver",
                "density_lb_ft3": 655,
                "cost_gp_ft3": 3275,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Silver composition."
            },
            "C5F8FC65-A19E-F190-B1AA-8C56F86322FA": {
                "item_id": "C5F8FC65-A19E-F190-B1AA-8C56F86322FA",
                "item_name": "Steel",
                "item_type": "item_composition",
                "variable_name": "steel",
                "density_lb_ft3": 490,
                "cost_gp_ft3": 40,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Steel composition."
            },
            "D1E6CA2B-73EA-4DA6-99AA-45A88203EA6A": {
                "item_id": "D1E6CA2B-73EA-4DA6-99AA-45A88203EA6A",
                "item_name": "Stone",
                "item_type": "item_composition",
                "variable_name": "stone",
                "density_lb_ft3": 165,
                "cost_gp_ft3": 1,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Stone composition."
            },
            "7F9BB86D-226E-3EA3-649A-093760FD6EFE": {
                "item_id": "7F9BB86D-226E-3EA3-649A-093760FD6EFE",
                "item_name": "Talon",
                "item_type": "item_composition",
                "variable_name": "talon",
                "density_lb_ft3": 112,
                "cost_gp_ft3": 22,
                "destroy_fate": "rubble_as_bone",
                "destroy_fate_detail": "Rubble uses Bone composition (not Talon)."
            },
            "01D2DFF4-D004-B8A9-6F60-D0261548E1B4": {
                "item_id": "01D2DFF4-D004-B8A9-6F60-D0261548E1B4",
                "item_name": "Tin",
                "item_type": "item_composition",
                "variable_name": "tin",
                "density_lb_ft3": 456,
                "cost_gp_ft3": 45,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Tin composition."
            },
            "7140027D-EF3C-6ED2-594E-CF564EDF3466": {
                "item_id": "7140027D-EF3C-6ED2-594E-CF564EDF3466",
                "item_name": "Titanium",
                "item_type": "item_composition",
                "variable_name": "titanium",
                "density_lb_ft3": 281,
                "cost_gp_ft3": 560,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Titanium composition."
            },
            "BDD3F042-222C-F292-4D6B-F6649B99383B": {
                "item_id": "BDD3F042-222C-F292-4D6B-F6649B99383B",
                "item_name": "Wood",
                "item_type": "item_composition",
                "variable_name": "wood",
                "density_lb_ft3": 40,
                "cost_gp_ft3": 2,
                "destroy_fate": "rubble",
                "destroy_fate_detail": "Rubble uses Wood composition."
            }
        },
        "light_cycle_mode": {
            "472EBA96-F2BE-A721-E01E-8FF9EBA8C4BB": {
                "item_id": "472EBA96-F2BE-A721-E01E-8FF9EBA8C4BB",
                "item_name": "Endless Darkness",
                "item_type": "light_cycle_mode",
                "variable_name": "endless_darkness"
            },
            "383B5324-0F9C-5C00-F24B-EB740839B91A": {
                "item_id": "383B5324-0F9C-5C00-F24B-EB740839B91A",
                "item_name": "Endless Dim Light",
                "item_type": "light_cycle_mode",
                "variable_name": "endless_dim_light"
            },
            "D82E7DC2-F7E0-B92A-BDBE-DC241D01F353": {
                "item_id": "D82E7DC2-F7E0-B92A-BDBE-DC241D01F353",
                "item_name": "Endless Bright Light",
                "item_type": "light_cycle_mode",
                "variable_name": "endless_bright_light"
            },
            "B0BB8478-C762-B215-32C0-0F668187BB8F": {
                "item_id": "B0BB8478-C762-B215-32C0-0F668187BB8F",
                "item_name": "Long Days",
                "item_type": "light_cycle_mode",
                "variable_name": "long_days"
            },
            "C5DC831D-788C-982C-FFAB-7B97949E3979": {
                "item_id": "C5DC831D-788C-982C-FFAB-7B97949E3979",
                "item_name": "Long Nights",
                "item_type": "light_cycle_mode",
                "variable_name": "long_nights"
            },
            "64377EFA-FE12-9AFE-E20A-4189E2DF3EDF": {
                "item_id": "64377EFA-FE12-9AFE-E20A-4189E2DF3EDF",
                "item_name": "Default Light Cycle",
                "item_type": "light_cycle_mode",
                "variable_name": "default_light_cycle"
            }
        },
        "light_type": {
            "0CC8A592-CF4C-7BE4-DD0C-17A41D690A05": {
                "item_id": "0CC8A592-CF4C-7BE4-DD0C-17A41D690A05",
                "item_name": "Bright Light",
                "variable_name": "bright_light"
            },
            "61D1498F-9175-6906-4B26-8356C28B28C1": {
                "item_id": "61D1498F-9175-6906-4B26-8356C28B28C1",
                "item_name": "Dim Light",
                "variable_name": "dim_light"
            },
            "99D3E371-AC3F-7839-28E7-770FE50D24C1": {
                "item_id": "99D3E371-AC3F-7839-28E7-770FE50D24C1",
                "item_name": "Pitch Black",
                "variable_name": "pitch_black"
            },
            "67F42B5B-E3D1-0818-0197-1F36B20FC630": {
                "item_id": "67F42B5B-E3D1-0818-0197-1F36B20FC630",
                "item_name": "Magical Darkness",
                "variable_name": "magical_darkness"
            }
        },
        "map_marker": {
            "C7814403-F84C-F6F9-0794-95F3EC3AE394": {
                "item_id": "C7814403-F84C-F6F9-0794-95F3EC3AE394",
                "item_name": "East - Map Marker",
                "item_type": "map_marker",
                "variable_name": "east"
            },
            "F5DDC0AA-581A-8E6F-EFAF-4445D1A3EBC3": {
                "item_id": "F5DDC0AA-581A-8E6F-EFAF-4445D1A3EBC3",
                "item_name": "North - Map Marker",
                "item_type": "map_marker",
                "variable_name": "north"
            },
            "ACE453E8-5725-AB18-0BCF-589DDA35135D": {
                "item_id": "ACE453E8-5725-AB18-0BCF-589DDA35135D",
                "item_name": "Northeast - Map Marker",
                "item_type": "map_marker",
                "variable_name": "northeast"
            },
            "BF941177-6C2F-4EF6-92C8-BF45E0E1BE52": {
                "item_id": "BF941177-6C2F-4EF6-92C8-BF45E0E1BE52",
                "item_name": "Northwest - Map Marker",
                "item_type": "map_marker",
                "variable_name": "northwest"
            },
            "85436C19-426D-491A-E049-42731CF8AB70": {
                "item_id": "85436C19-426D-491A-E049-42731CF8AB70",
                "item_name": "South - Map Marker",
                "item_type": "map_marker",
                "variable_name": "south"
            },
            "D93EF021-9229-85C0-46DB-43F0E7E0FE9D": {
                "item_id": "D93EF021-9229-85C0-46DB-43F0E7E0FE9D",
                "item_name": "Southeast - Map Marker",
                "item_type": "map_marker",
                "variable_name": "southeast"
            },
            "73F0A293-AE4D-5E0C-9A0A-59F46FE20F5D": {
                "item_id": "73F0A293-AE4D-5E0C-9A0A-59F46FE20F5D",
                "item_name": "Southwest - Map Marker",
                "item_type": "map_marker",
                "variable_name": "southwest"
            },
            "44B43903-216C-386A-24BE-5DE3BCBB8E0D": {
                "item_id": "44B43903-216C-386A-24BE-5DE3BCBB8E0D",
                "item_name": "West - Map Marker",
                "item_type": "map_marker",
                "variable_name": "west"
            }
        },
        "natural_weapon_form": {
            "2D894B13-AC1A-4BCD-8914-92EB4BDACC18": {
                "item_id": "2D894B13-AC1A-4BCD-8914-92EB4BDACC18",
                "item_name": "Natural Weapon Form \u2014 Bite",
                "item_type": "natural_weapon_form",
                "variable_name": "bite",
                "icon_variable_name": "natural_weapon",
                "description": "A jaw closing on the target. The head-slot family every bite rider (poison, disease, drain, elemental) is meant to ride."
            },
            "4C4FE4AE-E485-495B-8ED2-F22A35DA30E8": {
                "item_id": "4C4FE4AE-E485-495B-8ED2-F22A35DA30E8",
                "item_name": "Natural Weapon Form \u2014 Beak",
                "item_type": "natural_weapon_form",
                "variable_name": "beak",
                "icon_variable_name": "natural_weapon",
                "description": "A hooked or shearing beak. Bird, roc and owlbear heads."
            },
            "A4A9688B-1C46-4A04-BDFE-552CF774547E": {
                "item_id": "A4A9688B-1C46-4A04-BDFE-552CF774547E",
                "item_name": "Natural Weapon Form \u2014 Gore",
                "item_type": "natural_weapon_form",
                "variable_name": "gore",
                "icon_variable_name": "natural_weapon",
                "description": "A driving thrust of the points on the head, delivered on the charge."
            },
            "5E805770-2DD5-4D6B-BC6D-8463D291C177": {
                "item_id": "5E805770-2DD5-4D6B-BC6D-8463D291C177",
                "item_name": "Natural Weapon Form \u2014 Horn",
                "item_type": "natural_weapon_form",
                "variable_name": "horn",
                "icon_variable_name": "natural_weapon",
                "description": "A horn or antler swept into the target. Distinct from gore: the sweep, not the charge."
            },
            "25C71284-9FE1-4FB5-982A-941913327B4A": {
                "item_id": "25C71284-9FE1-4FB5-982A-941913327B4A",
                "item_name": "Natural Weapon Form \u2014 Tusk",
                "item_type": "natural_weapon_form",
                "variable_name": "tusk",
                "icon_variable_name": "natural_weapon",
                "description": "An upward rip with the tusks of a boar or a mammoth."
            },
            "1D1BFF8B-39AC-4C8A-BD50-136A141E6A44": {
                "item_id": "1D1BFF8B-39AC-4C8A-BD50-136A141E6A44",
                "item_name": "Natural Weapon Form \u2014 Ram",
                "item_type": "natural_weapon_form",
                "variable_name": "ram",
                "icon_variable_name": "natural_weapon",
                "description": "A headbutt \u2014 the skull itself as the weapon, no points involved."
            },
            "068FC154-D699-45DE-B085-F02B23F94DB9": {
                "item_id": "068FC154-D699-45DE-B085-F02B23F94DB9",
                "item_name": "Natural Weapon Form \u2014 Tongue",
                "item_type": "natural_weapon_form",
                "variable_name": "tongue",
                "icon_variable_name": "natural_weapon",
                "description": "A tongue lashed or shot out at range, frog- and roper-style."
            },
            "E03A9BC3-2D6E-4C5F-8FFB-D7BA35D99301": {
                "item_id": "E03A9BC3-2D6E-4C5F-8FFB-D7BA35D99301",
                "item_name": "Natural Weapon Form \u2014 Pincer",
                "item_type": "natural_weapon_form",
                "variable_name": "pincer",
                "icon_variable_name": "natural_weapon",
                "description": "A chitinous claw that shears rather than rakes."
            },
            "7EBB7791-77C4-4C77-851D-9CCFAAAB3961": {
                "item_id": "7EBB7791-77C4-4C77-851D-9CCFAAAB3961",
                "item_name": "Natural Weapon Form \u2014 Lash",
                "item_type": "natural_weapon_form",
                "variable_name": "lash",
                "icon_variable_name": "natural_weapon",
                "description": "A whipping strand of flesh, hook or chain grown from the body."
            },
            "F7944C69-7A83-4BF1-9B39-C4EE05951309": {
                "item_id": "F7944C69-7A83-4BF1-9B39-C4EE05951309",
                "item_name": "Natural Weapon Form \u2014 Claw",
                "item_type": "natural_weapon_form",
                "variable_name": "claw",
                "icon_variable_name": "natural_weapon",
                "description": "A raking swipe of clawed limbs. The largest limb family in the catalog."
            },
            "F326ECEC-8545-48E6-80DC-B3901DD4CE37": {
                "item_id": "F326ECEC-8545-48E6-80DC-B3901DD4CE37",
                "item_name": "Natural Weapon Form \u2014 Talon",
                "item_type": "natural_weapon_form",
                "variable_name": "talon",
                "icon_variable_name": "natural_weapon",
                "description": "The grasping talons of a bird of prey \u2014 a claw that seizes rather than rakes."
            },
            "B997BBBB-DC3F-4F8C-AB8E-A63C80AF133B": {
                "item_id": "B997BBBB-DC3F-4F8C-AB8E-A63C80AF133B",
                "item_name": "Natural Weapon Form \u2014 Rake",
                "item_type": "natural_weapon_form",
                "variable_name": "rake",
                "icon_variable_name": "natural_weapon",
                "description": "A raking kick with the hind legs, delivered from a grapple or pounce."
            },
            "E749A3D6-F04A-4890-85B2-ACD31A722718": {
                "item_id": "E749A3D6-F04A-4890-85B2-ACD31A722718",
                "item_name": "Natural Weapon Form \u2014 Pseudopod",
                "item_type": "natural_weapon_form",
                "variable_name": "pseudopod",
                "icon_variable_name": "natural_weapon",
                "description": "A limb extruded from an amorphous body \u2014 oozes, elementals and shaped matter."
            },
            "DDB21DE1-F41C-4456-B99C-D1B9D8742B84": {
                "item_id": "DDB21DE1-F41C-4456-B99C-D1B9D8742B84",
                "item_name": "Natural Weapon Form \u2014 Slam",
                "item_type": "natural_weapon_form",
                "variable_name": "slam",
                "icon_variable_name": "natural_weapon",
                "description": "A whole-body blow: fist, trunk, wing or bulk driven into the target."
            },
            "16DE3886-A2B7-4957-A751-AE08F048BADD": {
                "item_id": "16DE3886-A2B7-4957-A751-AE08F048BADD",
                "item_name": "Natural Weapon Form \u2014 Tentacle",
                "item_type": "natural_weapon_form",
                "variable_name": "tentacle",
                "icon_variable_name": "natural_weapon",
                "description": "A long boneless arm that reaches, wraps and drags."
            },
            "B8324075-E65F-455C-BD40-B09C95B02812": {
                "item_id": "B8324075-E65F-455C-BD40-B09C95B02812",
                "item_name": "Natural Weapon Form \u2014 Constrict",
                "item_type": "natural_weapon_form",
                "variable_name": "constrict",
                "icon_variable_name": "natural_weapon",
                "description": "A coiling body that crushes what it has already wrapped."
            },
            "FAEFBA34-2176-46E5-911D-51580EF6DA74": {
                "item_id": "FAEFBA34-2176-46E5-911D-51580EF6DA74",
                "item_name": "Natural Weapon Form \u2014 Stinger",
                "item_type": "natural_weapon_form",
                "variable_name": "stinger",
                "icon_variable_name": "natural_weapon",
                "description": "A barbed tail tip that drives venom in on the hit."
            },
            "FABD5931-2BE5-4A39-BD45-62529717A62F": {
                "item_id": "FABD5931-2BE5-4A39-BD45-62529717A62F",
                "item_name": "Natural Weapon Form \u2014 Tail",
                "item_type": "natural_weapon_form",
                "variable_name": "tail",
                "icon_variable_name": "tail",
                "description": "A tail swung as a club or sweep, without a sting."
            },
            "4BC81F0D-4C96-44B0-AD91-422E0A6E5259": {
                "item_id": "4BC81F0D-4C96-44B0-AD91-422E0A6E5259",
                "item_name": "Natural Weapon Form \u2014 Hoof",
                "item_type": "natural_weapon_form",
                "variable_name": "hoof",
                "icon_variable_name": "natural_weapon",
                "description": "A shod or cloven hoof kicked into the target."
            },
            "06BBC9AA-3BED-43A4-9EC3-96072F827C04": {
                "item_id": "06BBC9AA-3BED-43A4-9EC3-96072F827C04",
                "item_name": "Natural Weapon Form \u2014 Stomp",
                "item_type": "natural_weapon_form",
                "variable_name": "stomp",
                "icon_variable_name": "natural_weapon",
                "description": "A downward crush with the full weight of the body behind it."
            },
            "287DFA0C-FD83-4305-A41E-D26CE7CE1CCC": {
                "item_id": "287DFA0C-FD83-4305-A41E-D26CE7CE1CCC",
                "item_name": "Natural Weapon Form \u2014 Spine",
                "item_type": "natural_weapon_form",
                "variable_name": "spine",
                "icon_variable_name": "natural_weapon",
                "description": "Quills, thorns or needles loosed or driven from the body."
            },
            "2C02D1AA-5FBD-470C-8154-B5304BE28D13": {
                "item_id": "2C02D1AA-5FBD-470C-8154-B5304BE28D13",
                "item_name": "Natural Weapon Form \u2014 Hurl",
                "item_type": "natural_weapon_form",
                "variable_name": "hurl",
                "icon_variable_name": "natural_weapon",
                "description": "Matter torn loose and thrown \u2014 the natural-weapon equivalent of a ranged attack."
            },
            "83CA2730-7598-44D6-BDA2-CDE4B040E73B": {
                "item_id": "83CA2730-7598-44D6-BDA2-CDE4B040E73B",
                "item_name": "Natural Weapon Form \u2014 Other",
                "item_type": "natural_weapon_form",
                "variable_name": "other",
                "icon_variable_name": "natural_weapon",
                "description": "A natural weapon whose shape fits none of the named forms. Deliberately not a bucket to grow \u2014 add a form instead."
            }
        },
        "playable_class": {
            "4B808990-16EB-52F5-0E88-EF0809F4C299": {
                "item_id": "4B808990-16EB-52F5-0E88-EF0809F4C299",
                "item_name": "Barbarian",
                "item_type": "class",
                "variable_name": "barbarian",
                "icon_variable_name": "_barbarian",
                "primary_essence": "22918408-67CC-4093-80E8-BF6FA8915C21",
                "caster_type": "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B"
            },
            "D656F798-435B-26F9-0332-0E489BBDEC7F": {
                "item_id": "D656F798-435B-26F9-0332-0E489BBDEC7F",
                "item_name": "Bard",
                "item_type": "class",
                "variable_name": "bard",
                "icon_variable_name": "_bard",
                "primary_essence": "72F93730-134F-4CA2-8FC4-F2915F20CAC6",
                "caster_type": "A18765B6-F35A-47E2-F112-DF1582C37B37"
            },
            "6E4C0D81-46B8-BFF4-2D31-827EC8ACF3A7": {
                "item_id": "6E4C0D81-46B8-BFF4-2D31-827EC8ACF3A7",
                "item_name": "Champion",
                "item_type": "class",
                "variable_name": "champion",
                "icon_variable_name": "_champion",
                "primary_essence": "22918408-67CC-4093-80E8-BF6FA8915C21",
                "caster_type": "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B"
            },
            "2BCE19F7-76A3-EE20-3EA3-C2B8ADA88878": {
                "item_id": "2BCE19F7-76A3-EE20-3EA3-C2B8ADA88878",
                "item_name": "Deathbringer",
                "item_type": "class",
                "variable_name": "deathbringer",
                "icon_variable_name": "_deathbringer",
                "primary_essence": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8",
                "caster_type": "E8FB3E1F-2B16-4889-831C-99FC9E34853E"
            },
            "63056B34-DBA2-E711-1456-ED5E032A058C": {
                "item_id": "63056B34-DBA2-E711-1456-ED5E032A058C",
                "item_name": "Druid",
                "item_type": "class",
                "variable_name": "druid",
                "icon_variable_name": "_druid",
                "primary_essence": "72F93730-134F-4CA2-8FC4-F2915F20CAC6",
                "caster_type": "A18765B6-F35A-47E2-F112-DF1582C37B37"
            },
            "B9E74EDE-8D63-B137-F094-46054EF61512": {
                "item_id": "B9E74EDE-8D63-B137-F094-46054EF61512",
                "item_name": "Hunter",
                "item_type": "class",
                "variable_name": "hunter",
                "icon_variable_name": "_hunter",
                "primary_essence": "22918408-67CC-4093-80E8-BF6FA8915C21",
                "caster_type": "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B"
            },
            "44223199-712F-A11F-BADD-EC10813AFBF7": {
                "item_id": "44223199-712F-A11F-BADD-EC10813AFBF7",
                "item_name": "Machinist",
                "item_type": "class",
                "variable_name": "machinist",
                "icon_variable_name": "_machinist",
                "primary_essence": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8",
                "caster_type": "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B"
            },
            "74D15961-05FC-1D0C-DDF6-F518F026F22B": {
                "item_id": "74D15961-05FC-1D0C-DDF6-F518F026F22B",
                "item_name": "Monk",
                "item_type": "class",
                "variable_name": "monk",
                "icon_variable_name": "_monk",
                "primary_essence": "22918408-67CC-4093-80E8-BF6FA8915C21",
                "caster_type": "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B"
            },
            "D28986FA-DCD0-F760-9F58-9E0AEF386F38": {
                "item_id": "D28986FA-DCD0-F760-9F58-9E0AEF386F38",
                "item_name": "Paladin",
                "item_type": "class",
                "variable_name": "paladin",
                "icon_variable_name": "_paladin",
                "primary_essence": "72F93730-134F-4CA2-8FC4-F2915F20CAC6",
                "caster_type": "E8FB3E1F-2B16-4889-831C-99FC9E34853E"
            },
            "F573438B-0CA0-C945-B90F-5EFB6E1E1C99": {
                "item_id": "F573438B-0CA0-C945-B90F-5EFB6E1E1C99",
                "item_name": "Priest",
                "item_type": "class",
                "variable_name": "priest",
                "icon_variable_name": "_priest",
                "primary_essence": "72F93730-134F-4CA2-8FC4-F2915F20CAC6",
                "caster_type": "A18765B6-F35A-47E2-F112-DF1582C37B37"
            },
            "F2D31321-42E4-926B-892A-DF0A41176D14": {
                "item_id": "F2D31321-42E4-926B-892A-DF0A41176D14",
                "item_name": "Psion",
                "item_type": "class",
                "variable_name": "psion",
                "icon_variable_name": "_psion",
                "primary_essence": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8",
                "caster_type": "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B"
            },
            "90474F60-446A-A55D-9B1F-9F974AD13D87": {
                "item_id": "90474F60-446A-A55D-9B1F-9F974AD13D87",
                "item_name": "Shaman",
                "item_type": "class",
                "variable_name": "shaman",
                "icon_variable_name": "_shaman",
                "primary_essence": "72F93730-134F-4CA2-8FC4-F2915F20CAC6",
                "caster_type": "E8FB3E1F-2B16-4889-831C-99FC9E34853E"
            },
            "92303965-8EFD-8D5E-C18F-B4FF3A38CA72": {
                "item_id": "92303965-8EFD-8D5E-C18F-B4FF3A38CA72",
                "item_name": "Sorcerer",
                "item_type": "class",
                "variable_name": "sorcerer",
                "icon_variable_name": "_sorcerer",
                "primary_essence": "22918408-67CC-4093-80E8-BF6FA8915C21",
                "caster_type": "A18765B6-F35A-47E2-F112-DF1582C37B37"
            },
            "BD274DB4-75BE-BF81-FB33-A225748563BC": {
                "item_id": "BD274DB4-75BE-BF81-FB33-A225748563BC",
                "item_name": "Spellblade",
                "item_type": "class",
                "variable_name": "spellblade",
                "icon_variable_name": "_spellblade",
                "primary_essence": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8",
                "caster_type": "E8FB3E1F-2B16-4889-831C-99FC9E34853E"
            },
            "35EDCE49-85F9-A36E-4407-547E0153DA05": {
                "item_id": "35EDCE49-85F9-A36E-4407-547E0153DA05",
                "item_name": "Summoner",
                "item_type": "class",
                "variable_name": "summoner",
                "icon_variable_name": "_summoner",
                "primary_essence": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8",
                "caster_type": "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B",
                "private": true
            },
            "D3F66A5C-A446-2217-697F-C174E2E5801E": {
                "item_id": "D3F66A5C-A446-2217-697F-C174E2E5801E",
                "item_name": "Thief",
                "item_type": "class",
                "variable_name": "thief",
                "icon_variable_name": "_thief",
                "primary_essence": "22918408-67CC-4093-80E8-BF6FA8915C21",
                "caster_type": "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B"
            },
            "4DDA161E-31D6-9894-58C7-CD34B21734BD": {
                "item_id": "4DDA161E-31D6-9894-58C7-CD34B21734BD",
                "item_name": "Warlock",
                "item_type": "class",
                "variable_name": "warlock",
                "icon_variable_name": "_warlock",
                "primary_essence": "72F93730-134F-4CA2-8FC4-F2915F20CAC6",
                "caster_type": "A18765B6-F35A-47E2-F112-DF1582C37B37"
            },
            "2BCF5CBC-1E87-E654-8310-E56EC051E559": {
                "item_id": "2BCF5CBC-1E87-E654-8310-E56EC051E559",
                "item_name": "Wizard",
                "item_type": "class",
                "variable_name": "wizard",
                "icon_variable_name": "_wizard",
                "primary_essence": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8",
                "caster_type": "A18765B6-F35A-47E2-F112-DF1582C37B37"
            }
        },
        "range_type": {
            "D82855E1-4BB9-93EA-6374-B9904318BC1D": {
                "item_id": "D82855E1-4BB9-93EA-6374-B9904318BC1D",
                "item_name": "Self",
                "variable_name": "self",
                "icon_variable_name": "range_self",
                "x_distance": 0,
                "target_only": true
            },
            "7E615545-1179-6F6A-9729-0AFFCD588B31": {
                "item_id": "7E615545-1179-6F6A-9729-0AFFCD588B31",
                "item_name": "Object Range",
                "variable_name": "object_range",
                "icon_variable_name": "range_object",
                "x_distance": 0,
                "target_only": true
            },
            "36D59FF4-6778-96ED-8664-F5D63638C77B": {
                "item_id": "36D59FF4-6778-96ED-8664-F5D63638C77B",
                "item_name": "Reach",
                "variable_name": "reach",
                "icon_variable_name": "range_reach",
                "x_distance": "reach"
            },
            "4C761395-2532-3F23-7CBA-CA81AF5C0855": {
                "item_id": "4C761395-2532-3F23-7CBA-CA81AF5C0855",
                "item_name": "Close",
                "variable_name": "close",
                "icon_variable_name": "range_close",
                "x_distance": 30
            },
            "A95F219A-6288-6B17-6DB7-03DE4B97AE96": {
                "item_id": "A95F219A-6288-6B17-6DB7-03DE4B97AE96",
                "item_name": "Near",
                "variable_name": "near",
                "icon_variable_name": "range_near",
                "x_distance": 60
            },
            "D1E8DA38-61C2-97AA-6173-4BF6157FEEE3": {
                "item_id": "D1E8DA38-61C2-97AA-6173-4BF6157FEEE3",
                "item_name": "Far",
                "variable_name": "far",
                "icon_variable_name": "range_far",
                "x_distance": 120
            },
            "F6DAE84B-CBB3-5C0F-89EF-370DE841DFDA": {
                "item_id": "F6DAE84B-CBB3-5C0F-89EF-370DE841DFDA",
                "item_name": "Very Far",
                "variable_name": "very_far",
                "icon_variable_name": "range_very_far",
                "x_distance": 240
            },
            "BB47D2E8-FFFD-8A04-FC6C-FC02583750ED": {
                "item_id": "BB47D2E8-FFFD-8A04-FC6C-FC02583750ED",
                "item_name": "Unlimited",
                "variable_name": "unlimited",
                "icon_variable_name": "range_unlimited",
                "x_distance": "unlimited"
            }
        },
        "roll_type": {
            "981477BF-20AC-B5B0-A9A9-A5CB4459884C": {
                "item_id": "981477BF-20AC-B5B0-A9A9-A5CB4459884C",
                "item_name": "Challenge Roll Assistance Roll",
                "variable_name": "challenge_roll_assistance_roll",
                "roll_type_pl_multiplier": 1.5
            },
            "82BBB3B6-4646-48E8-A5A2-8DC0947A91D0": {
                "item_id": "82BBB3B6-4646-48E8-A5A2-8DC0947A91D0",
                "item_name": "Damage Roll",
                "variable_name": "damage_roll",
                "roll_type_pl_multiplier": 1
            },
            "ED5B44EA-7438-9582-A388-04EFF342E460": {
                "item_id": "ED5B44EA-7438-9582-A388-04EFF342E460",
                "item_name": "DC Roll",
                "variable_name": "dc_roll",
                "roll_type_pl_multiplier": 0.4
            },
            "AD80D31D-898B-66CE-0894-1335D11B1529": {
                "item_id": "AD80D31D-898B-66CE-0894-1335D11B1529",
                "item_name": "Contesting Roll",
                "variable_name": "contesting_roll",
                "roll_type_pl_multiplier": 0.4
            },
            "A063F21A-02D9-BA39-9C71-09C8E8122693": {
                "item_id": "A063F21A-02D9-BA39-9C71-09C8E8122693",
                "item_name": "Essence Roll",
                "variable_name": "essence_roll",
                "roll_type_pl_multiplier": 0.4
            },
            "4FB7452A-F130-40C3-83E6-5E92C329D7B2": {
                "item_id": "4FB7452A-F130-40C3-83E6-5E92C329D7B2",
                "item_name": "Healing Roll",
                "variable_name": "healing_roll",
                "roll_type_pl_multiplier": 1
            },
            "52949AF2-7C18-4BA3-754E-4BF898A67AFD": {
                "item_id": "52949AF2-7C18-4BA3-754E-4BF898A67AFD",
                "item_name": "Recharge Ability Roll",
                "variable_name": "recharge_ability_roll",
                "roll_type_pl_multiplier": 1
            },
            "28B4E29C-5D8D-57CC-7634-761CEBD01190": {
                "item_id": "28B4E29C-5D8D-57CC-7634-761CEBD01190",
                "item_name": "Reduce Damage Roll",
                "variable_name": "reduce_damage_roll",
                "roll_type_pl_multiplier": 1
            },
            "9909BE44-99AE-8780-BB12-BD99BA6E672E": {
                "item_id": "9909BE44-99AE-8780-BB12-BD99BA6E672E",
                "item_name": "Regeneration Roll",
                "variable_name": "regeneration_roll",
                "roll_type_pl_multiplier": 1
            },
            "E26FC164-16F5-E38B-66F9-337FAEDE2A67": {
                "item_id": "E26FC164-16F5-E38B-66F9-337FAEDE2A67",
                "item_name": "Skill Roll Assistance Roll",
                "variable_name": "skill_roll_assistance_roll",
                "roll_type_pl_multiplier": 1.5
            },
            "73ECB998-6C8E-1854-FBBB-EF02AC2AC0EE": {
                "item_id": "73ECB998-6C8E-1854-FBBB-EF02AC2AC0EE",
                "item_name": "Skill Roll Retracting Roll",
                "variable_name": "skill_roll_retracting_roll",
                "roll_type_pl_multiplier": 1.5
            },
            "5740CA49-006E-A7A0-B46B-6DDED6CD546C": {
                "item_id": "5740CA49-006E-A7A0-B46B-6DDED6CD546C",
                "item_name": "Spell Melee Attack Roll",
                "variable_name": "spell_melee_attack_roll",
                "roll_type_pl_multiplier": 0.4
            },
            "DD280A3B-6F1D-4CE9-9EFD-505A74D0C07C": {
                "item_id": "DD280A3B-6F1D-4CE9-9EFD-505A74D0C07C",
                "item_name": "Spell Ranged Attack Roll",
                "variable_name": "spell_ranged_attack_roll",
                "roll_type_pl_multiplier": 0.4
            },
            "E5016E3A-6A12-2287-5F48-5CFAC863E967": {
                "item_id": "E5016E3A-6A12-2287-5F48-5CFAC863E967",
                "item_name": "Summon Roll",
                "variable_name": "summon_roll",
                "roll_type_pl_multiplier": 1
            },
            "4634635E-4E82-DFB3-8411-27A6BFB8CF0F": {
                "item_id": "4634635E-4E82-DFB3-8411-27A6BFB8CF0F",
                "item_name": "Temporary Vitality Regeneration Roll",
                "variable_name": "temporary_vitality_regeneration_roll",
                "roll_type_pl_multiplier": 1
            },
            "5E2689A2-0F7D-1E27-F4D5-CA09CA5C2591": {
                "item_id": "5E2689A2-0F7D-1E27-F4D5-CA09CA5C2591",
                "item_name": "Temporary Vitality Roll",
                "variable_name": "temporary_vitality_roll",
                "roll_type_pl_multiplier": 1
            },
            "1EBE0C5D-4D59-F08A-B118-13286A198ED5": {
                "item_id": "1EBE0C5D-4D59-F08A-B118-13286A198ED5",
                "item_name": "Weapon Attack Roll Assistance Roll",
                "variable_name": "weapon_attack_roll_assistance_roll",
                "roll_type_pl_multiplier": 1
            },
            "2FE8DFB7-FE61-4862-AF71-3523262350A0": {
                "item_id": "2FE8DFB7-FE61-4862-AF71-3523262350A0",
                "item_name": "Weapon Melee Attack Roll",
                "variable_name": "weapon_melee_attack_roll",
                "roll_type_pl_multiplier": 0.4
            },
            "3F85CA97-F9B2-A83A-FDE8-E523FD99346C": {
                "item_id": "3F85CA97-F9B2-A83A-FDE8-E523FD99346C",
                "item_name": "Weapon Ranged Attack Roll",
                "variable_name": "weapon_ranged_attack_roll",
                "roll_type_pl_multiplier": 0.4
            },
            "9C752002-0C85-40D8-8DC0-D43AECBB2207": {
                "item_id": "9C752002-0C85-40D8-8DC0-D43AECBB2207",
                "item_name": "Armor Bending Roll",
                "variable_name": "armor_bending_roll",
                "roll_type_pl_multiplier": 1
            },
            "5DFD335C-B12A-4B3C-9FF6-560E12D9045F": {
                "item_id": "5DFD335C-B12A-4B3C-9FF6-560E12D9045F",
                "item_name": "Dying Stratum Roll",
                "variable_name": "dying_stratum_roll",
                "roll_type_pl_multiplier": 1
            },
            "FA17A3A2-3068-C84C-1EA5-C511F71FBD8B": {
                "item_id": "FA17A3A2-3068-C84C-1EA5-C511F71FBD8B",
                "item_name": "Gathering Roll",
                "variable_name": "gathering_roll",
                "roll_type_pl_multiplier": 1
            },
            "54DC30E0-923C-4BBF-A8CC-570B0068E8A2": {
                "item_id": "54DC30E0-923C-4BBF-A8CC-570B0068E8A2",
                "item_name": "Crafting Roll",
                "variable_name": "crafting_roll",
                "roll_type_pl_multiplier": 1
            },
            "E1C8D281-0DC7-4883-8381-5630E23AD99D": {
                "item_id": "E1C8D281-0DC7-4883-8381-5630E23AD99D",
                "item_name": "Excavation Roll",
                "variable_name": "excavation_roll",
                "roll_type_pl_multiplier": 1
            },
            "77A044B7-7041-CA96-3C63-BB718B15A364": {
                "item_id": "77A044B7-7041-CA96-3C63-BB718B15A364",
                "item_name": "Damage Over Time Roll",
                "variable_name": "damage_over_time_roll",
                "roll_type_pl_multiplier": 1.3
            },
            "9878714A-27C3-D737-88B3-E8C1EE63A20F": {
                "item_id": "9878714A-27C3-D737-88B3-E8C1EE63A20F",
                "item_name": "Extra Damage Roll",
                "variable_name": "extra_damage_roll",
                "roll_type_pl_multiplier": 1
            },
            "42A38751-5549-CDE7-528E-AED309A2B07D": {
                "item_id": "42A38751-5549-CDE7-528E-AED309A2B07D",
                "item_name": "Extra Weapon Damage Roll",
                "variable_name": "extra_weapon_damage_roll",
                "roll_type_pl_multiplier": 1
            },
            "ABF66E1E-DA79-4329-31FA-70D981032C06": {
                "item_id": "ABF66E1E-DA79-4329-31FA-70D981032C06",
                "item_name": "Skill Roll",
                "variable_name": "skill_roll",
                "roll_type_pl_multiplier": 1
            },
            "F1CB1CCF-138F-0B16-266F-3AFE1AB8C73D": {
                "item_id": "F1CB1CCF-138F-0B16-266F-3AFE1AB8C73D",
                "item_name": "Extra Healing Roll",
                "variable_name": "extra_healing_roll",
                "roll_type_pl_multiplier": 1
            },
            "C823C739-A9DE-AA5A-07B8-CB67F578F880": {
                "item_id": "C823C739-A9DE-AA5A-07B8-CB67F578F880",
                "item_name": "Increase Luck Roll",
                "variable_name": "increase_luck_roll",
                "roll_type_pl_multiplier": 1
            },
            "DE5B6A74-0024-FFDB-C5C6-B0248D956515": {
                "item_id": "DE5B6A74-0024-FFDB-C5C6-B0248D956515",
                "item_name": "Reduce Luck Roll",
                "variable_name": "reduce_luck_roll",
                "roll_type_pl_multiplier": 1
            },
            "DB30C685-3830-9AEA-D8FA-D92FEA762982": {
                "item_id": "DB30C685-3830-9AEA-D8FA-D92FEA762982",
                "item_name": "Increase Mana Roll",
                "variable_name": "increase_mana_roll",
                "roll_type_pl_multiplier": 1
            },
            "905613F5-A045-BC0A-3686-CD1EC15060C5": {
                "item_id": "905613F5-A045-BC0A-3686-CD1EC15060C5",
                "item_name": "Reduce Mana Roll",
                "variable_name": "reduce_mana_roll",
                "roll_type_pl_multiplier": 1
            },
            "99DC3B29-702D-08D0-346E-AA4359EA1D82": {
                "item_id": "99DC3B29-702D-08D0-346E-AA4359EA1D82",
                "item_name": "Extra Damage Taken Roll",
                "variable_name": "extra_damage_roll_taken",
                "roll_type_pl_multiplier": 1
            },
            "CC2CEB6B-CEFB-481F-911A-A47A427D5EB2": {
                "item_id": "CC2CEB6B-CEFB-481F-911A-A47A427D5EB2",
                "item_name": "Lockpicking Roll",
                "variable_name": "lockpicking_roll",
                "roll_type_pl_multiplier": 1
            },
            "5FC40097-3C6E-53ED-0947-486FCC6DE627": {
                "item_id": "5FC40097-3C6E-53ED-0947-486FCC6DE627",
                "item_name": "Mana Drain Roll",
                "variable_name": "mana_drain_roll",
                "roll_type_pl_multiplier": 1
            },
            "F5BC82EE-DBDF-4594-F850-0C49E4292AC7": {
                "item_id": "F5BC82EE-DBDF-4594-F850-0C49E4292AC7",
                "item_name": "Temporary Max Vitality Roll",
                "variable_name": "temporary_max_vitality_roll",
                "roll_type_pl_multiplier": 1
            },
            "67B41E3F-5BF3-33A0-B459-7B8768B71933": {
                "item_id": "67B41E3F-5BF3-33A0-B459-7B8768B71933",
                "item_name": "Training Roll",
                "variable_name": "training_roll",
                "roll_type_pl_multiplier": 1
            }
        },
        "season": {
            "8D31485E-8590-7829-2918-2BEA0F1C125C": {
                "item_id": "8D31485E-8590-7829-2918-2BEA0F1C125C",
                "item_name": "Spring",
                "variable_name": "spring",
                "sunrise_dim_light_hour": 6,
                "sunrise_dim_light_minute": 30,
                "sunrise_hour": 7,
                "sunrise_minute": 0,
                "sunset_dim_light_hour": 19,
                "sunset_dim_light_minute": 0,
                "sunset_hour": 19,
                "sunset_minute": 30
            },
            "C3A3E1D8-1393-370F-C3D5-FEA77B0EB518": {
                "item_id": "C3A3E1D8-1393-370F-C3D5-FEA77B0EB518",
                "item_name": "Summer",
                "variable_name": "summer",
                "sunrise_dim_light_hour": 5,
                "sunrise_dim_light_minute": 30,
                "sunrise_hour": 6,
                "sunrise_minute": 0,
                "sunset_dim_light_hour": 20,
                "sunset_dim_light_minute": 0,
                "sunset_hour": 20,
                "sunset_minute": 30
            },
            "69DDD63C-1DEF-A3C2-DF5C-D022747821CA": {
                "item_id": "69DDD63C-1DEF-A3C2-DF5C-D022747821CA",
                "item_name": "Autumn",
                "variable_name": "autumn",
                "sunrise_dim_light_hour": 7,
                "sunrise_dim_light_minute": 0,
                "sunrise_hour": 7,
                "sunrise_minute": 30,
                "sunset_dim_light_hour": 18,
                "sunset_dim_light_minute": 0,
                "sunset_hour": 18,
                "sunset_minute": 30
            },
            "467B3256-C3F2-3426-217D-A8A779ED62FB": {
                "item_id": "467B3256-C3F2-3426-217D-A8A779ED62FB",
                "item_name": "Winter",
                "variable_name": "winter",
                "sunrise_dim_light_hour": 7,
                "sunrise_dim_light_minute": 30,
                "sunrise_hour": 8,
                "sunrise_minute": 0,
                "sunset_dim_light_hour": 16,
                "sunset_dim_light_minute": 30,
                "sunset_hour": 17,
                "sunset_minute": 0
            }
        },
        "sense": {
            "3B58A8C2-F310-42FB-A71C-904904089303": {
                "item_id": "3B58A8C2-F310-42FB-A71C-904904089303",
                "item_name": "Nightsight",
                "item_type": "sense",
                "variable_name": "nightsight"
            },
            "F87E66D1-0EB2-469F-BB07-CF2CF4E26B30": {
                "item_id": "F87E66D1-0EB2-469F-BB07-CF2CF4E26B30",
                "item_name": "Blindsight",
                "item_type": "sense",
                "variable_name": "blindsight"
            },
            "51EFBF8C-672F-F1F8-543A-6B079320572C": {
                "item_id": "51EFBF8C-672F-F1F8-543A-6B079320572C",
                "item_name": "Fiendsight",
                "item_type": "sense",
                "variable_name": "fiendsight"
            },
            "E472D6BD-1A9C-F84E-AD55-F3068A3EC303": {
                "item_id": "E472D6BD-1A9C-F84E-AD55-F3068A3EC303",
                "item_name": "Ghostsight",
                "item_type": "sense",
                "variable_name": "ghostsight"
            },
            "6B8E5648-B589-5F6A-DFAA-84F7E646B062": {
                "item_id": "6B8E5648-B589-5F6A-DFAA-84F7E646B062",
                "item_name": "Spellsight",
                "item_type": "sense",
                "variable_name": "spellsight"
            },
            "9F34BE02-A199-4A9C-A2C4-531CD8A1DD58": {
                "item_id": "9F34BE02-A199-4A9C-A2C4-531CD8A1DD58",
                "item_name": "Truesight",
                "item_type": "sense",
                "variable_name": "truesight"
            },
            "61FD588C-4A17-4190-999B-7832820C44BA": {
                "item_id": "61FD588C-4A17-4190-999B-7832820C44BA",
                "item_name": "Tremorsense",
                "item_type": "sense",
                "variable_name": "tremorsense"
            },
            "57DAF94A-7C3A-4C5B-A7A9-22729D06355F": {
                "item_id": "57DAF94A-7C3A-4C5B-A7A9-22729D06355F",
                "item_name": "Telepathy",
                "item_type": "sense",
                "variable_name": "telepathy"
            }
        },
        "size": {
            "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": {
                "item_id": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7",
                "item_name": "Tiny",
                "item_type": "size",
                "variable_name": "tiny",
                "v_die": 4
            },
            "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": {
                "item_id": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7",
                "item_name": "Small",
                "item_type": "size",
                "variable_name": "small",
                "v_die": 6
            },
            "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": {
                "item_id": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC",
                "item_name": "Medium",
                "item_type": "size",
                "variable_name": "medium",
                "v_die": 8
            },
            "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": {
                "item_id": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
                "item_name": "Large",
                "item_type": "size",
                "variable_name": "large",
                "v_die": 10
            },
            "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": {
                "item_id": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C",
                "item_name": "Huge",
                "item_type": "size",
                "variable_name": "huge",
                "v_die": 12
            },
            "CEA2946E-D395-46EA-A6E7-74D21EA2376E": {
                "item_id": "CEA2946E-D395-46EA-A6E7-74D21EA2376E",
                "item_name": "Gargantuan",
                "item_type": "size",
                "variable_name": "gargantuan",
                "v_die": 20
            },
            "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": {
                "item_id": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68",
                "item_name": "Colossal",
                "item_type": "size",
                "variable_name": "colossal",
                "v_die": 50
            },
            "4C33FD22-5382-15DA-1C46-F57F14378AFD": {
                "item_id": "4C33FD22-5382-15DA-1C46-F57F14378AFD",
                "item_name": "Titanic",
                "item_type": "size",
                "variable_name": "titanic",
                "v_die": 100
            }
        },
        "size_type": {
            "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": {
                "item_id": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7",
                "item_name": "Tiny",
                "item_type": "size_type",
                "variable_name": "tiny",
                "base_size": 2.5,
                "weight_multiplier": 3,
                "hunger_meter_max": 25,
                "thirst_meter_max": 25,
                "thumbnail_width": 40,
                "thumbnail_height": 40,
                "reach": "+3",
                "vitality_scale": 0.25,
                "required_weapon_size_fit_passive": "C80A28EC-E4DF-664C-FA7C-870A8A53C032",
                "required_armor_size_fit_passive": "64C7938A-010C-1527-6890-A4BC39362807"
            },
            "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": {
                "item_id": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7",
                "item_name": "Small",
                "item_type": "size_type",
                "variable_name": "small",
                "base_size": 3.75,
                "weight_multiplier": 7,
                "hunger_meter_max": 50,
                "thirst_meter_max": 50,
                "thumbnail_width": 60,
                "thumbnail_height": 60,
                "reach": "+5",
                "vitality_scale": 0.6
            },
            "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": {
                "item_id": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC",
                "item_name": "Medium - Size",
                "item_type": "size_type",
                "variable_name": "medium",
                "base_size": 5,
                "weight_multiplier": 10,
                "hunger_meter_max": 100,
                "thirst_meter_max": 100,
                "thumbnail_width": 80,
                "thumbnail_height": 80,
                "reach": "+5",
                "vitality_scale": 1
            },
            "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": {
                "item_id": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
                "item_name": "Large",
                "item_type": "size_type",
                "variable_name": "large",
                "base_size": 10,
                "weight_multiplier": 20,
                "hunger_meter_max": 200,
                "thirst_meter_max": 200,
                "thumbnail_width": 160,
                "thumbnail_height": 160,
                "reach": "+5",
                "vitality_scale": 4,
                "required_weapon_size_fit_passive": "BD02A97E-8EB3-445A-8758-B01E089FFE03",
                "required_armor_size_fit_passive": "83D21DE1-B6D9-877E-9B6E-56734C400643"
            },
            "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": {
                "item_id": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C",
                "item_name": "Huge",
                "item_type": "size_type",
                "variable_name": "huge",
                "base_size": 15,
                "weight_multiplier": 40,
                "hunger_meter_max": 400,
                "thirst_meter_max": 400,
                "thumbnail_width": 240,
                "thumbnail_height": 240,
                "reach": "+10",
                "vitality_scale": 15,
                "required_weapon_size_fit_passive": "F74CFA32-D114-191D-CC2F-C8DE12B8E871",
                "required_armor_size_fit_passive": "BE936924-6C8B-CBEC-3E77-6D47B1F98959"
            },
            "CEA2946E-D395-46EA-A6E7-74D21EA2376E": {
                "item_id": "CEA2946E-D395-46EA-A6E7-74D21EA2376E",
                "item_name": "Gargantuan",
                "item_type": "size_type",
                "variable_name": "gargantuan",
                "base_size": 20,
                "weight_multiplier": 80,
                "hunger_meter_max": 800,
                "thirst_meter_max": 800,
                "thumbnail_width": 320,
                "thumbnail_height": 320,
                "reach": "+10",
                "vitality_scale": 50,
                "required_weapon_size_fit_passive": "4C7C35F9-F948-581F-0F2D-11BAFC476122",
                "required_armor_size_fit_passive": "65532C69-CC39-2614-CABC-C4D5EB9ACE48"
            },
            "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": {
                "item_id": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68",
                "item_name": "Colossal",
                "item_type": "size_type",
                "variable_name": "colossal",
                "base_size": 25,
                "weight_multiplier": 160,
                "hunger_meter_max": 1600,
                "thirst_meter_max": 1600,
                "thumbnail_width": 400,
                "thumbnail_height": 400,
                "reach": "+15",
                "vitality_scale": 160,
                "required_weapon_size_fit_passive": "C05381EC-D66A-15AC-46F0-42F5EA8D9383",
                "required_armor_size_fit_passive": "7C0A9429-D170-041B-727B-5D3762D9CFC5"
            },
            "4C33FD22-5382-15DA-1C46-F57F14378AFD": {
                "item_id": "4C33FD22-5382-15DA-1C46-F57F14378AFD",
                "item_name": "Titanic",
                "item_type": "size_type",
                "variable_name": "titanic",
                "base_size": 30,
                "weight_multiplier": 320,
                "hunger_meter_max": 3200,
                "thirst_meter_max": 3200,
                "thumbnail_width": 480,
                "thumbnail_height": 480,
                "reach": "+20",
                "vitality_scale": 500,
                "required_weapon_size_fit_passive": "44D45637-FCFE-FC95-BE32-DD47FCAEC116",
                "required_armor_size_fit_passive": "A0DC40FE-BA7A-89FC-CA10-1C15BBAD6EDF"
            }
        },
        "speed_type": {
            "DF516479-F164-87FA-7BB8-6F268BF1DCE7": {
                "item_id": "DF516479-F164-87FA-7BB8-6F268BF1DCE7",
                "item_name": "Walking Speed",
                "item_type": "speed_type",
                "variable_name": "speed_walking"
            },
            "B96061AE-3369-7E7A-B6A2-C7C8FBF2A23F": {
                "item_id": "B96061AE-3369-7E7A-B6A2-C7C8FBF2A23F",
                "item_name": "Jumping Speed",
                "item_type": "speed_type",
                "variable_name": "speed_jumping"
            },
            "ED9810A9-3456-4D6B-BC5C-A1BAF5952B98": {
                "item_id": "ED9810A9-3456-4D6B-BC5C-A1BAF5952B98",
                "item_name": "Swimming Speed",
                "item_type": "speed_type",
                "variable_name": "speed_swimming"
            },
            "EDCBE2A8-CD3D-43DC-9B92-84A634BE12AE": {
                "item_id": "EDCBE2A8-CD3D-43DC-9B92-84A634BE12AE",
                "item_name": "Climbing Speed",
                "item_type": "speed_type",
                "variable_name": "speed_climbing"
            },
            "F1D0A27A-43F1-4A4C-A5F8-ED9BD2D908D4": {
                "item_id": "F1D0A27A-43F1-4A4C-A5F8-ED9BD2D908D4",
                "item_name": "Flying Speed",
                "item_type": "speed_type",
                "variable_name": "speed_flying"
            },
            "ACFB413D-15A8-835B-C821-9E101B6C4F60": {
                "item_id": "ACFB413D-15A8-835B-C821-9E101B6C4F60",
                "item_name": "Burrowing Speed",
                "item_type": "speed_type",
                "variable_name": "speed_burrowing"
            },
            "3C96DE74-D9E6-4173-8671-989209A0BF97": {
                "item_id": "3C96DE74-D9E6-4173-8671-989209A0BF97",
                "item_name": "Teleport",
                "item_type": "speed_type",
                "variable_name": "teleport"
            },
            "AE7D4EB3-DC36-BD47-978F-1DBCFE2B616A": {
                "item_id": "AE7D4EB3-DC36-BD47-978F-1DBCFE2B616A",
                "item_name": "Hovering Speed",
                "item_type": "speed_type",
                "variable_name": "speed_hovering"
            }
        },
        "sphere_of_magic": {
            "96E272A4-8DDE-443C-0FCF-3A24ECFFB7C2": {
                "item_id": "96E272A4-8DDE-443C-0FCF-3A24ECFFB7C2",
                "item_name": "Arcane Sphere of Magic",
                "variable_name": "arcane"
            },
            "57F117E8-6659-4F2D-AED2-82D6005492B9": {
                "item_id": "57F117E8-6659-4F2D-AED2-82D6005492B9",
                "item_name": "Divine Sphere of Magic",
                "variable_name": "divine"
            },
            "B4D1AA5E-3B7B-4CE6-BA1E-DC43A5EEBF38": {
                "item_id": "B4D1AA5E-3B7B-4CE6-BA1E-DC43A5EEBF38",
                "item_name": "Primal Sphere of Magic",
                "variable_name": "primal"
            }
        },
        "status_effect": {
            "658B4D83-322B-42FA-82AB-49D3BAD33590": {
                "item_id": "658B4D83-322B-42FA-82AB-49D3BAD33590",
                "item_name": "Ageless",
                "variable_name": "ageless",
                "status_type": "boon"
            },
            "9529EEA7-63A9-C572-ECA9-F523E87C58A8": {
                "item_id": "9529EEA7-63A9-C572-ECA9-F523E87C58A8",
                "item_name": "Deafened",
                "variable_name": "deafened",
                "status_type": "bane"
            },
            "4638F1B5-48F9-4E81-95B7-E0325F40B5EF": {
                "item_id": "4638F1B5-48F9-4E81-95B7-E0325F40B5EF",
                "item_name": "Diseased",
                "variable_name": "diseased",
                "status_type": "bane"
            },
            "D9043BEC-2EFF-BC30-BE5C-270D7E1A68A8": {
                "item_id": "D9043BEC-2EFF-BC30-BE5C-270D7E1A68A8",
                "item_name": "Poisoned",
                "variable_name": "poisoned",
                "status_type": "bane"
            },
            "A176161E-3825-86D8-7BE7-C1524A5B19D4": {
                "item_id": "A176161E-3825-86D8-7BE7-C1524A5B19D4",
                "item_name": "Food Poisoning",
                "variable_name": "food_poisoning",
                "status_type": "bane"
            },
            "F5ACBDB4-D923-3684-57F6-FBF3F720AEFA": {
                "item_id": "F5ACBDB4-D923-3684-57F6-FBF3F720AEFA",
                "item_name": "Prone",
                "variable_name": "prone",
                "status_type": "bane"
            },
            "095BC6BC-06F6-74E0-2B8A-FC1F32AF809B": {
                "item_id": "095BC6BC-06F6-74E0-2B8A-FC1F32AF809B",
                "item_name": "Sleeping",
                "variable_name": "sleeping",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "2A20ACDF-3BC6-B964-8FBD-F8E1AC581AA5": {
                "item_id": "2A20ACDF-3BC6-B964-8FBD-F8E1AC581AA5",
                "item_name": "Suffocating",
                "variable_name": "suffocating",
                "status_type": "bane"
            },
            "1E8008FA-B68A-8DE8-48CE-0EB121008FEB": {
                "item_id": "1E8008FA-B68A-8DE8-48CE-0EB121008FEB",
                "item_name": "Drowning",
                "variable_name": "drowning",
                "status_type": "bane"
            },
            "7B044913-E45E-04C9-F25C-5FB8B8C503F4": {
                "item_id": "7B044913-E45E-04C9-F25C-5FB8B8C503F4",
                "item_name": "Surprised",
                "variable_name": "surprised",
                "status_type": "bane"
            },
            "F73BA661-ADD2-26E0-E265-FBEB7E5E6AF1": {
                "item_id": "F73BA661-ADD2-26E0-E265-FBEB7E5E6AF1",
                "item_name": "Unconscious",
                "variable_name": "unconscious",
                "status_type": "bane"
            },
            "799B512F-C685-9655-0AF0-8CFBE0349130": {
                "item_id": "799B512F-C685-9655-0AF0-8CFBE0349130",
                "item_name": "Truthsayer",
                "variable_name": "truthsayer",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "DCB240F7-C033-1B9C-0E27-446C5C1F4D0C": {
                "item_id": "DCB240F7-C033-1B9C-0E27-446C5C1F4D0C",
                "item_name": "Repelled",
                "variable_name": "repelled",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "BCC91DAF-AF10-497E-241D-ACD1BEC9E80E": {
                "item_id": "BCC91DAF-AF10-497E-241D-ACD1BEC9E80E",
                "item_name": "Silenced",
                "variable_name": "silenced",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "83EAD975-053D-1DDA-4474-F2128633500E": {
                "item_id": "83EAD975-053D-1DDA-4474-F2128633500E",
                "item_name": "Withering",
                "variable_name": "withering",
                "status_type": "bane",
                "applies_to_compositions": [
                    "wood",
                    "flesh",
                    "living"
                ]
            },
            "3E9BD118-C5FB-2C0A-01CF-72DC2C4ED0E8": {
                "item_id": "3E9BD118-C5FB-2C0A-01CF-72DC2C4ED0E8",
                "item_name": "Challenged",
                "variable_name": "challenged",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "D5A31654-692A-B4BE-49DC-2B3360F76D4A": {
                "item_id": "D5A31654-692A-B4BE-49DC-2B3360F76D4A",
                "item_name": "Confused",
                "variable_name": "confused",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "B5E6379E-5869-4B82-3EB4-9ACB48D2F82A": {
                "item_id": "B5E6379E-5869-4B82-3EB4-9ACB48D2F82A",
                "item_name": "Feebleminded",
                "variable_name": "feebleminded",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "3188FB3B-C860-43D4-9BA0-40364C460385": {
                "item_id": "3188FB3B-C860-43D4-9BA0-40364C460385",
                "item_name": "Resting",
                "variable_name": "resting",
                "status_type": "bane"
            },
            "8A6575CF-BCA9-2E70-5ECB-21FE529FCAB6": {
                "item_id": "8A6575CF-BCA9-2E70-5ECB-21FE529FCAB6",
                "item_name": "Soul Breaker",
                "variable_name": "soul_breaker",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "39F1A03D-A7C7-4E90-98FD-14F508074BC5": {
                "item_id": "39F1A03D-A7C7-4E90-98FD-14F508074BC5",
                "item_name": "Unimpeded",
                "variable_name": "unimpeded",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "EC8F4821-26B6-4874-86E0-2B344CDC8B4F": {
                "item_id": "EC8F4821-26B6-4874-86E0-2B344CDC8B4F",
                "item_name": "Reckless",
                "variable_name": "reckless",
                "status_type": "boon"
            },
            "E7FDB796-26DA-E0F5-8F88-C21FE01D923B": {
                "item_id": "E7FDB796-26DA-E0F5-8F88-C21FE01D923B",
                "item_name": "Concentrating",
                "variable_name": "concentrating",
                "status_type": "bane"
            },
            "AE967694-B94B-F0FF-B680-829FDE6E8D58": {
                "item_id": "AE967694-B94B-F0FF-B680-829FDE6E8D58",
                "item_name": "Searching",
                "variable_name": "searching",
                "status_type": "bane"
            },
            "A311574A-3513-44AB-8C70-3C3006F6CC40": {
                "item_id": "A311574A-3513-44AB-8C70-3C3006F6CC40",
                "item_name": "Consecrated",
                "variable_name": "consecrated",
                "status_type": "none"
            },
            "321DA526-E48E-F202-10FC-D3A2B03485F2": {
                "item_id": "321DA526-E48E-F202-10FC-D3A2B03485F2",
                "item_name": "Frightened",
                "variable_name": "frightened",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "057BA9B2-177C-40A6-8815-8063DDDC0D9B": {
                "item_id": "057BA9B2-177C-40A6-8815-8063DDDC0D9B",
                "item_name": "AOE Redirection",
                "variable_name": "aoe_redirection",
                "status_type": "none",
                "ends_on_caster_death": true
            },
            "83234E69-6C06-3392-256B-CB3796C180A7": {
                "item_id": "83234E69-6C06-3392-256B-CB3796C180A7",
                "item_name": "Incorporeal",
                "variable_name": "incorporeal",
                "status_type": "boon"
            },
            "9DF8FF4C-33E8-8095-4876-ED3DBCD50B79": {
                "item_id": "9DF8FF4C-33E8-8095-4876-ED3DBCD50B79",
                "item_name": "Spell Locked",
                "variable_name": "spell_locked",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "2A64D1E8-7C3B-4F92-B5A8-E19D64C72F35": {
                "item_id": "2A64D1E8-7C3B-4F92-B5A8-E19D64C72F35",
                "item_name": "Abjuration Locked",
                "variable_name": "circle_locked_abjuration",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "9E15B7A2-3D48-4C61-A927-F84B21D6E593": {
                "item_id": "9E15B7A2-3D48-4C61-A927-F84B21D6E593",
                "item_name": "Charm Locked",
                "variable_name": "circle_locked_charm",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "6C82F394-1A5D-4E76-8B34-D29E75A1C648": {
                "item_id": "6C82F394-1A5D-4E76-8B34-D29E75A1C648",
                "item_name": "Conjuration Locked",
                "variable_name": "circle_locked_conjuration",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "4F37A8D1-9B62-4A15-C783-28E91B5F4D76": {
                "item_id": "4F37A8D1-9B62-4A15-C783-28E91B5F4D76",
                "item_name": "Divination Locked",
                "variable_name": "circle_locked_divination",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "8D21C6F5-4E93-4B27-A164-73F8D2E9B5A4": {
                "item_id": "8D21C6F5-4E93-4B27-A164-73F8D2E9B5A4",
                "item_name": "Evocation Locked",
                "variable_name": "circle_locked_evocation",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "3B96E4A7-2F51-4D38-9C82-46A1E7D3F925": {
                "item_id": "3B96E4A7-2F51-4D38-9C82-46A1E7D3F925",
                "item_name": "Illusion Locked",
                "variable_name": "circle_locked_illusion",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "7A45D2B9-6C18-4F63-B591-82D4F6A3E1C7": {
                "item_id": "7A45D2B9-6C18-4F63-B591-82D4F6A3E1C7",
                "item_name": "Necromancy Locked",
                "variable_name": "circle_locked_necromancy",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "5E63B1C4-8A27-4D95-A348-91C6E2F7D8B3": {
                "item_id": "5E63B1C4-8A27-4D95-A348-91C6E2F7D8B3",
                "item_name": "Transmutation Locked",
                "variable_name": "circle_locked_transmutation",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "1D87F5A3-6B42-4C19-8E75-34A9D1B6C2F8": {
                "item_id": "1D87F5A3-6B42-4C19-8E75-34A9D1B6C2F8",
                "item_name": "Arcane Sphere Locked",
                "variable_name": "sphere_locked_arcane",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "9C34A6E1-5D78-4B26-A493-67F2E8D5B1A9": {
                "item_id": "9C34A6E1-5D78-4B26-A493-67F2E8D5B1A9",
                "item_name": "Divine Sphere Locked",
                "variable_name": "sphere_locked_divine",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "6F92C3D7-1E85-4A64-B237-58D1A9F4E6C3": {
                "item_id": "6F92C3D7-1E85-4A64-B237-58D1A9F4E6C3",
                "item_name": "Primal Sphere Locked",
                "variable_name": "sphere_locked_primal",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "1710A01B-FAF1-4684-5050-A10386685D35": {
                "item_id": "1710A01B-FAF1-4684-5050-A10386685D35",
                "item_name": "Inverted",
                "variable_name": "inverted",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "DB1C8E56-CBD7-09E4-0FBF-148F28A93D67": {
                "item_id": "DB1C8E56-CBD7-09E4-0FBF-148F28A93D67",
                "item_name": "Fleeing",
                "variable_name": "fleeing",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "DA2F74EB-CF67-AEEB-0DE1-376C6BB7CABA": {
                "item_id": "DA2F74EB-CF67-AEEB-0DE1-376C6BB7CABA",
                "item_name": "Holy Turned",
                "variable_name": "holy_turned",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "D31E3DD8-FFA1-67EC-D3F4-FCD323059091": {
                "item_id": "D31E3DD8-FFA1-67EC-D3F4-FCD323059091",
                "item_name": "Disguised",
                "variable_name": "disguised",
                "status_type": "boon"
            },
            "EEDD357F-C1CA-44C1-A53F-DD06EEFBA597": {
                "item_id": "EEDD357F-C1CA-44C1-A53F-DD06EEFBA597",
                "item_name": "Holding Mastery",
                "variable_name": "holding_mastery",
                "status_type": "boon"
            },
            "D09D563D-0689-4B56-AEAA-5A254DC408A4": {
                "item_id": "D09D563D-0689-4B56-AEAA-5A254DC408A4",
                "item_name": "Performing a Melody",
                "variable_name": "performing_a_melody",
                "status_type": "boon"
            },
            "2858158E-5E6A-491B-9824-290DE8D692D8": {
                "item_id": "2858158E-5E6A-491B-9824-290DE8D692D8",
                "item_name": "Shadowform",
                "variable_name": "shadowform",
                "status_type": "boon"
            },
            "331C8511-F8A7-4626-AF17-48FAF062FE50": {
                "item_id": "331C8511-F8A7-4626-AF17-48FAF062FE50",
                "item_name": "Fate Card Suit Love",
                "variable_name": "fate_card_suit_love",
                "status_type": "boon"
            },
            "D9394C92-068A-FAFA-231D-289157FD2980": {
                "item_id": "D9394C92-068A-FAFA-231D-289157FD2980",
                "item_name": "Fate Card Suit War",
                "variable_name": "fate_card_suit_war",
                "status_type": "boon"
            },
            "34987D5C-BB13-7633-E28A-C3DA4BD458A7": {
                "item_id": "34987D5C-BB13-7633-E28A-C3DA4BD458A7",
                "item_name": "Fate Card Suit Prosperity",
                "variable_name": "fate_card_suit_prosperity",
                "status_type": "boon"
            },
            "6A31B8DA-8AD6-ACC1-9E3A-3A8DD77FD43D": {
                "item_id": "6A31B8DA-8AD6-ACC1-9E3A-3A8DD77FD43D",
                "item_name": "Fate Card Suit Change",
                "variable_name": "fate_card_suit_change",
                "status_type": "boon"
            },
            "C8163F62-7B18-8221-A60D-C9DD775682E3": {
                "item_id": "C8163F62-7B18-8221-A60D-C9DD775682E3",
                "item_name": "Trackers Brand",
                "variable_name": "trackers_brand",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "D343892B-338C-4FBE-BEA0-2015FE503F43": {
                "item_id": "D343892B-338C-4FBE-BEA0-2015FE503F43",
                "item_name": "Donning",
                "variable_name": "donning",
                "status_type": "bane"
            },
            "398DD6E8-AFAE-EA0D-6FE9-C22842D53775": {
                "item_id": "398DD6E8-AFAE-EA0D-6FE9-C22842D53775",
                "item_name": "Doffing",
                "variable_name": "doffing",
                "status_type": "bane"
            },
            "ED30CCB0-1645-B97E-B9A6-867D8D0094BD": {
                "item_id": "ED30CCB0-1645-B97E-B9A6-867D8D0094BD",
                "item_name": "Reading",
                "variable_name": "reading",
                "status_type": "bane"
            },
            "426C7E0B-EF44-498C-10B2-B50A9E28E45C": {
                "item_id": "426C7E0B-EF44-498C-10B2-B50A9E28E45C",
                "item_name": "Training",
                "variable_name": "training",
                "status_type": "bane"
            },
            "78C51D2D-5178-551C-1249-B5DDA4083098": {
                "item_id": "78C51D2D-5178-551C-1249-B5DDA4083098",
                "item_name": "Trapped",
                "variable_name": "trapped",
                "status_type": "boon"
            },
            "477A7977-60D2-4B9C-96B0-6ED4BFD6437E": {
                "item_id": "477A7977-60D2-4B9C-96B0-6ED4BFD6437E",
                "item_name": "Locked",
                "variable_name": "locked",
                "status_type": "boon"
            },
            "36C061BF-E480-4334-961C-26500150E3C4": {
                "item_id": "36C061BF-E480-4334-961C-26500150E3C4",
                "item_name": "Integrated Object",
                "variable_name": "integrated_object",
                "status_type": "none"
            },
            "B84EBE3F-B385-4CEF-9C69-648086C4CB7D": {
                "item_id": "B84EBE3F-B385-4CEF-9C69-648086C4CB7D",
                "item_name": "Summon Tag",
                "variable_name": "summon_tag",
                "status_type": "none"
            },
            "5AA76DEE-CE52-E021-67CD-8C701DA0E56F": {
                "item_id": "5AA76DEE-CE52-E021-67CD-8C701DA0E56F",
                "item_name": "Awake",
                "variable_name": "awake",
                "status_type": "none"
            },
            "FD5CB2E3-B247-274A-5B42-25F538F72661": {
                "item_id": "FD5CB2E3-B247-274A-5B42-25F538F72661",
                "item_name": "Weary",
                "variable_name": "weary",
                "status_type": "bane"
            },
            "A707303F-CE4F-26D8-8846-B5178D3F1DB2": {
                "item_id": "A707303F-CE4F-26D8-8846-B5178D3F1DB2",
                "item_name": "Nondetection Effect",
                "variable_name": "nondetection_effect",
                "status_type": "boon"
            },
            "B9DC5478-8F86-29F7-15D8-1C8CE8171F12": {
                "item_id": "B9DC5478-8F86-29F7-15D8-1C8CE8171F12",
                "item_name": "Spider Climb Effect",
                "variable_name": "spider_climb_effect",
                "status_type": "boon"
            },
            "A13061B6-2390-14E8-34E0-366C0E0CDE34": {
                "item_id": "A13061B6-2390-14E8-34E0-366C0E0CDE34",
                "item_name": "Water Walk Effect",
                "variable_name": "water_walk_effect",
                "status_type": "boon"
            },
            "5D939B6E-B9BC-7AC5-5143-4F00F4189EA3": {
                "item_id": "5D939B6E-B9BC-7AC5-5143-4F00F4189EA3",
                "item_name": "Casting",
                "variable_name": "casting",
                "status_type": "bane"
            },
            "5833A733-D277-0A60-3A94-A0F355A79A80": {
                "item_id": "5833A733-D277-0A60-3A94-A0F355A79A80",
                "item_name": "Casting Ritual Spell",
                "variable_name": "casting_ritual_spell",
                "status_type": "bane"
            },
            "62ED7394-9C33-D41A-C426-1BC6723C999A": {
                "item_id": "62ED7394-9C33-D41A-C426-1BC6723C999A",
                "item_name": "Crafting",
                "variable_name": "crafting",
                "status_type": "bane"
            },
            "E49AA8BA-1F60-4FD8-B3C0-852BBA3978C3": {
                "item_id": "E49AA8BA-1F60-4FD8-B3C0-852BBA3978C3",
                "item_name": "Crafting Progress",
                "variable_name": "crafting_progress",
                "status_type": "none"
            },
            "1C4D81BB-FB79-68AD-E881-28D874927FD2": {
                "item_id": "1C4D81BB-FB79-68AD-E881-28D874927FD2",
                "item_name": "Disenchanting",
                "variable_name": "disenchanting",
                "status_type": "bane"
            },
            "FF9A38A3-5F35-F083-E153-7DF41B0C0826": {
                "item_id": "FF9A38A3-5F35-F083-E153-7DF41B0C0826",
                "item_name": "Lockpicking",
                "variable_name": "lockpicking",
                "status_type": "bane"
            },
            "3F171782-CC56-32DF-81B4-8C0ED89F47F4": {
                "item_id": "3F171782-CC56-32DF-81B4-8C0ED89F47F4",
                "item_name": "Gathering",
                "variable_name": "gathering",
                "status_type": "bane"
            },
            "7B3E9C4A-1D62-4F08-A5D7-3E90C1B84F26": {
                "item_id": "7B3E9C4A-1D62-4F08-A5D7-3E90C1B84F26",
                "item_name": "Excavation Found",
                "variable_name": "excavation_found",
                "status_type": "none"
            },
            "A64E346E-F58C-5FB7-BE30-71232C06897C": {
                "item_id": "A64E346E-F58C-5FB7-BE30-71232C06897C",
                "item_name": "Slightly Drunk",
                "variable_name": "slightly_drunk",
                "status_type": "bane"
            },
            "67B9CAB7-1C48-41E0-AEAF-2F4A352075C1": {
                "item_id": "67B9CAB7-1C48-41E0-AEAF-2F4A352075C1",
                "item_name": "Drunk",
                "variable_name": "drunk",
                "status_type": "bane"
            },
            "09FC38BC-6060-4B67-A33F-EF7D448F71F1": {
                "item_id": "09FC38BC-6060-4B67-A33F-EF7D448F71F1",
                "item_name": "Burning",
                "variable_name": "burning",
                "status_type": "bane"
            },
            "996886D6-67F7-2A7D-0336-9324C877CAA6": {
                "item_id": "996886D6-67F7-2A7D-0336-9324C877CAA6",
                "item_name": "Melting",
                "variable_name": "melting",
                "status_type": "bane"
            },
            "F632281D-2F16-FFDA-FB95-2E958988F01F": {
                "item_id": "F632281D-2F16-FFDA-FB95-2E958988F01F",
                "item_name": "Corroding",
                "variable_name": "corroding",
                "status_type": "bane"
            },
            "F90FB02F-2549-6FE0-A162-CC3FA7C90C67": {
                "item_id": "F90FB02F-2549-6FE0-A162-CC3FA7C90C67",
                "item_name": "Dissolving",
                "variable_name": "dissolving",
                "status_type": "bane"
            },
            "E3169368-A4EF-476F-B699-5EFE62C7CE2A": {
                "item_id": "E3169368-A4EF-476F-B699-5EFE62C7CE2A",
                "item_name": "Wet",
                "variable_name": "wet",
                "status_type": "bane"
            },
            "99951E6E-9801-4E3E-A684-4D111F2D6624": {
                "item_id": "99951E6E-9801-4E3E-A684-4D111F2D6624",
                "item_name": "Chilled",
                "variable_name": "chilled",
                "status_type": "bane"
            },
            "84CD1B4A-0D7C-9385-8128-D91339F269BF": {
                "item_id": "84CD1B4A-0D7C-9385-8128-D91339F269BF",
                "item_name": "Freezing",
                "variable_name": "freezing",
                "status_type": "bane"
            },
            "6EFBE105-7632-4C64-BC04-206CEAF663E6": {
                "item_id": "6EFBE105-7632-4C64-BC04-206CEAF663E6",
                "item_name": "Frozen",
                "variable_name": "frozen",
                "status_type": "bane"
            },
            "E5452E0D-251E-4BDD-AC25-DADD00A7BEC7": {
                "item_id": "E5452E0D-251E-4BDD-AC25-DADD00A7BEC7",
                "item_name": "Electrocuted",
                "variable_name": "electrocuted",
                "status_type": "bane"
            },
            "F711788C-2BB4-4114-8339-B3C85BE0D52A": {
                "item_id": "F711788C-2BB4-4114-8339-B3C85BE0D52A",
                "item_name": "Shocked",
                "variable_name": "shocked",
                "status_type": "bane"
            },
            "CEFF8A40-503C-FDA3-41B3-43DC06BF762D": {
                "item_id": "CEFF8A40-503C-FDA3-41B3-43DC06BF762D",
                "item_name": "Blinded",
                "variable_name": "blinded",
                "status_type": "bane"
            },
            "0313A4D7-C1C2-4D1B-8DD7-CC6EDBC42065": {
                "item_id": "0313A4D7-C1C2-4D1B-8DD7-CC6EDBC42065",
                "item_name": "Dimmed",
                "variable_name": "dimmed",
                "status_type": "bane"
            },
            "4B74DA87-EABF-7EBA-D283-C5A1FEF483C9": {
                "item_id": "4B74DA87-EABF-7EBA-D283-C5A1FEF483C9",
                "item_name": "Sightless",
                "variable_name": "sightless",
                "status_type": "bane"
            },
            "3E053858-D7C1-4E36-91A7-AF05EF5D0C62": {
                "item_id": "3E053858-D7C1-4E36-91A7-AF05EF5D0C62",
                "item_name": "Photosensitive Eye Strain",
                "variable_name": "photosensitive_eye_strain",
                "status_type": "bane"
            },
            "3C038AB7-2684-A787-1809-6C8224DBB285": {
                "item_id": "3C038AB7-2684-A787-1809-6C8224DBB285",
                "item_name": "Extreme Photosensitive Eye Strain",
                "variable_name": "extreme_photosensitive_eye_strain",
                "status_type": "bane"
            },
            "A1F1FAF2-DA1E-D537-36C2-2B74DC82CB12": {
                "item_id": "A1F1FAF2-DA1E-D537-36C2-2B74DC82CB12",
                "item_name": "Piloting",
                "variable_name": "piloting",
                "status_type": "boon"
            },
            "DDC66C31-4093-84AF-18BB-093D924B8738": {
                "item_id": "DDC66C31-4093-84AF-18BB-093D924B8738",
                "item_name": "Piloted",
                "variable_name": "piloted",
                "status_type": "bane"
            },
            "FF8D219A-2A83-0EE5-A222-E748753E8D0B": {
                "item_id": "FF8D219A-2A83-0EE5-A222-E748753E8D0B",
                "item_name": "Riding",
                "variable_name": "riding",
                "status_type": "boon"
            },
            "680EFB9E-3CFB-491F-A620-5BABF800131C": {
                "item_id": "680EFB9E-3CFB-491F-A620-5BABF800131C",
                "item_name": "Mounted",
                "variable_name": "mounted",
                "status_type": "bane"
            },
            "F13F6A58-FE91-F24D-12BE-BE7CCAD81A40": {
                "item_id": "F13F6A58-FE91-F24D-12BE-BE7CCAD81A40",
                "item_name": "Ridden",
                "variable_name": "ridden",
                "status_type": "bane"
            },
            "E2054884-038E-3D6E-56C5-19ABBFED8379": {
                "item_id": "E2054884-038E-3D6E-56C5-19ABBFED8379",
                "item_name": "Obscured",
                "variable_name": "obscured",
                "status_type": "boon"
            },
            "1BA5473E-6218-6688-1C68-DCA4FEF00A97": {
                "item_id": "1BA5473E-6218-6688-1C68-DCA4FEF00A97",
                "item_name": "Sneaking",
                "variable_name": "sneaking",
                "status_type": "bane"
            },
            "47667406-1B72-9D60-310B-D8CF6BFE397D": {
                "item_id": "47667406-1B72-9D60-310B-D8CF6BFE397D",
                "item_name": "Hidden",
                "variable_name": "hidden",
                "status_type": "boon"
            },
            "84B91EEB-2FA6-D1CB-1347-75BFBDA2A6DD": {
                "item_id": "84B91EEB-2FA6-D1CB-1347-75BFBDA2A6DD",
                "item_name": "Invisible",
                "variable_name": "invisible",
                "status_type": "boon"
            },
            "B6232175-C357-9A97-0ACA-7ECC67563635": {
                "item_id": "B6232175-C357-9A97-0ACA-7ECC67563635",
                "item_name": "Greater Invisible",
                "variable_name": "greater_invisible",
                "status_type": "boon"
            },
            "2A2845CD-949F-06E2-E6B2-98CFD5603241": {
                "item_id": "2A2845CD-949F-06E2-E6B2-98CFD5603241",
                "item_name": "Ethereal",
                "variable_name": "ethereal",
                "status_type": "boon"
            },
            "B9693027-E65E-DAFF-B2C5-7CF31927184D": {
                "item_id": "B9693027-E65E-DAFF-B2C5-7CF31927184D",
                "item_name": "Flanked",
                "variable_name": "flanked",
                "status_type": "bane"
            },
            "3A2FD2B0-28A9-62D3-CB13-A22974618CDB": {
                "item_id": "3A2FD2B0-28A9-62D3-CB13-A22974618CDB",
                "item_name": "Partial Cover",
                "variable_name": "partial_cover",
                "status_type": "boon"
            },
            "A126C1D6-FE3E-5578-DCC6-CBBF8742E9C1": {
                "item_id": "A126C1D6-FE3E-5578-DCC6-CBBF8742E9C1",
                "item_name": "Full Cover",
                "variable_name": "full_cover",
                "status_type": "boon"
            },
            "BE6DC590-4EB7-B297-5AC6-8E47AA4E00EF": {
                "item_id": "BE6DC590-4EB7-B297-5AC6-8E47AA4E00EF",
                "item_name": "Hunkered Down",
                "variable_name": "hunkered_down",
                "status_type": "boon"
            },
            "306CD53D-AD03-DD13-FDDF-34D9120613CD": {
                "item_id": "306CD53D-AD03-DD13-FDDF-34D9120613CD",
                "item_name": "Encumbered",
                "variable_name": "encumbered",
                "status_type": "bane"
            },
            "49F87D1B-3878-789E-D52E-65BA7F2F4218": {
                "item_id": "49F87D1B-3878-789E-D52E-65BA7F2F4218",
                "item_name": "Heavily Encumbered",
                "variable_name": "heavily_encumbered",
                "status_type": "bane"
            },
            "1AEA950E-A57E-6059-448A-E4A6FCED97A3": {
                "item_id": "1AEA950E-A57E-6059-448A-E4A6FCED97A3",
                "item_name": "Shield Encumbered",
                "variable_name": "shield_encumbered",
                "status_type": "bane"
            },
            "466374FE-D89C-DB77-1809-7249A831015D": {
                "item_id": "466374FE-D89C-DB77-1809-7249A831015D",
                "item_name": "Armor Encumbered",
                "variable_name": "armor_encumbered",
                "status_type": "bane"
            },
            "10278E95-5320-A57E-471F-C3E7AEFA70BA": {
                "item_id": "10278E95-5320-A57E-471F-C3E7AEFA70BA",
                "item_name": "Bolstered",
                "variable_name": "bolstered",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "EB6FB558-7427-A647-8F46-D2E8C25F1F60": {
                "item_id": "EB6FB558-7427-A647-8F46-D2E8C25F1F60",
                "item_name": "Exhausted",
                "variable_name": "exhausted",
                "status_type": "bane"
            },
            "BF31EE0A-5B3C-370B-0118-96B067CFD929": {
                "item_id": "BF31EE0A-5B3C-370B-0118-96B067CFD929",
                "item_name": "Paralyzed",
                "variable_name": "paralyzed",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "F2CD1603-38A4-85E9-D148-CE3D429310A2": {
                "item_id": "F2CD1603-38A4-85E9-D148-CE3D429310A2",
                "item_name": "Banished",
                "variable_name": "banished",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "D218F4FB-5693-87B9-93C1-776FC1F7ED90": {
                "item_id": "D218F4FB-5693-87B9-93C1-776FC1F7ED90",
                "item_name": "Stunned",
                "variable_name": "stunned",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "B404E7CA-C073-473E-A799-A71601A22DE5": {
                "item_id": "B404E7CA-C073-473E-A799-A71601A22DE5",
                "item_name": "Dazed",
                "variable_name": "dazed",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "6CCB9287-4420-962A-2952-7469394A5C7A": {
                "item_id": "6CCB9287-4420-962A-2952-7469394A5C7A",
                "item_name": "Backlash",
                "variable_name": "backlash",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "DD4C0995-C3D2-43A3-CFC7-226C3005274C": {
                "item_id": "DD4C0995-C3D2-43A3-CFC7-226C3005274C",
                "item_name": "Charmed",
                "variable_name": "charmed",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "D2E7BA2C-562D-D4AC-7F71-13E4AC540484": {
                "item_id": "D2E7BA2C-562D-D4AC-7F71-13E4AC540484",
                "item_name": "Dominated",
                "variable_name": "dominated",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "185D46F5-09E2-1921-F721-FDD0A2AB3EFC": {
                "item_id": "185D46F5-09E2-1921-F721-FDD0A2AB3EFC",
                "item_name": "Possessed",
                "variable_name": "possessed",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "E4A34093-AAAB-6453-BCE0-FBA65EE263AD": {
                "item_id": "E4A34093-AAAB-6453-BCE0-FBA65EE263AD",
                "item_name": "Grappling",
                "variable_name": "grappling",
                "status_type": "boon"
            },
            "0C2A8037-B0BC-8300-C818-198881B00E7D": {
                "item_id": "0C2A8037-B0BC-8300-C818-198881B00E7D",
                "item_name": "Grappled",
                "variable_name": "grappled",
                "status_type": "bane"
            },
            "E34AF232-5438-88FC-9A9F-73850CCCFD51": {
                "item_id": "E34AF232-5438-88FC-9A9F-73850CCCFD51",
                "item_name": "Restrained",
                "variable_name": "restrained",
                "status_type": "bane"
            },
            "F40E19A3-FC86-187F-050E-8C8B69761353": {
                "item_id": "F40E19A3-FC86-187F-050E-8C8B69761353",
                "item_name": "Immobile",
                "variable_name": "immobile",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "BC6671F6-DEDF-9C1B-C459-226E7388A00C": {
                "item_id": "BC6671F6-DEDF-9C1B-C459-226E7388A00C",
                "item_name": "Slowed",
                "variable_name": "slowed",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "90D15611-2833-46D6-A72E-04C16C87972F": {
                "item_id": "90D15611-2833-46D6-A72E-04C16C87972F",
                "item_name": "Hindered",
                "variable_name": "hindered",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "9FD8A4D0-B09B-C068-D475-7EAB358D1A1E": {
                "item_id": "9FD8A4D0-B09B-C068-D475-7EAB358D1A1E",
                "item_name": "Hamstrung",
                "variable_name": "hamstrung",
                "status_type": "bane"
            },
            "64318AE9-0187-4C71-9163-084694BCE180": {
                "item_id": "64318AE9-0187-4C71-9163-084694BCE180",
                "item_name": "Sluggish",
                "variable_name": "sluggish",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "75B1C2F6-8E21-0ED0-32AD-C49B68804CCC": {
                "item_id": "75B1C2F6-8E21-0ED0-32AD-C49B68804CCC",
                "item_name": "Rushed",
                "variable_name": "rushed",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "091B2BEE-7F61-D7DB-0CF1-6D255F4B7663": {
                "item_id": "091B2BEE-7F61-D7DB-0CF1-6D255F4B7663",
                "item_name": "Hasted",
                "variable_name": "hasted",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "EAA88590-DB1D-7C46-F523-E87A31912777": {
                "item_id": "EAA88590-DB1D-7C46-F523-E87A31912777",
                "item_name": "Dizzy",
                "variable_name": "dizzy",
                "status_type": "bane"
            },
            "9853CC89-CE34-4077-5453-59605542265C": {
                "item_id": "9853CC89-CE34-4077-5453-59605542265C",
                "item_name": "Staggered",
                "variable_name": "staggered",
                "status_type": "bane"
            },
            "BE55F5A2-74F7-63D0-D169-900934E2E26E": {
                "item_id": "BE55F5A2-74F7-63D0-D169-900934E2E26E",
                "item_name": "Impaired",
                "variable_name": "impaired",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "3AD27E05-55EB-4B79-83F6-FC88ADEBD342": {
                "item_id": "3AD27E05-55EB-4B79-83F6-FC88ADEBD342",
                "item_name": "Exposed",
                "variable_name": "exposed",
                "status_type": "bane"
            },
            "75682F12-AB67-401B-97D7-F1B7354333CA": {
                "item_id": "75682F12-AB67-401B-97D7-F1B7354333CA",
                "item_name": "Squeezed",
                "variable_name": "squeezed",
                "status_type": "bane"
            },
            "B45813FE-321A-EC7F-F008-12B8FD33B524": {
                "item_id": "B45813FE-321A-EC7F-F008-12B8FD33B524",
                "item_name": "Very Squeezed",
                "variable_name": "very_squeezed",
                "status_type": "bane"
            },
            "98FEA101-0910-41AE-9E20-E126C8B73AFC": {
                "item_id": "98FEA101-0910-41AE-9E20-E126C8B73AFC",
                "item_name": "Protected",
                "variable_name": "protected",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "256BCFFB-B0BF-7C7A-B238-3126CA2AC20C": {
                "item_id": "256BCFFB-B0BF-7C7A-B238-3126CA2AC20C",
                "item_name": "Powerful",
                "variable_name": "powerful",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "091CBC18-FF1D-6072-3190-90EFAEDDE6F5": {
                "item_id": "091CBC18-FF1D-6072-3190-90EFAEDDE6F5",
                "item_name": "Greater Powerful",
                "variable_name": "greater_powerful",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "C518B122-A108-4EA3-B140-E6211C1071BB": {
                "item_id": "C518B122-A108-4EA3-B140-E6211C1071BB",
                "item_name": "Empowered",
                "variable_name": "empowered",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "B49068EF-8A0A-0002-3476-E214504C3570": {
                "item_id": "B49068EF-8A0A-0002-3476-E214504C3570",
                "item_name": "Weakened",
                "variable_name": "weakened",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "CAD2A16E-0DB5-91C5-F7F4-24F46B28011C": {
                "item_id": "CAD2A16E-0DB5-91C5-F7F4-24F46B28011C",
                "item_name": "Greater Weakened",
                "variable_name": "greater_weakened",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "F450C824-98D3-D0B1-D6B1-C326F15F1578": {
                "item_id": "F450C824-98D3-D0B1-D6B1-C326F15F1578",
                "item_name": "Enfeebled",
                "variable_name": "enfeebled",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "DD53CA8E-DF3D-9AF4-49CB-9C61926BBB93": {
                "item_id": "DD53CA8E-DF3D-9AF4-49CB-9C61926BBB93",
                "item_name": "Defenseless",
                "variable_name": "defenseless",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "F55C0D31-091D-0F3F-74F0-AEE4C20BE1ED": {
                "item_id": "F55C0D31-091D-0F3F-74F0-AEE4C20BE1ED",
                "item_name": "Vulnerable",
                "variable_name": "vulnerable",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "60912827-B1B3-E9D7-6FBF-1FE976DDD04E": {
                "item_id": "60912827-B1B3-E9D7-6FBF-1FE976DDD04E",
                "item_name": "Shelled",
                "variable_name": "shelled",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "8912E655-C826-4CF6-8F3C-B036AC710CE3": {
                "item_id": "8912E655-C826-4CF6-8F3C-B036AC710CE3",
                "item_name": "Resistant",
                "variable_name": "resistant",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "1194F357-C419-2931-27B4-3B56F26BFBA7": {
                "item_id": "1194F357-C419-2931-27B4-3B56F26BFBA7",
                "item_name": "Invulnerable",
                "variable_name": "invulnerable",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "88F8F0BA-3E96-4D9C-AFCE-008D849B0BFC": {
                "item_id": "88F8F0BA-3E96-4D9C-AFCE-008D849B0BFC",
                "item_name": "Hunger and Thirst Tick",
                "variable_name": "hunger_and_thirst_tick",
                "status_type": "none"
            },
            "6FAF0CD0-26E2-60A3-0608-A3C8E1828027": {
                "item_id": "6FAF0CD0-26E2-60A3-0608-A3C8E1828027",
                "item_name": "Thirsty",
                "variable_name": "thirsty",
                "status_type": "bane"
            },
            "C1F4E2B6-DA45-8CAC-322D-C5DF54FFC418": {
                "item_id": "C1F4E2B6-DA45-8CAC-322D-C5DF54FFC418",
                "item_name": "Parched",
                "variable_name": "parched",
                "status_type": "bane"
            },
            "2611657A-9C0A-4680-AB51-62235A6D8D79": {
                "item_id": "2611657A-9C0A-4680-AB51-62235A6D8D79",
                "item_name": "Desiccating",
                "variable_name": "desiccating",
                "status_type": "bane"
            },
            "5672B433-B59D-561E-B4C6-79565C46B3CA": {
                "item_id": "5672B433-B59D-561E-B4C6-79565C46B3CA",
                "item_name": "Hungry",
                "variable_name": "hungry",
                "status_type": "bane"
            },
            "7780B669-28AA-680E-D28D-397B05A15FC6": {
                "item_id": "7780B669-28AA-680E-D28D-397B05A15FC6",
                "item_name": "Starving",
                "variable_name": "starving",
                "status_type": "bane"
            },
            "457ADEAA-1D5D-9AB4-EFC9-2B7120C78BAA": {
                "item_id": "457ADEAA-1D5D-9AB4-EFC9-2B7120C78BAA",
                "item_name": "Petrified",
                "variable_name": "petrified",
                "status_type": "bane"
            },
            "DFCF49C0-D5BC-C56F-A7C5-DC8D134ED7D7": {
                "item_id": "DFCF49C0-D5BC-C56F-A7C5-DC8D134ED7D7",
                "item_name": "Petrifying",
                "variable_name": "petrifying",
                "status_type": "bane",
                "transitional": {
                    "progresses_to": "petrified",
                    "retry_skill": "fortitude",
                    "retry_dc": 10
                }
            },
            "3BE713AB-37D7-630B-C1F8-9470784BA33E": {
                "item_id": "3BE713AB-37D7-630B-C1F8-9470784BA33E",
                "item_name": "Bleeding",
                "variable_name": "bleeding",
                "status_type": "bane"
            },
            "22E33A8E-DF5D-2596-8E2D-0E8A8528E47C": {
                "item_id": "22E33A8E-DF5D-2596-8E2D-0E8A8528E47C",
                "item_name": "Moderate Bleeding",
                "variable_name": "moderate_bleeding",
                "status_type": "bane"
            },
            "BAAA237B-1AA7-0409-5BC7-1A6720573069": {
                "item_id": "BAAA237B-1AA7-0409-5BC7-1A6720573069",
                "item_name": "Severe Bleeding",
                "variable_name": "severe_bleeding",
                "status_type": "bane"
            },
            "A5CDC77C-D224-DD5F-291B-EF8DF2EA443D": {
                "item_id": "A5CDC77C-D224-DD5F-291B-EF8DF2EA443D",
                "item_name": "Maimed",
                "variable_name": "maimed",
                "status_type": "bane"
            },
            "9437F344-1461-B4C0-E196-6BA1A34ADC94": {
                "item_id": "9437F344-1461-B4C0-E196-6BA1A34ADC94",
                "item_name": "Maimed 1",
                "variable_name": "maimed_1",
                "status_type": "bane"
            },
            "9154FF1F-721A-2BCA-1AEF-24AC7B32FE4B": {
                "item_id": "9154FF1F-721A-2BCA-1AEF-24AC7B32FE4B",
                "item_name": "Maimed 2",
                "variable_name": "maimed_2",
                "status_type": "bane"
            },
            "46F27428-2B73-50F7-6F0C-D4FAFDB753ED": {
                "item_id": "46F27428-2B73-50F7-6F0C-D4FAFDB753ED",
                "item_name": "Maimed 3",
                "variable_name": "maimed_3",
                "status_type": "bane"
            },
            "4D27433B-6F72-47BB-9A60-B80493F22D65": {
                "item_id": "4D27433B-6F72-47BB-9A60-B80493F22D65",
                "item_name": "Maimed 4",
                "variable_name": "maimed_4",
                "status_type": "bane"
            },
            "E4994653-49B3-D768-35C1-36C8DE40CC1A": {
                "item_id": "E4994653-49B3-D768-35C1-36C8DE40CC1A",
                "item_name": "Maimed 5",
                "variable_name": "maimed_5",
                "status_type": "bane"
            },
            "5C557D5A-B85F-DF45-3CF6-6739D2BD70EC": {
                "item_id": "5C557D5A-B85F-DF45-3CF6-6739D2BD70EC",
                "item_name": "Maimed 6",
                "variable_name": "maimed_6",
                "status_type": "bane"
            },
            "44D4504C-9BD5-0B65-F8E2-6DC4A0F820B4": {
                "item_id": "44D4504C-9BD5-0B65-F8E2-6DC4A0F820B4",
                "item_name": "Maimed 7",
                "variable_name": "maimed_7",
                "status_type": "bane"
            },
            "1DEE12B6-D23A-7470-812E-CE4C77AAD395": {
                "item_id": "1DEE12B6-D23A-7470-812E-CE4C77AAD395",
                "item_name": "Maimed 8",
                "variable_name": "maimed_8",
                "status_type": "bane"
            },
            "4AEF8F40-B779-C0AD-4455-2DABE7B1D14B": {
                "item_id": "4AEF8F40-B779-C0AD-4455-2DABE7B1D14B",
                "item_name": "Maimed 9",
                "variable_name": "maimed_9",
                "status_type": "bane"
            },
            "A230F5E6-B6AD-8091-4F59-5E454776B4FA": {
                "item_id": "A230F5E6-B6AD-8091-4F59-5E454776B4FA",
                "item_name": "Maimed 10",
                "variable_name": "maimed_10",
                "status_type": "bane"
            },
            "CEF623E6-6A71-37FD-29C7-12988B43151A": {
                "item_id": "CEF623E6-6A71-37FD-29C7-12988B43151A",
                "item_name": "Arcane Fatigue",
                "variable_name": "arcane_fatigue",
                "status_type": "bane"
            },
            "F8E5F274-2F31-1340-6167-ED9131E81A88": {
                "item_id": "F8E5F274-2F31-1340-6167-ED9131E81A88",
                "item_name": "Arcane Fatigue 1",
                "variable_name": "arcane_fatigue_1",
                "status_type": "bane"
            },
            "E18A79D1-AA69-7F80-2579-78B583E0771B": {
                "item_id": "E18A79D1-AA69-7F80-2579-78B583E0771B",
                "item_name": "Arcane Fatigue 2",
                "variable_name": "arcane_fatigue_2",
                "status_type": "bane"
            },
            "20F461C2-67CC-BEF6-E02A-4E9A464EC397": {
                "item_id": "20F461C2-67CC-BEF6-E02A-4E9A464EC397",
                "item_name": "Arcane Fatigue 3",
                "variable_name": "arcane_fatigue_3",
                "status_type": "bane"
            },
            "EF165E68-DD93-90C8-A848-01D93B041CBD": {
                "item_id": "EF165E68-DD93-90C8-A848-01D93B041CBD",
                "item_name": "Arcane Fatigue 4",
                "variable_name": "arcane_fatigue_4",
                "status_type": "bane"
            },
            "DA5A18C5-FDE5-D20B-0E3B-07B68E6C7C1C": {
                "item_id": "DA5A18C5-FDE5-D20B-0E3B-07B68E6C7C1C",
                "item_name": "Arcane Fatigue 5",
                "variable_name": "arcane_fatigue_5",
                "status_type": "bane"
            },
            "683632D7-756C-0165-9E94-27EA95A53A53": {
                "item_id": "683632D7-756C-0165-9E94-27EA95A53A53",
                "item_name": "Arcane Fatigue 6",
                "variable_name": "arcane_fatigue_6",
                "status_type": "bane"
            },
            "E19F0AB8-E760-D84A-85C3-1A14E7DFE399": {
                "item_id": "E19F0AB8-E760-D84A-85C3-1A14E7DFE399",
                "item_name": "Arcane Fatigue 7",
                "variable_name": "arcane_fatigue_7",
                "status_type": "bane"
            },
            "5F87B80F-A8E4-A3BE-6FC6-3B5BC0A669E9": {
                "item_id": "5F87B80F-A8E4-A3BE-6FC6-3B5BC0A669E9",
                "item_name": "Arcane Fatigue 8",
                "variable_name": "arcane_fatigue_8",
                "status_type": "bane"
            },
            "E29189CC-A2FA-B06A-5DBD-8551A3259829": {
                "item_id": "E29189CC-A2FA-B06A-5DBD-8551A3259829",
                "item_name": "Arcane Fatigue 9",
                "variable_name": "arcane_fatigue_9",
                "status_type": "bane"
            },
            "BDAF9378-AA7A-445F-D24F-8E6A0EE84456": {
                "item_id": "BDAF9378-AA7A-445F-D24F-8E6A0EE84456",
                "item_name": "Arcane Fatigue 10",
                "variable_name": "arcane_fatigue_10",
                "status_type": "bane"
            },
            "4744C91C-51DC-4C36-8C6E-DB801410FF61": {
                "item_id": "4744C91C-51DC-4C36-8C6E-DB801410FF61",
                "item_name": "Blighted",
                "variable_name": "blighted",
                "status_type": "bane"
            },
            "5CB84B6E-E636-B4A3-3864-910DBD3B63B4": {
                "item_id": "5CB84B6E-E636-B4A3-3864-910DBD3B63B4",
                "item_name": "Blighted 1",
                "variable_name": "blighted_1",
                "status_type": "bane"
            },
            "1B912A78-2334-D265-2674-7AD764534D56": {
                "item_id": "1B912A78-2334-D265-2674-7AD764534D56",
                "item_name": "Blighted 2",
                "variable_name": "blighted_2",
                "status_type": "bane"
            },
            "7F938839-F44A-FA43-05FA-BAAF79B7A05B": {
                "item_id": "7F938839-F44A-FA43-05FA-BAAF79B7A05B",
                "item_name": "Blighted 3",
                "variable_name": "blighted_3",
                "status_type": "bane"
            },
            "FCC88F77-777D-56B1-913E-E676C90E39E3": {
                "item_id": "FCC88F77-777D-56B1-913E-E676C90E39E3",
                "item_name": "Blighted 4",
                "variable_name": "blighted_4",
                "status_type": "bane"
            },
            "655383C0-8B0C-3B33-694D-26404400626D": {
                "item_id": "655383C0-8B0C-3B33-694D-26404400626D",
                "item_name": "Blighted 5",
                "variable_name": "blighted_5",
                "status_type": "bane"
            },
            "36B68995-C875-199D-20E8-1A1098F846B0": {
                "item_id": "36B68995-C875-199D-20E8-1A1098F846B0",
                "item_name": "Blighted 6",
                "variable_name": "blighted_6",
                "status_type": "bane"
            },
            "D9668790-E866-861A-FDE0-D23D2903B0FA": {
                "item_id": "D9668790-E866-861A-FDE0-D23D2903B0FA",
                "item_name": "Blighted 7",
                "variable_name": "blighted_7",
                "status_type": "bane"
            },
            "90D143BD-9CC9-06F7-F339-03F50C27D958": {
                "item_id": "90D143BD-9CC9-06F7-F339-03F50C27D958",
                "item_name": "Blighted 8",
                "variable_name": "blighted_8",
                "status_type": "bane"
            },
            "8A3B8D76-ED7A-560A-166D-73093DE6F4E9": {
                "item_id": "8A3B8D76-ED7A-560A-166D-73093DE6F4E9",
                "item_name": "Blighted 9",
                "variable_name": "blighted_9",
                "status_type": "bane"
            },
            "E64821CE-A9A5-D2C3-4116-8A8D5DCA4D30": {
                "item_id": "E64821CE-A9A5-D2C3-4116-8A8D5DCA4D30",
                "item_name": "Blighted 10",
                "variable_name": "blighted_10",
                "status_type": "bane"
            },
            "EB6632D3-5EC0-4E4D-5C6C-1BCB7EF57022": {
                "item_id": "EB6632D3-5EC0-4E4D-5C6C-1BCB7EF57022",
                "item_name": "Shielded",
                "variable_name": "shielded",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "BF823982-6FC8-51F0-F452-5BE1C949FBA6": {
                "item_id": "BF823982-6FC8-51F0-F452-5BE1C949FBA6",
                "item_name": "Shielded 1",
                "variable_name": "shielded_1",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "36DA5B89-CA08-3940-E798-FCAE6BE775D5": {
                "item_id": "36DA5B89-CA08-3940-E798-FCAE6BE775D5",
                "item_name": "Shielded 2",
                "variable_name": "shielded_2",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "8346CCFF-3A5B-F0E4-CFDE-6CF1D1ED3368": {
                "item_id": "8346CCFF-3A5B-F0E4-CFDE-6CF1D1ED3368",
                "item_name": "Shielded 3",
                "variable_name": "shielded_3",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "E5314BED-1269-3A65-8C15-01E80A3A8E23": {
                "item_id": "E5314BED-1269-3A65-8C15-01E80A3A8E23",
                "item_name": "Shielded 4",
                "variable_name": "shielded_4",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "E614D75F-CF27-D169-3D91-0D33D9CE354B": {
                "item_id": "E614D75F-CF27-D169-3D91-0D33D9CE354B",
                "item_name": "Shielded 5",
                "variable_name": "shielded_5",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "A831D8E0-4DC5-4FBF-4A4C-2C9955AE230A": {
                "item_id": "A831D8E0-4DC5-4FBF-4A4C-2C9955AE230A",
                "item_name": "Shielded 6",
                "variable_name": "shielded_6",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "631AAD91-F6A5-879D-5BD6-B7F885AA7FC9": {
                "item_id": "631AAD91-F6A5-879D-5BD6-B7F885AA7FC9",
                "item_name": "Shielded 7",
                "variable_name": "shielded_7",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "BF1C1C48-8171-90B8-CD83-F2768348629F": {
                "item_id": "BF1C1C48-8171-90B8-CD83-F2768348629F",
                "item_name": "Shielded 8",
                "variable_name": "shielded_8",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "2A63EC91-E5B1-17B4-DFB0-199F9E2084A5": {
                "item_id": "2A63EC91-E5B1-17B4-DFB0-199F9E2084A5",
                "item_name": "Shielded 9",
                "variable_name": "shielded_9",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "01B0F693-7D8A-C588-9B34-CD1F323D8433": {
                "item_id": "01B0F693-7D8A-C588-9B34-CD1F323D8433",
                "item_name": "Shielded 10",
                "variable_name": "shielded_10",
                "status_type": "boon",
                "ends_on_caster_death": true
            },
            "D98B076A-3A38-E225-B8E3-A646C69AA29D": {
                "item_id": "D98B076A-3A38-E225-B8E3-A646C69AA29D",
                "item_name": "Judgement",
                "variable_name": "judgement",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "430F1BE4-6522-4468-8E27-426B23D003BF": {
                "item_id": "430F1BE4-6522-4468-8E27-426B23D003BF",
                "item_name": "Judgement 1",
                "variable_name": "judgement_1",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "9EFD0898-7C92-6DE4-DD2F-D6F75ECF3B58": {
                "item_id": "9EFD0898-7C92-6DE4-DD2F-D6F75ECF3B58",
                "item_name": "Judgement 2",
                "variable_name": "judgement_2",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "90FB0BFB-6186-5E01-FD8B-0315D6DFB809": {
                "item_id": "90FB0BFB-6186-5E01-FD8B-0315D6DFB809",
                "item_name": "Judgement 3",
                "variable_name": "judgement_3",
                "status_type": "bane",
                "ends_on_caster_death": true
            },
            "CDC5CFDA-B09C-4A68-820D-6C74D90BD595": {
                "item_id": "CDC5CFDA-B09C-4A68-820D-6C74D90BD595",
                "item_name": "Mirror Images",
                "variable_name": "mirror_image_effect",
                "status_type": "boon"
            },
            "D9B64F38-A817-47B8-AB07-60D59F3D893C": {
                "item_id": "D9B64F38-A817-47B8-AB07-60D59F3D893C",
                "item_name": "Mirror Image 1",
                "variable_name": "mirror_image_1",
                "status_type": "boon"
            },
            "AE20C09B-76BE-5BC4-4E33-6E8CFE1F0139": {
                "item_id": "AE20C09B-76BE-5BC4-4E33-6E8CFE1F0139",
                "item_name": "Mirror Image 2",
                "variable_name": "mirror_image_2",
                "status_type": "boon"
            },
            "479A4B5C-43F3-3559-979B-5BDA8A379F07": {
                "item_id": "479A4B5C-43F3-3559-979B-5BDA8A379F07",
                "item_name": "Mirror Image 3",
                "variable_name": "mirror_image_3",
                "status_type": "boon"
            },
            "80585488-CC4B-4A80-8ECE-CB1CE83F2407": {
                "item_id": "80585488-CC4B-4A80-8ECE-CB1CE83F2407",
                "item_name": "Fully Rested",
                "variable_name": "fully_rested",
                "status_type": "none"
            },
            "82788F70-EBEF-44C4-80E7-6622AD20DD60": {
                "item_id": "82788F70-EBEF-44C4-80E7-6622AD20DD60",
                "item_name": "Invigorated",
                "variable_name": "invigorated",
                "status_type": "none"
            },
            "FF30B76E-785D-2CAF-FC66-C131D0548808": {
                "item_id": "FF30B76E-785D-2CAF-FC66-C131D0548808",
                "item_name": "Fresh",
                "variable_name": "fresh",
                "status_type": "none"
            },
            "658483AA-34DE-74E5-C974-E3E202C31CC7": {
                "item_id": "658483AA-34DE-74E5-C974-E3E202C31CC7",
                "item_name": "Barely Wounded",
                "variable_name": "barely_wounded",
                "status_type": "none"
            },
            "C97076EF-FED9-19B4-D109-C22F9BC740E8": {
                "item_id": "C97076EF-FED9-19B4-D109-C22F9BC740E8",
                "item_name": "Wounded",
                "variable_name": "wounded",
                "status_type": "none"
            },
            "44B8792E-632E-2651-C666-67DFD181E92A": {
                "item_id": "44B8792E-632E-2651-C666-67DFD181E92A",
                "item_name": "Bloodied",
                "variable_name": "bloodied",
                "status_type": "none"
            },
            "298BE1DD-2917-476E-D79C-92CF8C598926": {
                "item_id": "298BE1DD-2917-476E-D79C-92CF8C598926",
                "item_name": "Well Bloodied",
                "variable_name": "well_bloodied",
                "status_type": "none"
            },
            "D5DE14C4-3194-87BC-D767-6D45BDD90552": {
                "item_id": "D5DE14C4-3194-87BC-D767-6D45BDD90552",
                "item_name": "On Deaths Door",
                "variable_name": "on_deaths_door",
                "status_type": "none"
            },
            "8AE129AF-52D8-CCE8-706A-85767DB52740": {
                "item_id": "8AE129AF-52D8-CCE8-706A-85767DB52740",
                "item_name": "Dying",
                "variable_name": "dying",
                "status_type": "bane"
            },
            "9FEE2E8A-9CF7-D74D-5D16-B86C2603A1FA": {
                "item_id": "9FEE2E8A-9CF7-D74D-5D16-B86C2603A1FA",
                "item_name": "Dead",
                "variable_name": "dead",
                "status_type": "bane"
            },
            "F07C595F-D2DC-4CE9-904E-A4D73ABF9DEA": {
                "item_id": "F07C595F-D2DC-4CE9-904E-A4D73ABF9DEA",
                "item_name": "Stabilized",
                "variable_name": "stabilized",
                "status_type": "boon"
            },
            "99C862B9-D6AE-4E18-7803-A6F9B42A88E1": {
                "item_id": "99C862B9-D6AE-4E18-7803-A6F9B42A88E1",
                "item_name": "Crippled",
                "variable_name": "crippled",
                "status_type": "bane"
            },
            "78C6CC42-BCCE-4F22-9FC5-41F8D7E70944": {
                "item_id": "78C6CC42-BCCE-4F22-9FC5-41F8D7E70944",
                "item_name": "Dying State",
                "variable_name": "dying_state",
                "status_type": "bane"
            },
            "EE063289-1AF3-41CF-B73C-64A0556E6D07": {
                "item_id": "EE063289-1AF3-41CF-B73C-64A0556E6D07",
                "item_name": "Dying State 1",
                "variable_name": "dying_state_1",
                "status_type": "bane"
            },
            "2EAAA2E8-1B9C-196D-3E58-C29C09FF8492": {
                "item_id": "2EAAA2E8-1B9C-196D-3E58-C29C09FF8492",
                "item_name": "Dying State 2",
                "variable_name": "dying_state_2",
                "status_type": "bane"
            },
            "A9678CB1-11D3-55A3-E3C9-F342B2E40980": {
                "item_id": "A9678CB1-11D3-55A3-E3C9-F342B2E40980",
                "item_name": "Dying State 3",
                "variable_name": "dying_state_3",
                "status_type": "bane"
            },
            "611DFED0-9AD1-5500-AF5B-DE7CBD9DDF64": {
                "item_id": "611DFED0-9AD1-5500-AF5B-DE7CBD9DDF64",
                "item_name": "Recovery State",
                "variable_name": "recovery_state",
                "status_type": "boon"
            },
            "553734EC-33D3-4527-AB2E-EF48ACED8DF0": {
                "item_id": "553734EC-33D3-4527-AB2E-EF48ACED8DF0",
                "item_name": "Recovery State 1",
                "variable_name": "recovery_state_1",
                "status_type": "boon"
            },
            "9AA7588A-4575-9550-343D-6ADB0C74C17F": {
                "item_id": "9AA7588A-4575-9550-343D-6ADB0C74C17F",
                "item_name": "Recovery State 2",
                "variable_name": "recovery_state_2",
                "status_type": "boon"
            },
            "660E3133-44D8-E79F-C0ED-A26CE31D6E32": {
                "item_id": "660E3133-44D8-E79F-C0ED-A26CE31D6E32",
                "item_name": "Recovery State 3",
                "variable_name": "recovery_state_3",
                "status_type": "boon"
            },
            "62E83DEB-4569-AE3A-F671-FF514C508FD2": {
                "item_id": "62E83DEB-4569-AE3A-F671-FF514C508FD2",
                "item_name": "Rotting",
                "variable_name": "rotting",
                "status_type": "bane"
            },
            "F7A1C3B2-5D64-4E18-9A70-2C8B41D5E093": {
                "item_id": "F7A1C3B2-5D64-4E18-9A70-2C8B41D5E093",
                "item_name": "Spoiling",
                "variable_name": "spoiling",
                "status_type": "bane"
            },
            "10C28483-A0E9-467F-993B-CBC440546A52": {
                "item_id": "10C28483-A0E9-467F-993B-CBC440546A52",
                "item_name": "Received Prayer of Healing",
                "variable_name": "received_prayer_of_healing",
                "status_type": "none"
            }
        },
        "sun_state": {
            "E4B7F803-C689-A9A5-0FB7-EB8D9946874E": {
                "item_id": "E4B7F803-C689-A9A5-0FB7-EB8D9946874E",
                "item_name": "Sun State Night",
                "item_type": "sun_state",
                "variable_name": "sun_state_night"
            },
            "04494E0F-FD0B-B2E7-3E15-94922127ADA2": {
                "item_id": "04494E0F-FD0B-B2E7-3E15-94922127ADA2",
                "item_name": "Sun State Sunrise",
                "item_type": "sun_state",
                "variable_name": "sun_state_sunrise"
            },
            "7650DB9F-465F-DDA6-9D7E-E064F4BC910F": {
                "item_id": "7650DB9F-465F-DDA6-9D7E-E064F4BC910F",
                "item_name": "Sun State Day",
                "item_type": "sun_state",
                "variable_name": "sun_state_day"
            },
            "7BA5009E-B362-AE2F-ABB6-D06D54D306EA": {
                "item_id": "7BA5009E-B362-AE2F-ABB6-D06D54D306EA",
                "item_name": "Sun State Sunset",
                "item_type": "sun_state",
                "variable_name": "sun_state_sunset"
            }
        },
        "swarm_template": {
            "C721A8A3-C301-AE2B-B388-D73FE51F65CC": {
                "item_id": "C721A8A3-C301-AE2B-B388-D73FE51F65CC",
                "item_name": "Swarm: 5",
                "item_type": "creature_template",
                "variable_name": "swarm_5",
                "monster_qty": 5,
                "width_lanes": 1
            },
            "B93C548F-95A2-14A0-129C-C6D40B38C7CB": {
                "item_id": "B93C548F-95A2-14A0-129C-C6D40B38C7CB",
                "item_name": "Swarm: 20",
                "item_type": "creature_template",
                "variable_name": "swarm_20",
                "monster_qty": 20,
                "width_lanes": 2
            },
            "BD05AC4E-43DC-BC8F-E5A9-D9AA454A9D2B": {
                "item_id": "BD05AC4E-43DC-BC8F-E5A9-D9AA454A9D2B",
                "item_name": "Swarm: 50",
                "item_type": "creature_template",
                "variable_name": "swarm_50",
                "monster_qty": 50,
                "width_lanes": 3
            },
            "1BE8C9F6-F3E8-2618-7FCC-1956C6C15139": {
                "item_id": "1BE8C9F6-F3E8-2618-7FCC-1956C6C15139",
                "item_name": "Swarm: 200",
                "item_type": "creature_template",
                "variable_name": "swarm_200",
                "monster_qty": 200,
                "width_lanes": 4
            }
        },
        "temperature_band": {
            "407B4AC5-27C4-60AD-FD56-9189FCDC8AE6": {
                "item_id": "407B4AC5-27C4-60AD-FD56-9189FCDC8AE6",
                "item_name": "Frigid",
                "variable_name": "freezing",
                "icon_variable_name": "temperature_frigid"
            },
            "EE3151A4-5BA0-52EB-85C8-B4E829E888BF": {
                "item_id": "EE3151A4-5BA0-52EB-85C8-B4E829E888BF",
                "item_name": "Chill",
                "variable_name": "cold",
                "icon_variable_name": "temperature_chill"
            },
            "126B1B2D-5ED1-1DA4-AE38-34301FAEF2C2": {
                "item_id": "126B1B2D-5ED1-1DA4-AE38-34301FAEF2C2",
                "item_name": "Cool",
                "variable_name": "cool",
                "icon_variable_name": "temperature_cool"
            },
            "4C543268-FEF1-23FE-4AFF-5A01A4F81953": {
                "item_id": "4C543268-FEF1-23FE-4AFF-5A01A4F81953",
                "item_name": "Temperate",
                "variable_name": "temperate",
                "icon_variable_name": "temperature_temperate"
            },
            "02673CAF-5E3B-966B-24EF-A6C8883169D8": {
                "item_id": "02673CAF-5E3B-966B-24EF-A6C8883169D8",
                "item_name": "Warm",
                "variable_name": "warm",
                "icon_variable_name": "temperature_warm"
            },
            "41F03902-005B-8110-850D-B95DC7A01CB3": {
                "item_id": "41F03902-005B-8110-850D-B95DC7A01CB3",
                "item_name": "Hot",
                "variable_name": "hot",
                "icon_variable_name": "temperature_hot"
            },
            "96DC27AA-0BBA-D76C-BA6E-C9DDAD103069": {
                "item_id": "96DC27AA-0BBA-D76C-BA6E-C9DDAD103069",
                "item_name": "Scorching",
                "variable_name": "scorching",
                "icon_variable_name": "temperature_scorching"
            }
        },
        "vitality_status": {
            "82788F70-EBEF-44C4-80E7-6622AD20DD60": {
                "item_id": "82788F70-EBEF-44C4-80E7-6622AD20DD60",
                "item_name": "Invigorated",
                "item_type": "vitality_status",
                "variable_name": "invigorated"
            },
            "FF30B76E-785D-2CAF-FC66-C131D0548808": {
                "item_id": "FF30B76E-785D-2CAF-FC66-C131D0548808",
                "item_name": "Fresh",
                "item_type": "vitality_status",
                "variable_name": "fresh"
            },
            "658483AA-34DE-74E5-C974-E3E202C31CC7": {
                "item_id": "658483AA-34DE-74E5-C974-E3E202C31CC7",
                "item_name": "Barely Wounded",
                "item_type": "vitality_status",
                "variable_name": "barely_wounded"
            },
            "C97076EF-FED9-19B4-D109-C22F9BC740E8": {
                "item_id": "C97076EF-FED9-19B4-D109-C22F9BC740E8",
                "item_name": "Wounded",
                "item_type": "vitality_status",
                "variable_name": "wounded"
            },
            "44B8792E-632E-2651-C666-67DFD181E92A": {
                "item_id": "44B8792E-632E-2651-C666-67DFD181E92A",
                "item_name": "Bloodied",
                "item_type": "vitality_status",
                "variable_name": "bloodied"
            },
            "298BE1DD-2917-476E-D79C-92CF8C598926": {
                "item_id": "298BE1DD-2917-476E-D79C-92CF8C598926",
                "item_name": "Well-Bloodied",
                "item_type": "vitality_status",
                "variable_name": "well_bloodied"
            },
            "D5DE14C4-3194-87BC-D767-6D45BDD90552": {
                "item_id": "D5DE14C4-3194-87BC-D767-6D45BDD90552",
                "item_name": "On Death's Door",
                "item_type": "vitality_status",
                "variable_name": "on_deaths_door"
            },
            "8AE129AF-52D8-CCE8-706A-85767DB52740": {
                "item_id": "8AE129AF-52D8-CCE8-706A-85767DB52740",
                "item_name": "Dying",
                "item_type": "vitality_status",
                "variable_name": "dying"
            },
            "9FEE2E8A-9CF7-D74D-5D16-B86C2603A1FA": {
                "item_id": "9FEE2E8A-9CF7-D74D-5D16-B86C2603A1FA",
                "item_name": "Dead",
                "item_type": "vitality_status",
                "variable_name": "dead"
            }
        },
        "weapon_classification_type": {
            "B66B3311-4A62-5531-D446-CE4A565FD181": {
                "item_id": "B66B3311-4A62-5531-D446-CE4A565FD181",
                "item_name": "Colossal Ranged Weapons",
                "variable_name": "colossal_ranged_weapons",
                "required_passive_for_equip": "5E7E3B4E-3350-448C-E959-0C7A59D4867E",
                "required_feat_for_equip": "9A5C417C-D482-199D-4FDB-2296A7DF6F7F"
            },
            "B12431F6-BB7A-8079-002F-111914B9E65A": {
                "item_id": "B12431F6-BB7A-8079-002F-111914B9E65A",
                "item_name": "Colossal Melee Weapons",
                "variable_name": "colossal_melee_weapons",
                "required_passive_for_equip": "867FE4B0-29AC-B2D9-B91B-CC468789C17D",
                "required_feat_for_equip": "F3298F3D-8106-B017-D009-B66B4F7D7785"
            },
            "AB7DEAAE-62BF-4996-A510-5F2B192F8F14": {
                "item_id": "AB7DEAAE-62BF-4996-A510-5F2B192F8F14",
                "item_name": "Natural Weapon",
                "variable_name": "natural_weapon"
            },
            "F187EE82-1D32-4C53-9F69-E59DDF33D7C7": {
                "item_id": "F187EE82-1D32-4C53-9F69-E59DDF33D7C7",
                "item_name": "Fist Weapons",
                "variable_name": "fist_weapons"
            },
            "6284CE8F-C929-7161-EC43-923DE40F4968": {
                "item_id": "6284CE8F-C929-7161-EC43-923DE40F4968",
                "item_name": "Clubs",
                "variable_name": "clubs"
            },
            "48C941BC-2E9A-CAD8-1DA7-D90AE8DB1768": {
                "item_id": "48C941BC-2E9A-CAD8-1DA7-D90AE8DB1768",
                "item_name": "Sickles",
                "variable_name": "sickles"
            },
            "742A06CA-5870-FA3B-603A-AEE94F5102F5": {
                "item_id": "742A06CA-5870-FA3B-603A-AEE94F5102F5",
                "item_name": "Whips",
                "variable_name": "whips"
            },
            "50740150-28E8-FB76-88BD-216B02569D3F": {
                "item_id": "50740150-28E8-FB76-88BD-216B02569D3F",
                "item_name": "Daggers",
                "variable_name": "daggers"
            },
            "67EFA62C-3A5C-9FEE-D54D-EF7615C063F4": {
                "item_id": "67EFA62C-3A5C-9FEE-D54D-EF7615C063F4",
                "item_name": "Hammers, Light",
                "variable_name": "hammers_light"
            },
            "57B8F98F-460E-7D39-C495-D2E26439391C": {
                "item_id": "57B8F98F-460E-7D39-C495-D2E26439391C",
                "item_name": "Shortswords",
                "variable_name": "shortswords"
            },
            "AFFA2CC1-0468-ABBC-2FA3-40597B8B374D": {
                "item_id": "AFFA2CC1-0468-ABBC-2FA3-40597B8B374D",
                "item_name": "Scimitars",
                "variable_name": "scimitars"
            },
            "5E58B1EB-B2AD-5F54-B4DD-D8DDA5E8BCE3": {
                "item_id": "5E58B1EB-B2AD-5F54-B4DD-D8DDA5E8BCE3",
                "item_name": "Maces",
                "variable_name": "maces"
            },
            "859394A9-EE4A-BD9A-C5A9-7FCD150E7344": {
                "item_id": "859394A9-EE4A-BD9A-C5A9-7FCD150E7344",
                "item_name": "Handaxes",
                "variable_name": "handaxes"
            },
            "2FB5E21A-7A0A-E4B8-604D-3A0A60A34172": {
                "item_id": "2FB5E21A-7A0A-E4B8-604D-3A0A60A34172",
                "item_name": "Javelins",
                "variable_name": "javelins"
            },
            "12D25118-B86A-80A5-01BC-C9427BD83D17": {
                "item_id": "12D25118-B86A-80A5-01BC-C9427BD83D17",
                "item_name": "Quarterstaffs",
                "variable_name": "quarterstaffs"
            },
            "7D08EF0E-0D7D-8CB0-70FA-0C741AF438E5": {
                "item_id": "7D08EF0E-0D7D-8CB0-70FA-0C741AF438E5",
                "item_name": "Spears",
                "variable_name": "spears"
            },
            "CF8B21A5-32CE-7E43-22E3-ABC56C457628": {
                "item_id": "CF8B21A5-32CE-7E43-22E3-ABC56C457628",
                "item_name": "Tridents",
                "variable_name": "tridents"
            },
            "2F238366-80B8-2BCF-EC81-387CE1A5D4DF": {
                "item_id": "2F238366-80B8-2BCF-EC81-387CE1A5D4DF",
                "item_name": "Rapiers",
                "variable_name": "rapiers"
            },
            "622AEA0A-D1A6-FB1C-83B4-FC67807D9197": {
                "item_id": "622AEA0A-D1A6-FB1C-83B4-FC67807D9197",
                "item_name": "War Picks",
                "variable_name": "war_picks"
            },
            "AD9D5036-D2CF-1C6A-9785-CCB5D35B96B5": {
                "item_id": "AD9D5036-D2CF-1C6A-9785-CCB5D35B96B5",
                "item_name": "Morningstars",
                "variable_name": "morningstars"
            },
            "D5906717-7237-CA1D-B089-18CF323A04DB": {
                "item_id": "D5906717-7237-CA1D-B089-18CF323A04DB",
                "item_name": "Flails",
                "variable_name": "flails"
            },
            "B5ECBC44-BAB8-E6B2-0D1C-CC2A5082BDD2": {
                "item_id": "B5ECBC44-BAB8-E6B2-0D1C-CC2A5082BDD2",
                "item_name": "Greatclubs",
                "variable_name": "greatclubs"
            },
            "DE15C4F8-2710-8187-3788-2DA46D8724B8": {
                "item_id": "DE15C4F8-2710-8187-3788-2DA46D8724B8",
                "item_name": "Scythes",
                "variable_name": "scythes"
            },
            "5C17EFAF-2F94-E2E4-02A2-791F241BD52B": {
                "item_id": "5C17EFAF-2F94-E2E4-02A2-791F241BD52B",
                "item_name": "Bladed Fans",
                "variable_name": "bladed_fans"
            },
            "E48B1524-C478-E245-AF07-2A1A145EE4D5": {
                "item_id": "E48B1524-C478-E245-AF07-2A1A145EE4D5",
                "item_name": "Longswords",
                "variable_name": "longswords"
            },
            "1B08D135-FE7B-4180-6F38-A1FEEF733355": {
                "item_id": "1B08D135-FE7B-4180-6F38-A1FEEF733355",
                "item_name": "Battleaxes",
                "variable_name": "battleaxes"
            },
            "3AC99772-BF88-6507-8360-EE3EAFC7540F": {
                "item_id": "3AC99772-BF88-6507-8360-EE3EAFC7540F",
                "item_name": "Warhammers",
                "variable_name": "warhammers"
            },
            "864FC3D6-0B39-7F59-0274-09B98850A41F": {
                "item_id": "864FC3D6-0B39-7F59-0274-09B98850A41F",
                "item_name": "Glaives",
                "variable_name": "glaives"
            },
            "5B8E8F69-AB95-617A-5E82-8F9C4D2C2485": {
                "item_id": "5B8E8F69-AB95-617A-5E82-8F9C4D2C2485",
                "item_name": "Halberds",
                "variable_name": "halberds"
            },
            "E4FB85CE-C211-BE13-B674-A2A591384C11": {
                "item_id": "E4FB85CE-C211-BE13-B674-A2A591384C11",
                "item_name": "Pikes",
                "variable_name": "pikes"
            },
            "7FA88F1A-084A-4A05-1B5D-27B56EDDED6F": {
                "item_id": "7FA88F1A-084A-4A05-1B5D-27B56EDDED6F",
                "item_name": "Greataxes",
                "variable_name": "greataxes"
            },
            "545EB766-1371-C2E2-2664-0C191EAC9C3F": {
                "item_id": "545EB766-1371-C2E2-2664-0C191EAC9C3F",
                "item_name": "Lances",
                "variable_name": "lances"
            },
            "26BF8308-1F2B-656E-FF25-9EB2D1E0EEE0": {
                "item_id": "26BF8308-1F2B-656E-FF25-9EB2D1E0EEE0",
                "item_name": "Double-Bladed Scimitars",
                "variable_name": "double_bladed_scimitars"
            },
            "FB124CCD-B381-452B-CAA1-B598E90A8534": {
                "item_id": "FB124CCD-B381-452B-CAA1-B598E90A8534",
                "item_name": "Greatswords",
                "variable_name": "greatswords"
            },
            "40DDC931-6479-B773-293E-CE570E99B975": {
                "item_id": "40DDC931-6479-B773-293E-CE570E99B975",
                "item_name": "Bladed Umbrellas",
                "variable_name": "bladed_umbrellas"
            },
            "44A52695-9CD1-804C-9ABA-178B70704D59": {
                "item_id": "44A52695-9CD1-804C-9ABA-178B70704D59",
                "item_name": "Mauls",
                "variable_name": "mauls"
            },
            "488EE738-F198-9F9E-4F9F-FE26B06BA64F": {
                "item_id": "488EE738-F198-9F9E-4F9F-FE26B06BA64F",
                "item_name": "Nets",
                "variable_name": "nets"
            },
            "D80255AC-6D02-0158-0796-76D110DE7778": {
                "item_id": "D80255AC-6D02-0158-0796-76D110DE7778",
                "item_name": "Blowguns",
                "variable_name": "blowguns"
            },
            "9F33304D-BEB8-86B5-3928-A4D98293DF97": {
                "item_id": "9F33304D-BEB8-86B5-3928-A4D98293DF97",
                "item_name": "Darts",
                "variable_name": "darts"
            },
            "D7BB53E2-0544-9AC9-7DD3-4FA47A12C80C": {
                "item_id": "D7BB53E2-0544-9AC9-7DD3-4FA47A12C80C",
                "item_name": "Slings",
                "variable_name": "slings"
            },
            "81AF4123-10E6-8656-F9CA-DCE1AC3DC7E3": {
                "item_id": "81AF4123-10E6-8656-F9CA-DCE1AC3DC7E3",
                "item_name": "Rope Darts",
                "variable_name": "rope_darts"
            },
            "6C92300B-B840-9E37-BF4D-46A166407E7B": {
                "item_id": "6C92300B-B840-9E37-BF4D-46A166407E7B",
                "item_name": "Shortbows",
                "variable_name": "shortbows"
            },
            "E6CCEF87-419A-57CF-DC12-73324DB86CD1": {
                "item_id": "E6CCEF87-419A-57CF-DC12-73324DB86CD1",
                "item_name": "Crossbows, Hand",
                "variable_name": "crossbows_hand"
            },
            "207C31FE-ABEE-96F1-2EA6-B98635F7D730": {
                "item_id": "207C31FE-ABEE-96F1-2EA6-B98635F7D730",
                "item_name": "Longbows",
                "variable_name": "longbows"
            },
            "8C25C0CD-AF02-6648-A158-87F4DEBB8651": {
                "item_id": "8C25C0CD-AF02-6648-A158-87F4DEBB8651",
                "item_name": "Crossbows, Light",
                "variable_name": "crossbows_light"
            },
            "7257525A-37A8-9DCE-1656-C7449FF2C305": {
                "item_id": "7257525A-37A8-9DCE-1656-C7449FF2C305",
                "item_name": "Crossbows, Heavy",
                "variable_name": "crossbows_heavy"
            },
            "FCED5C37-344C-1B6A-7598-E682452C1AA9": {
                "item_id": "FCED5C37-344C-1B6A-7598-E682452C1AA9",
                "item_name": "Palm Pistols",
                "variable_name": "palm_pistols"
            },
            "60509B0C-A1BB-B005-C834-98E5ACE40BAB": {
                "item_id": "60509B0C-A1BB-B005-C834-98E5ACE40BAB",
                "item_name": "Pistols",
                "variable_name": "pistols"
            },
            "BCC74411-8516-A30B-B79A-1DBED89C61A6": {
                "item_id": "BCC74411-8516-A30B-B79A-1DBED89C61A6",
                "item_name": "Pepperboxes",
                "variable_name": "pepperboxes"
            },
            "3BBEE883-286A-4A08-3CCB-52F283348345": {
                "item_id": "3BBEE883-286A-4A08-3CCB-52F283348345",
                "item_name": "Muskets",
                "variable_name": "muskets"
            },
            "7F3F7FC7-0CCF-E01A-22BA-E0AA0A97686D": {
                "item_id": "7F3F7FC7-0CCF-E01A-22BA-E0AA0A97686D",
                "item_name": "Blunderbusses",
                "variable_name": "blunderbusses"
            },
            "E54B8A46-A63F-AB3A-BAA9-C27826B0AF5F": {
                "item_id": "E54B8A46-A63F-AB3A-BAA9-C27826B0AF5F",
                "item_name": "Longshot Rifles",
                "variable_name": "longshot_rifles"
            },
            "5310DE5D-1453-5468-EBBA-B1132AB19394": {
                "item_id": "5310DE5D-1453-5468-EBBA-B1132AB19394",
                "item_name": "Hand Mortars",
                "variable_name": "hand_mortars"
            }
        },
        "weather_type": {
            "72D05502-08AA-159C-AA98-D6548840F964": {
                "item_id": "72D05502-08AA-159C-AA98-D6548840F964",
                "item_name": "Ashfall",
                "variable_name": "ashfall"
            },
            "95D01E12-0C33-928F-4DE8-570AD806D10B": {
                "item_id": "95D01E12-0C33-928F-4DE8-570AD806D10B",
                "item_name": "Clear",
                "variable_name": "clear",
                "icon_variable_name": "sunny"
            },
            "242858C1-C334-3A4C-7C5C-9706495750DD": {
                "item_id": "242858C1-C334-3A4C-7C5C-9706495750DD",
                "item_name": "Cloudy",
                "variable_name": "cloudy"
            },
            "1A485B48-C8F4-DF38-BB69-4FE828FDC8A5": {
                "item_id": "1A485B48-C8F4-DF38-BB69-4FE828FDC8A5",
                "item_name": "Dust Storm",
                "variable_name": "dust_storm"
            },
            "6B3F3EA7-DF1A-7F16-38D2-12542984DBD7": {
                "item_id": "6B3F3EA7-DF1A-7F16-38D2-12542984DBD7",
                "item_name": "Hail",
                "variable_name": "hail"
            },
            "351702BB-5901-87AF-85EC-C8A6FBB7ECF9": {
                "item_id": "351702BB-5901-87AF-85EC-C8A6FBB7ECF9",
                "item_name": "Hazy",
                "variable_name": "hazy"
            },
            "AFF257FE-DA6E-02E3-86FA-E06FF598180A": {
                "item_id": "AFF257FE-DA6E-02E3-86FA-E06FF598180A",
                "item_name": "Heavy Rain",
                "variable_name": "heavy_rain"
            },
            "BE024638-C2F8-8F7B-2C08-BF017BBFB56F": {
                "item_id": "BE024638-C2F8-8F7B-2C08-BF017BBFB56F",
                "item_name": "Heavy Snow",
                "variable_name": "heavy_snow"
            },
            "7DF71D1B-2794-00E9-C672-3A95E279E521": {
                "item_id": "7DF71D1B-2794-00E9-C672-3A95E279E521",
                "item_name": "Partly Cloudy",
                "variable_name": "partly_cloudy"
            },
            "5DF3C480-7754-4872-302E-63CC3C4A9F03": {
                "item_id": "5DF3C480-7754-4872-302E-63CC3C4A9F03",
                "item_name": "Raining",
                "variable_name": "raining"
            },
            "C4097260-89C0-CB3C-19DD-B76A305EC039": {
                "item_id": "C4097260-89C0-CB3C-19DD-B76A305EC039",
                "item_name": "Sleet",
                "variable_name": "sleet",
                "icon_variable_name": "snowing_and_raining"
            },
            "5ADA1900-D1AD-198D-A299-EB7EC01ADCBD": {
                "item_id": "5ADA1900-D1AD-198D-A299-EB7EC01ADCBD",
                "item_name": "Snowing",
                "variable_name": "snowing"
            },
            "828845FB-4210-2C7A-23CE-4223EDAD52D5": {
                "item_id": "828845FB-4210-2C7A-23CE-4223EDAD52D5",
                "item_name": "Thunderstorm",
                "variable_name": "thunderstorm",
                "icon_variable_name": "cloudy_lightning"
            }
        },
        "wind_level": {
            "6BB72BB2-74A1-B2F6-D856-D4A7561C87A6": {
                "item_id": "6BB72BB2-74A1-B2F6-D856-D4A7561C87A6",
                "item_name": "Still",
                "variable_name": "still",
                "icon_variable_name": "wind_still"
            },
            "EC7ACDFA-A5FE-77B7-3451-C5C080DD71B5": {
                "item_id": "EC7ACDFA-A5FE-77B7-3451-C5C080DD71B5",
                "item_name": "Breeze",
                "variable_name": "breeze",
                "icon_variable_name": "wind_breeze"
            },
            "9283858C-98CD-FA04-72FC-5D2B9166A9D8": {
                "item_id": "9283858C-98CD-FA04-72FC-5D2B9166A9D8",
                "item_name": "Strong Wind",
                "variable_name": "windy"
            },
            "29D3FFBA-3DB6-15C1-F88C-B72CFADAE907": {
                "item_id": "29D3FFBA-3DB6-15C1-F88C-B72CFADAE907",
                "item_name": "Gale",
                "variable_name": "gale"
            },
            "EBC4D926-EF60-DD81-248E-54F6F31F29E0": {
                "item_id": "EBC4D926-EF60-DD81-248E-54F6F31F29E0",
                "item_name": "Storm Wind",
                "variable_name": "storm",
                "icon_variable_name": "tornado"
            }
        }
    },
    "policies": {
        "FT_STRIP_TO_UUID_TYPES": [
            "roll_type",
            "range_type",
            "damage_type",
            "sphere_of_magic",
            "size_type",
            "defensive_skill",
            "innate_skill",
            "armor_skill",
            "circle_of_magic",
            "class",
            "subclass",
            "creature",
            "passive_ability",
            "spell",
            "terrain_type",
            "status_effect",
            "item_composition",
            "weapon_classification",
            "natural_weapon",
            "attack_ability",
            "aoe_type",
            "equipment_slot",
            "equipment_visual_mount",
            "vitality_status",
            "essence",
            "armor_type",
            "creature_type",
            "creature_sub_type",
            "creature_sub_type_ancestral",
            "creature_sub_type_grouping",
            "creature_ancestry",
            "creature_grouping",
            "creature_lineage",
            "weapon_skill",
            "knowledge_skill",
            "speed_type",
            "ancestry",
            "location_type",
            "light_type",
            "environment",
            "weather_type",
            "weather",
            "temperature",
            "tempurature_type",
            "wind_type",
            "team_type",
            "full_ability",
            "ability",
            "quick_ability",
            "free_ability",
            "reaction_ability",
            "opportunity_attack_ability",
            "feat",
            "charged_ability",
            "curse",
            "sanguine",
            "menta",
            "lineage",
            "background",
            "lifestyle"
        ],
        "FT_FORCE_INTERN_STRIP_TYPES": [
            "armor_type",
            "creature_type",
            "creature_sub_type",
            "creature_sub_type_ancestral",
            "creature_sub_type_grouping",
            "creature_ancestry",
            "creature_grouping",
            "creature_lineage",
            "weapon_skill",
            "knowledge_skill",
            "status_effect",
            "ancestry"
        ],
        "FT_CATALOGIZE_DENY_TYPES": [
            "creature",
            "player_character",
            "encounter",
            "encounter_creature",
            "campaign",
            "location",
            "adventure",
            "source"
        ]
    },
    "audioTaxonomy": {
        "hit": {
            "E48B1524-C478-E245-AF07-2A1A145EE4D5": "sword_hit",
            "57B8F98F-460E-7D39-C495-D2E26439391C": "sword_hit",
            "FB124CCD-B381-452B-CAA1-B598E90A8534": "sword_hit",
            "AFFA2CC1-0468-ABBC-2FA3-40597B8B374D": "sword_hit",
            "2F238366-80B8-2BCF-EC81-387CE1A5D4DF": "sword_hit",
            "26BF8308-1F2B-656E-FF25-9EB2D1E0EEE0": "sword_hit",
            "40DDC931-6479-B773-293E-CE570E99B975": "sword_hit",
            "50740150-28E8-FB76-88BD-216B02569D3F": "dagger_hit",
            "48C941BC-2E9A-CAD8-1DA7-D90AE8DB1768": "dagger_hit",
            "5C17EFAF-2F94-E2E4-02A2-791F241BD52B": "dagger_hit",
            "859394A9-EE4A-BD9A-C5A9-7FCD150E7344": "axe_hit",
            "1B08D135-FE7B-4180-6F38-A1FEEF733355": "axe_hit",
            "7FA88F1A-084A-4A05-1B5D-27B56EDDED6F": "axe_hit",
            "DE15C4F8-2710-8187-3788-2DA46D8724B8": "axe_hit",
            "5E58B1EB-B2AD-5F54-B4DD-D8DDA5E8BCE3": "mace_hit",
            "AD9D5036-D2CF-1C6A-9785-CCB5D35B96B5": "mace_hit",
            "D5906717-7237-CA1D-B089-18CF323A04DB": "mace_hit",
            "622AEA0A-D1A6-FB1C-83B4-FC67807D9197": "mace_hit",
            "6284CE8F-C929-7161-EC43-923DE40F4968": "mace_hit",
            "B5ECBC44-BAB8-E6B2-0D1C-CC2A5082BDD2": "mace_hit",
            "67EFA62C-3A5C-9FEE-D54D-EF7615C063F4": "hammer_hit",
            "3AC99772-BF88-6507-8360-EE3EAFC7540F": "hammer_hit",
            "44A52695-9CD1-804C-9ABA-178B70704D59": "hammer_hit",
            "B12431F6-BB7A-8079-002F-111914B9E65A": "hammer_hit",
            "7D08EF0E-0D7D-8CB0-70FA-0C741AF438E5": "spear_thrust",
            "2FB5E21A-7A0A-E4B8-604D-3A0A60A34172": "spear_thrust",
            "CF8B21A5-32CE-7E43-22E3-ABC56C457628": "spear_thrust",
            "E4FB85CE-C211-BE13-B674-A2A591384C11": "spear_thrust",
            "545EB766-1371-C2E2-2664-0C191EAC9C3F": "spear_thrust",
            "864FC3D6-0B39-7F59-0274-09B98850A41F": "spear_thrust",
            "5B8E8F69-AB95-617A-5E82-8F9C4D2C2485": "spear_thrust",
            "12D25118-B86A-80A5-01BC-C9427BD83D17": "staff_swing",
            "F187EE82-1D32-4C53-9F69-E59DDF33D7C7": "unarmed_hit",
            "742A06CA-5870-FA3B-603A-AEE94F5102F5": "whip_crack",
            "6C92300B-B840-9E37-BF4D-46A166407E7B": "bow_release",
            "207C31FE-ABEE-96F1-2EA6-B98635F7D730": "bow_release",
            "E6CCEF87-419A-57CF-DC12-73324DB86CD1": "bow_release",
            "8C25C0CD-AF02-6648-A158-87F4DEBB8651": "bow_release",
            "7257525A-37A8-9DCE-1656-C7449FF2C305": "bow_release",
            "FCED5C37-344C-1B6A-7598-E682452C1AA9": "gunshot_light",
            "60509B0C-A1BB-B005-C834-98E5ACE40BAB": "gunshot_light",
            "BCC74411-8516-A30B-B79A-1DBED89C61A6": "gunshot_light",
            "3BBEE883-286A-4A08-3CCB-52F283348345": "gunshot_heavy",
            "7F3F7FC7-0CCF-E01A-22BA-E0AA0A97686D": "gunshot_heavy",
            "E54B8A46-A63F-AB3A-BAA9-C27826B0AF5F": "gunshot_heavy",
            "5310DE5D-1453-5468-EBBA-B1132AB19394": "gunshot_heavy",
            "9F33304D-BEB8-86B5-3928-A4D98293DF97": "dart_throw",
            "D80255AC-6D02-0158-0796-76D110DE7778": "dart_throw",
            "D7BB53E2-0544-9AC9-7DD3-4FA47A12C80C": "sling_release",
            "81AF4123-10E6-8656-F9CA-DCE1AC3DC7E3": "sling_release",
            "488EE738-F198-9F9E-4F9F-FE26B06BA64F": "net_throw",
            "B66B3311-4A62-5531-D446-CE4A565FD181": "crossbow_release"
        },
        "swing": {
            "E48B1524-C478-E245-AF07-2A1A145EE4D5": "sword_swing",
            "57B8F98F-460E-7D39-C495-D2E26439391C": "sword_swing",
            "FB124CCD-B381-452B-CAA1-B598E90A8534": "sword_swing",
            "AFFA2CC1-0468-ABBC-2FA3-40597B8B374D": "sword_swing",
            "2F238366-80B8-2BCF-EC81-387CE1A5D4DF": "sword_swing",
            "26BF8308-1F2B-656E-FF25-9EB2D1E0EEE0": "sword_swing",
            "40DDC931-6479-B773-293E-CE570E99B975": "sword_swing",
            "50740150-28E8-FB76-88BD-216B02569D3F": "dagger_swing",
            "48C941BC-2E9A-CAD8-1DA7-D90AE8DB1768": "dagger_swing",
            "5C17EFAF-2F94-E2E4-02A2-791F241BD52B": "dagger_swing",
            "859394A9-EE4A-BD9A-C5A9-7FCD150E7344": "axe_swing",
            "1B08D135-FE7B-4180-6F38-A1FEEF733355": "axe_swing",
            "7FA88F1A-084A-4A05-1B5D-27B56EDDED6F": "axe_swing",
            "DE15C4F8-2710-8187-3788-2DA46D8724B8": "axe_swing",
            "5E58B1EB-B2AD-5F54-B4DD-D8DDA5E8BCE3": "mace_swing",
            "AD9D5036-D2CF-1C6A-9785-CCB5D35B96B5": "mace_swing",
            "D5906717-7237-CA1D-B089-18CF323A04DB": "mace_swing",
            "622AEA0A-D1A6-FB1C-83B4-FC67807D9197": "mace_swing",
            "67EFA62C-3A5C-9FEE-D54D-EF7615C063F4": "mace_swing",
            "3AC99772-BF88-6507-8360-EE3EAFC7540F": "mace_swing",
            "44A52695-9CD1-804C-9ABA-178B70704D59": "mace_swing",
            "6284CE8F-C929-7161-EC43-923DE40F4968": "mace_swing",
            "B5ECBC44-BAB8-E6B2-0D1C-CC2A5082BDD2": "mace_swing",
            "B12431F6-BB7A-8079-002F-111914B9E65A": "mace_swing",
            "12D25118-B86A-80A5-01BC-C9427BD83D17": "staff_swing",
            "6C92300B-B840-9E37-BF4D-46A166407E7B": "bow_release",
            "207C31FE-ABEE-96F1-2EA6-B98635F7D730": "bow_release",
            "E6CCEF87-419A-57CF-DC12-73324DB86CD1": "bow_release",
            "8C25C0CD-AF02-6648-A158-87F4DEBB8651": "bow_release",
            "7257525A-37A8-9DCE-1656-C7449FF2C305": "bow_release"
        },
        "damage": {
            "0C528CF8-1B5A-453C-9BDE-73CBBC239A2A": [
                "blood_hit",
                "blunt_blood",
                "bludgeoning"
            ],
            "C62E5227-0AB4-4C34-9058-DE97E36B0706": [
                "blood_hit",
                "blade",
                "piercing"
            ],
            "422B9C6D-9558-47CD-AC21-1FB3B45EF33E": [
                "blood_hit",
                "blunt_blood",
                "slashing"
            ],
            "F66879A9-5BDC-4996-8419-AF162CFCDC5F": [
                "acid"
            ],
            "8C455214-9F98-43C7-B9BC-1C74EE60805D": [
                "cold"
            ],
            "A8469481-849E-4BBA-986E-7C418DCA06A1": [
                "fire"
            ],
            "25F9052F-B963-43CB-991E-EB315E08A549": [
                "force"
            ],
            "944EC0D7-3320-42B1-B28D-68980DAA9719": [
                "lightning"
            ],
            "4EBFF986-A4AA-4709-BE68-E97D29B66D18": [
                "poison"
            ],
            "B61FDA44-4707-4539-B39B-54FA1FCBAA71": [
                "psychic"
            ],
            "5850D66F-70E8-467D-9A5C-93464A5A12C4": [
                "radiant"
            ],
            "F79CF36E-F439-44C3-9668-050683A30F1C": [
                "thunder"
            ],
            "D66B715F-E086-4C4B-A887-4BDB38AE32EB": [
                "necrotic"
            ]
        },
        "spell_miss": {
            "25F9052F-B963-43CB-991E-EB315E08A549": "force",
            "4EBFF986-A4AA-4709-BE68-E97D29B66D18": "poison",
            "5850D66F-70E8-467D-9A5C-93464A5A12C4": "radiant",
            "8C455214-9F98-43C7-B9BC-1C74EE60805D": "cold",
            "944EC0D7-3320-42B1-B28D-68980DAA9719": "lightning",
            "A8469481-849E-4BBA-986E-7C418DCA06A1": "fire",
            "B61FDA44-4707-4539-B39B-54FA1FCBAA71": "psychic",
            "D66B715F-E086-4C4B-A887-4BDB38AE32EB": "necrotic",
            "F66879A9-5BDC-4996-8419-AF162CFCDC5F": "acid",
            "F79CF36E-F439-44C3-9668-050683A30F1C": "thunder"
        },
        "piercing": "C62E5227-0AB4-4C34-9058-DE97E36B0706",
        "daggers": "50740150-28E8-FB76-88BD-216B02569D3F",
        "dagger_piercing": [
            "blood_hit",
            "dagger_blood"
        ]
    },
    "statusBases": {
        "658B4D83-322B-42FA-82AB-49D3BAD33590": null,
        "9529EEA7-63A9-C572-ECA9-F523E87C58A8": null,
        "4638F1B5-48F9-4E81-95B7-E0325F40B5EF": null,
        "D9043BEC-2EFF-BC30-BE5C-270D7E1A68A8": null,
        "A176161E-3825-86D8-7BE7-C1524A5B19D4": null,
        "F5ACBDB4-D923-3684-57F6-FBF3F720AEFA": null,
        "095BC6BC-06F6-74E0-2B8A-FC1F32AF809B": null,
        "2A20ACDF-3BC6-B964-8FBD-F8E1AC581AA5": null,
        "1E8008FA-B68A-8DE8-48CE-0EB121008FEB": null,
        "7B044913-E45E-04C9-F25C-5FB8B8C503F4": null,
        "F73BA661-ADD2-26E0-E265-FBEB7E5E6AF1": null,
        "799B512F-C685-9655-0AF0-8CFBE0349130": null,
        "DCB240F7-C033-1B9C-0E27-446C5C1F4D0C": null,
        "BCC91DAF-AF10-497E-241D-ACD1BEC9E80E": null,
        "83EAD975-053D-1DDA-4474-F2128633500E": null,
        "3E9BD118-C5FB-2C0A-01CF-72DC2C4ED0E8": null,
        "D5A31654-692A-B4BE-49DC-2B3360F76D4A": null,
        "B5E6379E-5869-4B82-3EB4-9ACB48D2F82A": null,
        "3188FB3B-C860-43D4-9BA0-40364C460385": null,
        "8A6575CF-BCA9-2E70-5ECB-21FE529FCAB6": null,
        "39F1A03D-A7C7-4E90-98FD-14F508074BC5": null,
        "EC8F4821-26B6-4874-86E0-2B344CDC8B4F": null,
        "E7FDB796-26DA-E0F5-8F88-C21FE01D923B": null,
        "AE967694-B94B-F0FF-B680-829FDE6E8D58": null,
        "A311574A-3513-44AB-8C70-3C3006F6CC40": null,
        "321DA526-E48E-F202-10FC-D3A2B03485F2": null,
        "057BA9B2-177C-40A6-8815-8063DDDC0D9B": null,
        "83234E69-6C06-3392-256B-CB3796C180A7": null,
        "9DF8FF4C-33E8-8095-4876-ED3DBCD50B79": null,
        "2A64D1E8-7C3B-4F92-B5A8-E19D64C72F35": null,
        "9E15B7A2-3D48-4C61-A927-F84B21D6E593": null,
        "6C82F394-1A5D-4E76-8B34-D29E75A1C648": null,
        "4F37A8D1-9B62-4A15-C783-28E91B5F4D76": null,
        "8D21C6F5-4E93-4B27-A164-73F8D2E9B5A4": null,
        "3B96E4A7-2F51-4D38-9C82-46A1E7D3F925": null,
        "7A45D2B9-6C18-4F63-B591-82D4F6A3E1C7": null,
        "5E63B1C4-8A27-4D95-A348-91C6E2F7D8B3": null,
        "1D87F5A3-6B42-4C19-8E75-34A9D1B6C2F8": null,
        "9C34A6E1-5D78-4B26-A493-67F2E8D5B1A9": null,
        "6F92C3D7-1E85-4A64-B237-58D1A9F4E6C3": null,
        "1710A01B-FAF1-4684-5050-A10386685D35": null,
        "DB1C8E56-CBD7-09E4-0FBF-148F28A93D67": null,
        "DA2F74EB-CF67-AEEB-0DE1-376C6BB7CABA": null,
        "D31E3DD8-FFA1-67EC-D3F4-FCD323059091": null,
        "EEDD357F-C1CA-44C1-A53F-DD06EEFBA597": null,
        "D09D563D-0689-4B56-AEAA-5A254DC408A4": null,
        "2858158E-5E6A-491B-9824-290DE8D692D8": null,
        "331C8511-F8A7-4626-AF17-48FAF062FE50": null,
        "D9394C92-068A-FAFA-231D-289157FD2980": null,
        "34987D5C-BB13-7633-E28A-C3DA4BD458A7": null,
        "6A31B8DA-8AD6-ACC1-9E3A-3A8DD77FD43D": null,
        "C8163F62-7B18-8221-A60D-C9DD775682E3": null,
        "D343892B-338C-4FBE-BEA0-2015FE503F43": null,
        "398DD6E8-AFAE-EA0D-6FE9-C22842D53775": null,
        "ED30CCB0-1645-B97E-B9A6-867D8D0094BD": null,
        "426C7E0B-EF44-498C-10B2-B50A9E28E45C": null,
        "78C51D2D-5178-551C-1249-B5DDA4083098": null,
        "477A7977-60D2-4B9C-96B0-6ED4BFD6437E": null,
        "36C061BF-E480-4334-961C-26500150E3C4": null,
        "B84EBE3F-B385-4CEF-9C69-648086C4CB7D": null,
        "5AA76DEE-CE52-E021-67CD-8C701DA0E56F": null,
        "FD5CB2E3-B247-274A-5B42-25F538F72661": null,
        "A707303F-CE4F-26D8-8846-B5178D3F1DB2": null,
        "B9DC5478-8F86-29F7-15D8-1C8CE8171F12": null,
        "A13061B6-2390-14E8-34E0-366C0E0CDE34": null,
        "5D939B6E-B9BC-7AC5-5143-4F00F4189EA3": null,
        "5833A733-D277-0A60-3A94-A0F355A79A80": null,
        "62ED7394-9C33-D41A-C426-1BC6723C999A": null,
        "E49AA8BA-1F60-4FD8-B3C0-852BBA3978C3": null,
        "1C4D81BB-FB79-68AD-E881-28D874927FD2": null,
        "FF9A38A3-5F35-F083-E153-7DF41B0C0826": null,
        "3F171782-CC56-32DF-81B4-8C0ED89F47F4": null,
        "7B3E9C4A-1D62-4F08-A5D7-3E90C1B84F26": null,
        "A64E346E-F58C-5FB7-BE30-71232C06897C": null,
        "67B9CAB7-1C48-41E0-AEAF-2F4A352075C1": null,
        "09FC38BC-6060-4B67-A33F-EF7D448F71F1": null,
        "996886D6-67F7-2A7D-0336-9324C877CAA6": "09FC38BC-6060-4B67-A33F-EF7D448F71F1",
        "F632281D-2F16-FFDA-FB95-2E958988F01F": null,
        "F90FB02F-2549-6FE0-A162-CC3FA7C90C67": "F632281D-2F16-FFDA-FB95-2E958988F01F",
        "E3169368-A4EF-476F-B699-5EFE62C7CE2A": null,
        "99951E6E-9801-4E3E-A684-4D111F2D6624": null,
        "84CD1B4A-0D7C-9385-8128-D91339F269BF": null,
        "6EFBE105-7632-4C64-BC04-206CEAF663E6": null,
        "E5452E0D-251E-4BDD-AC25-DADD00A7BEC7": null,
        "F711788C-2BB4-4114-8339-B3C85BE0D52A": null,
        "CEFF8A40-503C-FDA3-41B3-43DC06BF762D": null,
        "0313A4D7-C1C2-4D1B-8DD7-CC6EDBC42065": null,
        "4B74DA87-EABF-7EBA-D283-C5A1FEF483C9": null,
        "3E053858-D7C1-4E36-91A7-AF05EF5D0C62": null,
        "3C038AB7-2684-A787-1809-6C8224DBB285": null,
        "A1F1FAF2-DA1E-D537-36C2-2B74DC82CB12": null,
        "DDC66C31-4093-84AF-18BB-093D924B8738": null,
        "FF8D219A-2A83-0EE5-A222-E748753E8D0B": null,
        "680EFB9E-3CFB-491F-A620-5BABF800131C": null,
        "F13F6A58-FE91-F24D-12BE-BE7CCAD81A40": null,
        "E2054884-038E-3D6E-56C5-19ABBFED8379": null,
        "1BA5473E-6218-6688-1C68-DCA4FEF00A97": null,
        "47667406-1B72-9D60-310B-D8CF6BFE397D": null,
        "84B91EEB-2FA6-D1CB-1347-75BFBDA2A6DD": null,
        "B6232175-C357-9A97-0ACA-7ECC67563635": null,
        "2A2845CD-949F-06E2-E6B2-98CFD5603241": null,
        "B9693027-E65E-DAFF-B2C5-7CF31927184D": null,
        "3A2FD2B0-28A9-62D3-CB13-A22974618CDB": null,
        "A126C1D6-FE3E-5578-DCC6-CBBF8742E9C1": null,
        "BE6DC590-4EB7-B297-5AC6-8E47AA4E00EF": null,
        "306CD53D-AD03-DD13-FDDF-34D9120613CD": null,
        "49F87D1B-3878-789E-D52E-65BA7F2F4218": null,
        "1AEA950E-A57E-6059-448A-E4A6FCED97A3": null,
        "466374FE-D89C-DB77-1809-7249A831015D": null,
        "10278E95-5320-A57E-471F-C3E7AEFA70BA": null,
        "EB6FB558-7427-A647-8F46-D2E8C25F1F60": null,
        "BF31EE0A-5B3C-370B-0118-96B067CFD929": null,
        "F2CD1603-38A4-85E9-D148-CE3D429310A2": null,
        "D218F4FB-5693-87B9-93C1-776FC1F7ED90": null,
        "B404E7CA-C073-473E-A799-A71601A22DE5": null,
        "6CCB9287-4420-962A-2952-7469394A5C7A": null,
        "DD4C0995-C3D2-43A3-CFC7-226C3005274C": null,
        "D2E7BA2C-562D-D4AC-7F71-13E4AC540484": null,
        "185D46F5-09E2-1921-F721-FDD0A2AB3EFC": null,
        "E4A34093-AAAB-6453-BCE0-FBA65EE263AD": null,
        "0C2A8037-B0BC-8300-C818-198881B00E7D": null,
        "E34AF232-5438-88FC-9A9F-73850CCCFD51": null,
        "F40E19A3-FC86-187F-050E-8C8B69761353": null,
        "BC6671F6-DEDF-9C1B-C459-226E7388A00C": null,
        "90D15611-2833-46D6-A72E-04C16C87972F": null,
        "9FD8A4D0-B09B-C068-D475-7EAB358D1A1E": null,
        "64318AE9-0187-4C71-9163-084694BCE180": null,
        "75B1C2F6-8E21-0ED0-32AD-C49B68804CCC": null,
        "091B2BEE-7F61-D7DB-0CF1-6D255F4B7663": null,
        "EAA88590-DB1D-7C46-F523-E87A31912777": null,
        "9853CC89-CE34-4077-5453-59605542265C": null,
        "BE55F5A2-74F7-63D0-D169-900934E2E26E": null,
        "3AD27E05-55EB-4B79-83F6-FC88ADEBD342": null,
        "75682F12-AB67-401B-97D7-F1B7354333CA": null,
        "B45813FE-321A-EC7F-F008-12B8FD33B524": null,
        "98FEA101-0910-41AE-9E20-E126C8B73AFC": null,
        "256BCFFB-B0BF-7C7A-B238-3126CA2AC20C": null,
        "091CBC18-FF1D-6072-3190-90EFAEDDE6F5": null,
        "C518B122-A108-4EA3-B140-E6211C1071BB": null,
        "B49068EF-8A0A-0002-3476-E214504C3570": null,
        "CAD2A16E-0DB5-91C5-F7F4-24F46B28011C": null,
        "F450C824-98D3-D0B1-D6B1-C326F15F1578": null,
        "DD53CA8E-DF3D-9AF4-49CB-9C61926BBB93": null,
        "F55C0D31-091D-0F3F-74F0-AEE4C20BE1ED": null,
        "60912827-B1B3-E9D7-6FBF-1FE976DDD04E": null,
        "8912E655-C826-4CF6-8F3C-B036AC710CE3": null,
        "1194F357-C419-2931-27B4-3B56F26BFBA7": null,
        "88F8F0BA-3E96-4D9C-AFCE-008D849B0BFC": null,
        "6FAF0CD0-26E2-60A3-0608-A3C8E1828027": null,
        "C1F4E2B6-DA45-8CAC-322D-C5DF54FFC418": null,
        "2611657A-9C0A-4680-AB51-62235A6D8D79": null,
        "5672B433-B59D-561E-B4C6-79565C46B3CA": null,
        "7780B669-28AA-680E-D28D-397B05A15FC6": null,
        "457ADEAA-1D5D-9AB4-EFC9-2B7120C78BAA": null,
        "DFCF49C0-D5BC-C56F-A7C5-DC8D134ED7D7": null,
        "3BE713AB-37D7-630B-C1F8-9470784BA33E": null,
        "22E33A8E-DF5D-2596-8E2D-0E8A8528E47C": "3BE713AB-37D7-630B-C1F8-9470784BA33E",
        "BAAA237B-1AA7-0409-5BC7-1A6720573069": "3BE713AB-37D7-630B-C1F8-9470784BA33E",
        "A5CDC77C-D224-DD5F-291B-EF8DF2EA443D": null,
        "9437F344-1461-B4C0-E196-6BA1A34ADC94": "A5CDC77C-D224-DD5F-291B-EF8DF2EA443D",
        "9154FF1F-721A-2BCA-1AEF-24AC7B32FE4B": "A5CDC77C-D224-DD5F-291B-EF8DF2EA443D",
        "46F27428-2B73-50F7-6F0C-D4FAFDB753ED": "A5CDC77C-D224-DD5F-291B-EF8DF2EA443D",
        "4D27433B-6F72-47BB-9A60-B80493F22D65": "A5CDC77C-D224-DD5F-291B-EF8DF2EA443D",
        "E4994653-49B3-D768-35C1-36C8DE40CC1A": "A5CDC77C-D224-DD5F-291B-EF8DF2EA443D",
        "5C557D5A-B85F-DF45-3CF6-6739D2BD70EC": "A5CDC77C-D224-DD5F-291B-EF8DF2EA443D",
        "44D4504C-9BD5-0B65-F8E2-6DC4A0F820B4": "A5CDC77C-D224-DD5F-291B-EF8DF2EA443D",
        "1DEE12B6-D23A-7470-812E-CE4C77AAD395": "A5CDC77C-D224-DD5F-291B-EF8DF2EA443D",
        "4AEF8F40-B779-C0AD-4455-2DABE7B1D14B": "A5CDC77C-D224-DD5F-291B-EF8DF2EA443D",
        "A230F5E6-B6AD-8091-4F59-5E454776B4FA": null,
        "CEF623E6-6A71-37FD-29C7-12988B43151A": null,
        "F8E5F274-2F31-1340-6167-ED9131E81A88": "CEF623E6-6A71-37FD-29C7-12988B43151A",
        "E18A79D1-AA69-7F80-2579-78B583E0771B": "CEF623E6-6A71-37FD-29C7-12988B43151A",
        "20F461C2-67CC-BEF6-E02A-4E9A464EC397": "CEF623E6-6A71-37FD-29C7-12988B43151A",
        "EF165E68-DD93-90C8-A848-01D93B041CBD": "CEF623E6-6A71-37FD-29C7-12988B43151A",
        "DA5A18C5-FDE5-D20B-0E3B-07B68E6C7C1C": "CEF623E6-6A71-37FD-29C7-12988B43151A",
        "683632D7-756C-0165-9E94-27EA95A53A53": "CEF623E6-6A71-37FD-29C7-12988B43151A",
        "E19F0AB8-E760-D84A-85C3-1A14E7DFE399": "CEF623E6-6A71-37FD-29C7-12988B43151A",
        "5F87B80F-A8E4-A3BE-6FC6-3B5BC0A669E9": "CEF623E6-6A71-37FD-29C7-12988B43151A",
        "E29189CC-A2FA-B06A-5DBD-8551A3259829": "CEF623E6-6A71-37FD-29C7-12988B43151A",
        "BDAF9378-AA7A-445F-D24F-8E6A0EE84456": "CEF623E6-6A71-37FD-29C7-12988B43151A",
        "4744C91C-51DC-4C36-8C6E-DB801410FF61": null,
        "5CB84B6E-E636-B4A3-3864-910DBD3B63B4": "4744C91C-51DC-4C36-8C6E-DB801410FF61",
        "1B912A78-2334-D265-2674-7AD764534D56": "4744C91C-51DC-4C36-8C6E-DB801410FF61",
        "7F938839-F44A-FA43-05FA-BAAF79B7A05B": "4744C91C-51DC-4C36-8C6E-DB801410FF61",
        "FCC88F77-777D-56B1-913E-E676C90E39E3": "4744C91C-51DC-4C36-8C6E-DB801410FF61",
        "655383C0-8B0C-3B33-694D-26404400626D": "4744C91C-51DC-4C36-8C6E-DB801410FF61",
        "36B68995-C875-199D-20E8-1A1098F846B0": "4744C91C-51DC-4C36-8C6E-DB801410FF61",
        "D9668790-E866-861A-FDE0-D23D2903B0FA": "4744C91C-51DC-4C36-8C6E-DB801410FF61",
        "90D143BD-9CC9-06F7-F339-03F50C27D958": "4744C91C-51DC-4C36-8C6E-DB801410FF61",
        "8A3B8D76-ED7A-560A-166D-73093DE6F4E9": "4744C91C-51DC-4C36-8C6E-DB801410FF61",
        "E64821CE-A9A5-D2C3-4116-8A8D5DCA4D30": "4744C91C-51DC-4C36-8C6E-DB801410FF61",
        "EB6632D3-5EC0-4E4D-5C6C-1BCB7EF57022": null,
        "BF823982-6FC8-51F0-F452-5BE1C949FBA6": "EB6632D3-5EC0-4E4D-5C6C-1BCB7EF57022",
        "36DA5B89-CA08-3940-E798-FCAE6BE775D5": "EB6632D3-5EC0-4E4D-5C6C-1BCB7EF57022",
        "8346CCFF-3A5B-F0E4-CFDE-6CF1D1ED3368": "EB6632D3-5EC0-4E4D-5C6C-1BCB7EF57022",
        "E5314BED-1269-3A65-8C15-01E80A3A8E23": "EB6632D3-5EC0-4E4D-5C6C-1BCB7EF57022",
        "E614D75F-CF27-D169-3D91-0D33D9CE354B": "EB6632D3-5EC0-4E4D-5C6C-1BCB7EF57022",
        "A831D8E0-4DC5-4FBF-4A4C-2C9955AE230A": "EB6632D3-5EC0-4E4D-5C6C-1BCB7EF57022",
        "631AAD91-F6A5-879D-5BD6-B7F885AA7FC9": "EB6632D3-5EC0-4E4D-5C6C-1BCB7EF57022",
        "BF1C1C48-8171-90B8-CD83-F2768348629F": "EB6632D3-5EC0-4E4D-5C6C-1BCB7EF57022",
        "2A63EC91-E5B1-17B4-DFB0-199F9E2084A5": "EB6632D3-5EC0-4E4D-5C6C-1BCB7EF57022",
        "01B0F693-7D8A-C588-9B34-CD1F323D8433": "EB6632D3-5EC0-4E4D-5C6C-1BCB7EF57022",
        "D98B076A-3A38-E225-B8E3-A646C69AA29D": null,
        "430F1BE4-6522-4468-8E27-426B23D003BF": "D98B076A-3A38-E225-B8E3-A646C69AA29D",
        "9EFD0898-7C92-6DE4-DD2F-D6F75ECF3B58": "D98B076A-3A38-E225-B8E3-A646C69AA29D",
        "90FB0BFB-6186-5E01-FD8B-0315D6DFB809": "D98B076A-3A38-E225-B8E3-A646C69AA29D",
        "CDC5CFDA-B09C-4A68-820D-6C74D90BD595": null,
        "D9B64F38-A817-47B8-AB07-60D59F3D893C": "CDC5CFDA-B09C-4A68-820D-6C74D90BD595",
        "AE20C09B-76BE-5BC4-4E33-6E8CFE1F0139": "CDC5CFDA-B09C-4A68-820D-6C74D90BD595",
        "479A4B5C-43F3-3559-979B-5BDA8A379F07": "CDC5CFDA-B09C-4A68-820D-6C74D90BD595",
        "80585488-CC4B-4A80-8ECE-CB1CE83F2407": null,
        "82788F70-EBEF-44C4-80E7-6622AD20DD60": null,
        "FF30B76E-785D-2CAF-FC66-C131D0548808": null,
        "658483AA-34DE-74E5-C974-E3E202C31CC7": null,
        "C97076EF-FED9-19B4-D109-C22F9BC740E8": null,
        "44B8792E-632E-2651-C666-67DFD181E92A": null,
        "298BE1DD-2917-476E-D79C-92CF8C598926": null,
        "D5DE14C4-3194-87BC-D767-6D45BDD90552": null,
        "8AE129AF-52D8-CCE8-706A-85767DB52740": null,
        "9FEE2E8A-9CF7-D74D-5D16-B86C2603A1FA": null,
        "F07C595F-D2DC-4CE9-904E-A4D73ABF9DEA": null,
        "99C862B9-D6AE-4E18-7803-A6F9B42A88E1": null,
        "78C6CC42-BCCE-4F22-9FC5-41F8D7E70944": null,
        "EE063289-1AF3-41CF-B73C-64A0556E6D07": "78C6CC42-BCCE-4F22-9FC5-41F8D7E70944",
        "2EAAA2E8-1B9C-196D-3E58-C29C09FF8492": "78C6CC42-BCCE-4F22-9FC5-41F8D7E70944",
        "A9678CB1-11D3-55A3-E3C9-F342B2E40980": "78C6CC42-BCCE-4F22-9FC5-41F8D7E70944",
        "611DFED0-9AD1-5500-AF5B-DE7CBD9DDF64": null,
        "553734EC-33D3-4527-AB2E-EF48ACED8DF0": "611DFED0-9AD1-5500-AF5B-DE7CBD9DDF64",
        "9AA7588A-4575-9550-343D-6ADB0C74C17F": "611DFED0-9AD1-5500-AF5B-DE7CBD9DDF64",
        "660E3133-44D8-E79F-C0ED-A26CE31D6E32": "611DFED0-9AD1-5500-AF5B-DE7CBD9DDF64",
        "62E83DEB-4569-AE3A-F671-FF514C508FD2": null,
        "F7A1C3B2-5D64-4E18-9A70-2C8B41D5E093": null,
        "10C28483-A0E9-467F-993B-CBC440546A52": null
    },
    "names": {
        "22918408-67CC-4093-80E8-BF6FA8915C21": "Body",
        "63ABC96E-3804-4E1F-B38D-AABA3237B2D8": "Mind",
        "72F93730-134F-4CA2-8FC4-F2915F20CAC6": "Soul",
        "86792A8B-2070-4144-9C81-0D85706131DF": "Spirit",
        "E769E451-65EE-3628-1A78-D12C9A3FF02B": "Fortune",
        "7B7E8F97-6843-57CF-422C-5930CFA98B06": "Luck",
        "3B58A8C2-F310-42FB-A71C-904904089303": "Nightsight",
        "F87E66D1-0EB2-469F-BB07-CF2CF4E26B30": "Blindsight",
        "51EFBF8C-672F-F1F8-543A-6B079320572C": "Fiendsight",
        "E472D6BD-1A9C-F84E-AD55-F3068A3EC303": "Ghostsight",
        "6B8E5648-B589-5F6A-DFAA-84F7E646B062": "Spellsight",
        "9F34BE02-A199-4A9C-A2C4-531CD8A1DD58": "Truesight",
        "61FD588C-4A17-4190-999B-7832820C44BA": "Tremorsense",
        "57DAF94A-7C3A-4C5B-A7A9-22729D06355F": "Telepathy",
        "D82855E1-4BB9-93EA-6374-B9904318BC1D": "Self",
        "7E615545-1179-6F6A-9729-0AFFCD588B31": "Object Range",
        "36D59FF4-6778-96ED-8664-F5D63638C77B": "Reach",
        "4C761395-2532-3F23-7CBA-CA81AF5C0855": "Close (30)",
        "A95F219A-6288-6B17-6DB7-03DE4B97AE96": "Near (60)",
        "D1E8DA38-61C2-97AA-6173-4BF6157FEEE3": "Far (120)",
        "F6DAE84B-CBB3-5C0F-89EF-370DE841DFDA": "Very Far (240)",
        "BB47D2E8-FFFD-8A04-FC6C-FC02583750ED": "Unlimited",
        "DF516479-F164-87FA-7BB8-6F268BF1DCE7": "Walking Speed",
        "B96061AE-3369-7E7A-B6A2-C7C8FBF2A23F": "Jumping Speed",
        "ED9810A9-3456-4D6B-BC5C-A1BAF5952B98": "Swimming Speed",
        "EDCBE2A8-CD3D-43DC-9B92-84A634BE12AE": "Climbing Speed",
        "F1D0A27A-43F1-4A4C-A5F8-ED9BD2D908D4": "Flying Speed",
        "ACFB413D-15A8-835B-C821-9E101B6C4F60": "Burrowing Speed",
        "3C96DE74-D9E6-4173-8671-989209A0BF97": "Teleport",
        "AE7D4EB3-DC36-BD47-978F-1DBCFE2B616A": "Hovering Speed",
        "59C08B6D-F8D4-F9DB-81D9-0FD592094C73": "Balance",
        "24C07918-39D5-4317-A958-BDF68B633A21": "Fortitude",
        "58A62523-2588-452B-876B-61D8ACF3CCED": "Psyche",
        "922C5882-54DE-42D0-A5C8-8118AA1C858E": "Willpower",
        "F99172CC-DDEF-48D4-87F8-8B94F0071247": "Attention",
        "397C35B1-76DB-4A45-1468-E53CF797A1A3": "Empathy",
        "30735770-7440-0C26-5FDF-86C452C0C91D": "Frighten",
        "F5A23631-F770-1C49-79F0-E8A2B7A6DCAC": "Influence",
        "6E1A31A4-2D30-096B-BEA4-E2A1DC93A583": "Initiative",
        "28E0D03E-86B3-FDF4-E03A-8DFA1043FE3E": "Inspection",
        "64493E62-BCAF-27F1-2B6A-EC84DE328F66": "Sneak",
        "9F177F51-CDAC-0012-A574-DE1B8B17A55F": "Excavating",
        "B3856A19-34AD-D33A-14F1-BBBE79A67DA5": "Farming",
        "59B5B7EA-38B8-28C7-B74F-182906B4E3D7": "Fishing",
        "42D2DDEC-9C0C-E111-BE72-F556B47EDBFE": "Herbalism",
        "964A6407-E371-E6FA-A3FC-4ECDAD3615B7": "Hunting",
        "1E875D11-8C3F-53D6-5256-7FF5363FB1E4": "Locks",
        "B6B008F2-5805-C31F-842F-ED0C16D34484": "Mining",
        "114E1810-D8A6-72C2-54B8-7EDBC5D43A57": "Skinning",
        "27C6E09D-9CD0-41E5-B765-18F096CD8781": "Architecture",
        "432EF6B0-0DF5-5EA9-33A6-F1BE691772D0": "Astronomy",
        "AFF19B47-5E29-B9EA-1CEF-D017C9F440C3": "Biology",
        "432DBB43-005F-88D9-4F25-B5745D5C08D2": "Civics",
        "E38D3E9B-55CE-49EE-272B-C053D3C2E3B9": "Finance",
        "10657AA2-E10A-4C86-A814-B3A24B0CB252": "Gamesmanship",
        "E023B642-259E-69D7-4E72-334FE0A6EE64": "Geology",
        "58B3E565-2DAB-C967-766E-7D815EF1429B": "History",
        "D7F6DF07-296F-B231-3E70-9D6B46575709": "Law",
        "258BD584-26FB-F656-D15F-566BE8984551": "Linguistics",
        "ABE36CBD-1142-9809-FA05-C7DC4263B43C": "Magic",
        "761600DE-35EB-7B14-5980-F2430FFF85AB": "Medicine",
        "F259DADA-89E7-F08F-E24C-DA140F84FB36": "Music",
        "DEC0A112-9ADC-09D3-0FA7-3A59CFE8C008": "Navigation",
        "1D2EB61A-67FB-4F6D-FC1B-B5C36357CA6E": "Planes",
        "4D0FF632-CAC9-4714-64B8-43978DD90A7E": "Religion",
        "86BD9ED9-4768-239D-E755-BC198290FDBE": "Alchemy",
        "9CC50F9B-B8AD-B180-79BE-C309F1563800": "Art",
        "7229802A-2169-DDD4-6CCB-E755CCFAEB51": "Cooking",
        "E77A8B34-F880-E0E2-E6EC-42F4241F4FCC": "Enchanting",
        "B27AC929-722C-685E-E93E-CE38F49FF9BE": "Glassblowing",
        "AFD61488-049C-C7FC-2B72-26CBE7EAEAFD": "Jewelling",
        "F29D806E-160C-4EC2-923F-AAF1D5CDDB7E": "Leatherworking",
        "D7F51670-F6D9-5DD6-11D9-0CDBF35096A0": "Machining",
        "6C3E6964-F138-CA3F-DB99-4BFC7AF3E4FB": "Masoning",
        "0A68ECAB-D224-CF73-DB51-761BCFD663FA": "Smithing",
        "55565C71-B55B-3D10-9DFB-7C45D95BC724": "Weaving",
        "E5347227-42FD-9173-6C81-ADAD3E0ED6ED": "Woodworking",
        "A5B19883-CBDA-EC46-A859-96FF01651278": "Abolian",
        "B12FE4D0-480A-239A-DAF0-704850F5162D": "Abyssal",
        "820AB0A3-F21A-3135-DB75-89DCDF09A9D0": "Aquan",
        "B1B5365D-2DE0-AA53-A729-AC28BF8C8D52": "Auran",
        "81DADED4-7909-482A-BE32-76887642C172": "Common",
        "6EEF7655-4FC7-F5F4-0AB8-C31C31FEEDCD": "Domir",
        "0700727F-6C9E-4631-1140-B57A8E442137": "Draconic",
        "94D1A00F-4795-B1DD-6981-6CE3364AF1B3": "Druidic",
        "5C346F0F-D58D-2859-92EB-A347FA56899E": "Dwarvish",
        "42728623-5523-5986-672E-9A9FE5DD35B5": "Elvish",
        "4A5172E6-6D97-3958-C65B-F0792A660B85": "Enochian",
        "3098C163-7B26-7757-24F1-129C467D5BDB": "Gnomish",
        "6AB76ADB-22BC-904A-7D72-43FDCA112DD1": "Grel",
        "4767BD78-9829-6FC9-BD4A-5855F322CEB7": "Ignan",
        "22CC3970-0458-63CA-3D69-82A746B9A5CD": "Nagh",
        "16A53E58-027B-DF11-6AC5-72CA13B6583A": "Orcish",
        "2CB279E7-CD79-1A21-9F32-89184886D7FC": "Primordial",
        "641E712F-1B60-C633-14BF-C4EE0DDD4AF4": "Qini",
        "FBD22CAB-950F-8DAE-E052-65A88BF5205B": "Sign Language",
        "D267CD08-6952-99E9-B19E-52EC690546BB": "Sylvan",
        "EAC11C79-B399-7259-8556-8EDA88B7FCD8": "Terran",
        "E76097FE-D47E-FD76-B7AF-8F0C40A3BCA1": "Thieves Cant",
        "ABAE4F65-1A42-DEFC-21C8-11EBF883A484": "Umbral",
        "208E59A5-37B5-4DA3-97BE-8A1F540C94CD": "Cymbals Skill",
        "F9134996-0370-34A2-A101-13497D6631A0": "Drums Skill",
        "1DB53BE8-AB8F-CEB7-57E9-A3162F2AE4B3": "Flutes Skill",
        "3C5D9464-C206-44E7-015F-77A700D9BD9B": "Harps Skill",
        "3B5FFB0D-26EF-B237-1F54-63CFF4004E02": "Keyboards Skill",
        "7D2FFF31-8526-6AC0-42A7-BBCEBA432DBE": "Horns Skill",
        "937D4758-2CD8-1DA4-E47D-7E0DFD4E9C06": "Pipes Skill",
        "1D54B02A-B9BF-B47F-A22B-25182CE551F0": "Stringed, Bow Skill",
        "182CA00C-D9E4-C2AA-A243-B4EB4B8977B7": "Stringed, Plucked Skill",
        "F7FCBD40-CA99-88E6-BC5B-7D2F7D3C0EDB": "Zithers Skill",
        "45DE7B42-D548-498A-B7AB-C3DC1C660E57": "Natural Weapon Skill",
        "7BB6F92D-9C9F-D3D1-80FF-BBDBA3D06017": "One-Handed Melee Weapon Skill",
        "8F94D454-48C2-A031-AED0-943ED5B609AF": "Two-Handed Melee Weapon Skill",
        "2A16EE98-E160-89CD-4AC0-529BF36194D2": "Archery Weapon Skill",
        "850BDFE9-D36A-46AF-AD28-E1C533E140E3": "Firearms Weapon Skill",
        "1A3033B2-1FA4-485A-9D0A-1CD0BC92C961": "Throwable Weapon Skill",
        "F964C0DA-54EA-1EB5-ED00-8E9AD50FFA53": "Bending Weapon Skill",
        "937A5402-E933-4F87-8CAE-93427F47894A": "Heavy Armor Skill",
        "44F9404E-77AC-1F60-68A4-4CD6AE071161": "Light Armor Skill",
        "24495AD8-8EB9-488E-B816-5513E0A3DAA8": "Medium Armor Skill",
        "71E4E5C5-7AF6-9B16-90BF-8D9D6CCFD9DC": "Natural Armor Skill",
        "E973D6BE-E84E-4373-B134-BA8AA13BCD30": "Shield Armor Skill",
        "658B4D83-322B-42FA-82AB-49D3BAD33590": "Ageless",
        "9529EEA7-63A9-C572-ECA9-F523E87C58A8": "Deafened",
        "4638F1B5-48F9-4E81-95B7-E0325F40B5EF": "Diseased",
        "D9043BEC-2EFF-BC30-BE5C-270D7E1A68A8": "Poisoned",
        "A176161E-3825-86D8-7BE7-C1524A5B19D4": "Food Poisoning",
        "F5ACBDB4-D923-3684-57F6-FBF3F720AEFA": "Prone",
        "095BC6BC-06F6-74E0-2B8A-FC1F32AF809B": "Sleeping",
        "2A20ACDF-3BC6-B964-8FBD-F8E1AC581AA5": "Suffocating",
        "1E8008FA-B68A-8DE8-48CE-0EB121008FEB": "Drowning",
        "7B044913-E45E-04C9-F25C-5FB8B8C503F4": "Surprised",
        "F73BA661-ADD2-26E0-E265-FBEB7E5E6AF1": "Unconscious",
        "799B512F-C685-9655-0AF0-8CFBE0349130": "Truthsayer",
        "DCB240F7-C033-1B9C-0E27-446C5C1F4D0C": "Repelled",
        "BCC91DAF-AF10-497E-241D-ACD1BEC9E80E": "Silenced",
        "83EAD975-053D-1DDA-4474-F2128633500E": "Withering",
        "3E9BD118-C5FB-2C0A-01CF-72DC2C4ED0E8": "Challenged",
        "D5A31654-692A-B4BE-49DC-2B3360F76D4A": "Confused",
        "B5E6379E-5869-4B82-3EB4-9ACB48D2F82A": "Feebleminded",
        "3188FB3B-C860-43D4-9BA0-40364C460385": "Resting",
        "8A6575CF-BCA9-2E70-5ECB-21FE529FCAB6": "Soul Breaker",
        "39F1A03D-A7C7-4E90-98FD-14F508074BC5": "Unimpeded",
        "EC8F4821-26B6-4874-86E0-2B344CDC8B4F": "Reckless",
        "E7FDB796-26DA-E0F5-8F88-C21FE01D923B": "Concentrating",
        "AE967694-B94B-F0FF-B680-829FDE6E8D58": "Searching",
        "A311574A-3513-44AB-8C70-3C3006F6CC40": "Consecrated",
        "321DA526-E48E-F202-10FC-D3A2B03485F2": "Frightened",
        "057BA9B2-177C-40A6-8815-8063DDDC0D9B": "AOE Redirection",
        "83234E69-6C06-3392-256B-CB3796C180A7": "Incorporeal",
        "9DF8FF4C-33E8-8095-4876-ED3DBCD50B79": "Spell Locked",
        "2A64D1E8-7C3B-4F92-B5A8-E19D64C72F35": "Abjuration Locked",
        "9E15B7A2-3D48-4C61-A927-F84B21D6E593": "Charm Locked",
        "6C82F394-1A5D-4E76-8B34-D29E75A1C648": "Conjuration Locked",
        "4F37A8D1-9B62-4A15-C783-28E91B5F4D76": "Divination Locked",
        "8D21C6F5-4E93-4B27-A164-73F8D2E9B5A4": "Evocation Locked",
        "3B96E4A7-2F51-4D38-9C82-46A1E7D3F925": "Illusion Locked",
        "7A45D2B9-6C18-4F63-B591-82D4F6A3E1C7": "Necromancy Locked",
        "5E63B1C4-8A27-4D95-A348-91C6E2F7D8B3": "Transmutation Locked",
        "1D87F5A3-6B42-4C19-8E75-34A9D1B6C2F8": "Arcane Sphere Locked",
        "9C34A6E1-5D78-4B26-A493-67F2E8D5B1A9": "Divine Sphere Locked",
        "6F92C3D7-1E85-4A64-B237-58D1A9F4E6C3": "Primal Sphere Locked",
        "1710A01B-FAF1-4684-5050-A10386685D35": "Inverted",
        "DB1C8E56-CBD7-09E4-0FBF-148F28A93D67": "Fleeing",
        "DA2F74EB-CF67-AEEB-0DE1-376C6BB7CABA": "Holy Turned",
        "D31E3DD8-FFA1-67EC-D3F4-FCD323059091": "Disguised",
        "EEDD357F-C1CA-44C1-A53F-DD06EEFBA597": "Holding Mastery",
        "D09D563D-0689-4B56-AEAA-5A254DC408A4": "Performing a Melody",
        "2858158E-5E6A-491B-9824-290DE8D692D8": "Shadowform",
        "331C8511-F8A7-4626-AF17-48FAF062FE50": "Fate Card Suit Love",
        "D9394C92-068A-FAFA-231D-289157FD2980": "Fate Card Suit War",
        "34987D5C-BB13-7633-E28A-C3DA4BD458A7": "Fate Card Suit Prosperity",
        "6A31B8DA-8AD6-ACC1-9E3A-3A8DD77FD43D": "Fate Card Suit Change",
        "C8163F62-7B18-8221-A60D-C9DD775682E3": "Trackers Brand",
        "D343892B-338C-4FBE-BEA0-2015FE503F43": "Donning",
        "398DD6E8-AFAE-EA0D-6FE9-C22842D53775": "Doffing",
        "ED30CCB0-1645-B97E-B9A6-867D8D0094BD": "Reading",
        "426C7E0B-EF44-498C-10B2-B50A9E28E45C": "Training",
        "78C51D2D-5178-551C-1249-B5DDA4083098": "Trapped",
        "477A7977-60D2-4B9C-96B0-6ED4BFD6437E": "Locked",
        "36C061BF-E480-4334-961C-26500150E3C4": "Integrated Object",
        "B84EBE3F-B385-4CEF-9C69-648086C4CB7D": "Summon Tag",
        "5AA76DEE-CE52-E021-67CD-8C701DA0E56F": "Awake",
        "FD5CB2E3-B247-274A-5B42-25F538F72661": "Weary",
        "A707303F-CE4F-26D8-8846-B5178D3F1DB2": "Nondetection Effect",
        "B9DC5478-8F86-29F7-15D8-1C8CE8171F12": "Spider Climb Effect",
        "A13061B6-2390-14E8-34E0-366C0E0CDE34": "Water Walk Effect",
        "5D939B6E-B9BC-7AC5-5143-4F00F4189EA3": "Casting",
        "5833A733-D277-0A60-3A94-A0F355A79A80": "Casting Ritual Spell",
        "62ED7394-9C33-D41A-C426-1BC6723C999A": "Crafting",
        "E49AA8BA-1F60-4FD8-B3C0-852BBA3978C3": "Crafting Progress",
        "1C4D81BB-FB79-68AD-E881-28D874927FD2": "Disenchanting",
        "FF9A38A3-5F35-F083-E153-7DF41B0C0826": "Lockpicking",
        "3F171782-CC56-32DF-81B4-8C0ED89F47F4": "Gathering",
        "7B3E9C4A-1D62-4F08-A5D7-3E90C1B84F26": "Excavation Found",
        "A64E346E-F58C-5FB7-BE30-71232C06897C": "Slightly Drunk",
        "67B9CAB7-1C48-41E0-AEAF-2F4A352075C1": "Drunk",
        "09FC38BC-6060-4B67-A33F-EF7D448F71F1": "Burning",
        "996886D6-67F7-2A7D-0336-9324C877CAA6": "Melting",
        "F632281D-2F16-FFDA-FB95-2E958988F01F": "Corroding",
        "F90FB02F-2549-6FE0-A162-CC3FA7C90C67": "Dissolving",
        "E3169368-A4EF-476F-B699-5EFE62C7CE2A": "Wet",
        "99951E6E-9801-4E3E-A684-4D111F2D6624": "Chilled",
        "84CD1B4A-0D7C-9385-8128-D91339F269BF": "Freezing",
        "6EFBE105-7632-4C64-BC04-206CEAF663E6": "Frozen",
        "E5452E0D-251E-4BDD-AC25-DADD00A7BEC7": "Electrocuted",
        "F711788C-2BB4-4114-8339-B3C85BE0D52A": "Shocked",
        "CEFF8A40-503C-FDA3-41B3-43DC06BF762D": "Blinded",
        "0313A4D7-C1C2-4D1B-8DD7-CC6EDBC42065": "Dimmed",
        "4B74DA87-EABF-7EBA-D283-C5A1FEF483C9": "Sightless",
        "3E053858-D7C1-4E36-91A7-AF05EF5D0C62": "Photosensitive Eye Strain",
        "3C038AB7-2684-A787-1809-6C8224DBB285": "Extreme Photosensitive Eye Strain",
        "A1F1FAF2-DA1E-D537-36C2-2B74DC82CB12": "Piloting",
        "DDC66C31-4093-84AF-18BB-093D924B8738": "Piloted",
        "FF8D219A-2A83-0EE5-A222-E748753E8D0B": "Riding",
        "680EFB9E-3CFB-491F-A620-5BABF800131C": "Mounted",
        "F13F6A58-FE91-F24D-12BE-BE7CCAD81A40": "Ridden",
        "E2054884-038E-3D6E-56C5-19ABBFED8379": "Obscured",
        "1BA5473E-6218-6688-1C68-DCA4FEF00A97": "Sneaking",
        "47667406-1B72-9D60-310B-D8CF6BFE397D": "Hidden",
        "84B91EEB-2FA6-D1CB-1347-75BFBDA2A6DD": "Invisible",
        "B6232175-C357-9A97-0ACA-7ECC67563635": "Greater Invisible",
        "2A2845CD-949F-06E2-E6B2-98CFD5603241": "Ethereal",
        "B9693027-E65E-DAFF-B2C5-7CF31927184D": "Flanked",
        "3A2FD2B0-28A9-62D3-CB13-A22974618CDB": "Partial Cover",
        "A126C1D6-FE3E-5578-DCC6-CBBF8742E9C1": "Full Cover",
        "BE6DC590-4EB7-B297-5AC6-8E47AA4E00EF": "Hunkered Down",
        "306CD53D-AD03-DD13-FDDF-34D9120613CD": "Encumbered",
        "49F87D1B-3878-789E-D52E-65BA7F2F4218": "Heavily Encumbered",
        "1AEA950E-A57E-6059-448A-E4A6FCED97A3": "Shield Encumbered",
        "466374FE-D89C-DB77-1809-7249A831015D": "Armor Encumbered",
        "10278E95-5320-A57E-471F-C3E7AEFA70BA": "Bolstered",
        "EB6FB558-7427-A647-8F46-D2E8C25F1F60": "Exhausted",
        "BF31EE0A-5B3C-370B-0118-96B067CFD929": "Paralyzed",
        "F2CD1603-38A4-85E9-D148-CE3D429310A2": "Banished",
        "D218F4FB-5693-87B9-93C1-776FC1F7ED90": "Stunned",
        "B404E7CA-C073-473E-A799-A71601A22DE5": "Dazed",
        "6CCB9287-4420-962A-2952-7469394A5C7A": "Backlash",
        "DD4C0995-C3D2-43A3-CFC7-226C3005274C": "Charmed",
        "D2E7BA2C-562D-D4AC-7F71-13E4AC540484": "Dominated",
        "185D46F5-09E2-1921-F721-FDD0A2AB3EFC": "Possessed",
        "E4A34093-AAAB-6453-BCE0-FBA65EE263AD": "Grappling",
        "0C2A8037-B0BC-8300-C818-198881B00E7D": "Grappled",
        "E34AF232-5438-88FC-9A9F-73850CCCFD51": "Restrained",
        "F40E19A3-FC86-187F-050E-8C8B69761353": "Immobile",
        "BC6671F6-DEDF-9C1B-C459-226E7388A00C": "Slowed",
        "90D15611-2833-46D6-A72E-04C16C87972F": "Hindered",
        "9FD8A4D0-B09B-C068-D475-7EAB358D1A1E": "Hamstrung",
        "64318AE9-0187-4C71-9163-084694BCE180": "Sluggish",
        "75B1C2F6-8E21-0ED0-32AD-C49B68804CCC": "Rushed",
        "091B2BEE-7F61-D7DB-0CF1-6D255F4B7663": "Hasted",
        "EAA88590-DB1D-7C46-F523-E87A31912777": "Dizzy",
        "9853CC89-CE34-4077-5453-59605542265C": "Staggered",
        "BE55F5A2-74F7-63D0-D169-900934E2E26E": "Impaired",
        "3AD27E05-55EB-4B79-83F6-FC88ADEBD342": "Exposed",
        "75682F12-AB67-401B-97D7-F1B7354333CA": "Squeezed",
        "B45813FE-321A-EC7F-F008-12B8FD33B524": "Very Squeezed",
        "98FEA101-0910-41AE-9E20-E126C8B73AFC": "Protected",
        "256BCFFB-B0BF-7C7A-B238-3126CA2AC20C": "Powerful",
        "091CBC18-FF1D-6072-3190-90EFAEDDE6F5": "Greater Powerful",
        "C518B122-A108-4EA3-B140-E6211C1071BB": "Empowered",
        "B49068EF-8A0A-0002-3476-E214504C3570": "Weakened",
        "CAD2A16E-0DB5-91C5-F7F4-24F46B28011C": "Greater Weakened",
        "F450C824-98D3-D0B1-D6B1-C326F15F1578": "Enfeebled",
        "DD53CA8E-DF3D-9AF4-49CB-9C61926BBB93": "Defenseless",
        "F55C0D31-091D-0F3F-74F0-AEE4C20BE1ED": "Vulnerable",
        "60912827-B1B3-E9D7-6FBF-1FE976DDD04E": "Shelled",
        "8912E655-C826-4CF6-8F3C-B036AC710CE3": "Resistant",
        "1194F357-C419-2931-27B4-3B56F26BFBA7": "Invulnerable",
        "88F8F0BA-3E96-4D9C-AFCE-008D849B0BFC": "Hunger and Thirst Tick",
        "6FAF0CD0-26E2-60A3-0608-A3C8E1828027": "Thirsty",
        "C1F4E2B6-DA45-8CAC-322D-C5DF54FFC418": "Parched",
        "2611657A-9C0A-4680-AB51-62235A6D8D79": "Desiccating",
        "5672B433-B59D-561E-B4C6-79565C46B3CA": "Hungry",
        "7780B669-28AA-680E-D28D-397B05A15FC6": "Starving",
        "457ADEAA-1D5D-9AB4-EFC9-2B7120C78BAA": "Petrified",
        "DFCF49C0-D5BC-C56F-A7C5-DC8D134ED7D7": "Petrifying",
        "3BE713AB-37D7-630B-C1F8-9470784BA33E": "Bleeding",
        "22E33A8E-DF5D-2596-8E2D-0E8A8528E47C": "Moderate Bleeding",
        "BAAA237B-1AA7-0409-5BC7-1A6720573069": "Severe Bleeding",
        "A5CDC77C-D224-DD5F-291B-EF8DF2EA443D": "Maimed",
        "9437F344-1461-B4C0-E196-6BA1A34ADC94": "Maimed 1",
        "9154FF1F-721A-2BCA-1AEF-24AC7B32FE4B": "Maimed 2",
        "46F27428-2B73-50F7-6F0C-D4FAFDB753ED": "Maimed 3",
        "4D27433B-6F72-47BB-9A60-B80493F22D65": "Maimed 4",
        "E4994653-49B3-D768-35C1-36C8DE40CC1A": "Maimed 5",
        "5C557D5A-B85F-DF45-3CF6-6739D2BD70EC": "Maimed 6",
        "44D4504C-9BD5-0B65-F8E2-6DC4A0F820B4": "Maimed 7",
        "1DEE12B6-D23A-7470-812E-CE4C77AAD395": "Maimed 8",
        "4AEF8F40-B779-C0AD-4455-2DABE7B1D14B": "Maimed 9",
        "A230F5E6-B6AD-8091-4F59-5E454776B4FA": "Maimed 10",
        "CEF623E6-6A71-37FD-29C7-12988B43151A": "Arcane Fatigue",
        "F8E5F274-2F31-1340-6167-ED9131E81A88": "Arcane Fatigue 1",
        "E18A79D1-AA69-7F80-2579-78B583E0771B": "Arcane Fatigue 2",
        "20F461C2-67CC-BEF6-E02A-4E9A464EC397": "Arcane Fatigue 3",
        "EF165E68-DD93-90C8-A848-01D93B041CBD": "Arcane Fatigue 4",
        "DA5A18C5-FDE5-D20B-0E3B-07B68E6C7C1C": "Arcane Fatigue 5",
        "683632D7-756C-0165-9E94-27EA95A53A53": "Arcane Fatigue 6",
        "E19F0AB8-E760-D84A-85C3-1A14E7DFE399": "Arcane Fatigue 7",
        "5F87B80F-A8E4-A3BE-6FC6-3B5BC0A669E9": "Arcane Fatigue 8",
        "E29189CC-A2FA-B06A-5DBD-8551A3259829": "Arcane Fatigue 9",
        "BDAF9378-AA7A-445F-D24F-8E6A0EE84456": "Arcane Fatigue 10",
        "4744C91C-51DC-4C36-8C6E-DB801410FF61": "Blighted",
        "5CB84B6E-E636-B4A3-3864-910DBD3B63B4": "Blighted 1",
        "1B912A78-2334-D265-2674-7AD764534D56": "Blighted 2",
        "7F938839-F44A-FA43-05FA-BAAF79B7A05B": "Blighted 3",
        "FCC88F77-777D-56B1-913E-E676C90E39E3": "Blighted 4",
        "655383C0-8B0C-3B33-694D-26404400626D": "Blighted 5",
        "36B68995-C875-199D-20E8-1A1098F846B0": "Blighted 6",
        "D9668790-E866-861A-FDE0-D23D2903B0FA": "Blighted 7",
        "90D143BD-9CC9-06F7-F339-03F50C27D958": "Blighted 8",
        "8A3B8D76-ED7A-560A-166D-73093DE6F4E9": "Blighted 9",
        "E64821CE-A9A5-D2C3-4116-8A8D5DCA4D30": "Blighted 10",
        "EB6632D3-5EC0-4E4D-5C6C-1BCB7EF57022": "Shielded",
        "BF823982-6FC8-51F0-F452-5BE1C949FBA6": "Shielded 1",
        "36DA5B89-CA08-3940-E798-FCAE6BE775D5": "Shielded 2",
        "8346CCFF-3A5B-F0E4-CFDE-6CF1D1ED3368": "Shielded 3",
        "E5314BED-1269-3A65-8C15-01E80A3A8E23": "Shielded 4",
        "E614D75F-CF27-D169-3D91-0D33D9CE354B": "Shielded 5",
        "A831D8E0-4DC5-4FBF-4A4C-2C9955AE230A": "Shielded 6",
        "631AAD91-F6A5-879D-5BD6-B7F885AA7FC9": "Shielded 7",
        "BF1C1C48-8171-90B8-CD83-F2768348629F": "Shielded 8",
        "2A63EC91-E5B1-17B4-DFB0-199F9E2084A5": "Shielded 9",
        "01B0F693-7D8A-C588-9B34-CD1F323D8433": "Shielded 10",
        "D98B076A-3A38-E225-B8E3-A646C69AA29D": "Judgement",
        "430F1BE4-6522-4468-8E27-426B23D003BF": "Judgement 1",
        "9EFD0898-7C92-6DE4-DD2F-D6F75ECF3B58": "Judgement 2",
        "90FB0BFB-6186-5E01-FD8B-0315D6DFB809": "Judgement 3",
        "CDC5CFDA-B09C-4A68-820D-6C74D90BD595": "Mirror Images",
        "D9B64F38-A817-47B8-AB07-60D59F3D893C": "Mirror Image 1",
        "AE20C09B-76BE-5BC4-4E33-6E8CFE1F0139": "Mirror Image 2",
        "479A4B5C-43F3-3559-979B-5BDA8A379F07": "Mirror Image 3",
        "80585488-CC4B-4A80-8ECE-CB1CE83F2407": "Fully Rested",
        "82788F70-EBEF-44C4-80E7-6622AD20DD60": "Invigorated",
        "FF30B76E-785D-2CAF-FC66-C131D0548808": "Fresh",
        "658483AA-34DE-74E5-C974-E3E202C31CC7": "Barely Wounded",
        "C97076EF-FED9-19B4-D109-C22F9BC740E8": "Wounded",
        "44B8792E-632E-2651-C666-67DFD181E92A": "Bloodied",
        "298BE1DD-2917-476E-D79C-92CF8C598926": "Well Bloodied",
        "D5DE14C4-3194-87BC-D767-6D45BDD90552": "On Deaths Door",
        "8AE129AF-52D8-CCE8-706A-85767DB52740": "Dying",
        "9FEE2E8A-9CF7-D74D-5D16-B86C2603A1FA": "Dead",
        "F07C595F-D2DC-4CE9-904E-A4D73ABF9DEA": "Stabilized",
        "99C862B9-D6AE-4E18-7803-A6F9B42A88E1": "Crippled",
        "78C6CC42-BCCE-4F22-9FC5-41F8D7E70944": "Dying State",
        "EE063289-1AF3-41CF-B73C-64A0556E6D07": "Dying State 1",
        "2EAAA2E8-1B9C-196D-3E58-C29C09FF8492": "Dying State 2",
        "A9678CB1-11D3-55A3-E3C9-F342B2E40980": "Dying State 3",
        "611DFED0-9AD1-5500-AF5B-DE7CBD9DDF64": "Recovery State",
        "553734EC-33D3-4527-AB2E-EF48ACED8DF0": "Recovery State 1",
        "9AA7588A-4575-9550-343D-6ADB0C74C17F": "Recovery State 2",
        "660E3133-44D8-E79F-C0ED-A26CE31D6E32": "Recovery State 3",
        "62E83DEB-4569-AE3A-F671-FF514C508FD2": "Rotting",
        "F7A1C3B2-5D64-4E18-9A70-2C8B41D5E093": "Spoiling",
        "10C28483-A0E9-467F-993B-CBC440546A52": "Received Prayer of Healing",
        "981477BF-20AC-B5B0-A9A9-A5CB4459884C": "Challenge Roll Assistance Roll",
        "82BBB3B6-4646-48E8-A5A2-8DC0947A91D0": "Damage Roll",
        "ED5B44EA-7438-9582-A388-04EFF342E460": "DC Roll",
        "AD80D31D-898B-66CE-0894-1335D11B1529": "Contesting Roll",
        "A063F21A-02D9-BA39-9C71-09C8E8122693": "Essence Roll",
        "4FB7452A-F130-40C3-83E6-5E92C329D7B2": "Healing Roll",
        "52949AF2-7C18-4BA3-754E-4BF898A67AFD": "Recharge Ability Roll",
        "28B4E29C-5D8D-57CC-7634-761CEBD01190": "Reduce Damage Roll",
        "9909BE44-99AE-8780-BB12-BD99BA6E672E": "Regeneration Roll",
        "E26FC164-16F5-E38B-66F9-337FAEDE2A67": "Skill Roll Assistance Roll",
        "73ECB998-6C8E-1854-FBBB-EF02AC2AC0EE": "Skill Roll Retracting Roll",
        "5740CA49-006E-A7A0-B46B-6DDED6CD546C": "Spell Melee Attack Roll",
        "DD280A3B-6F1D-4CE9-9EFD-505A74D0C07C": "Spell Ranged Attack Roll",
        "E5016E3A-6A12-2287-5F48-5CFAC863E967": "Summon Roll",
        "4634635E-4E82-DFB3-8411-27A6BFB8CF0F": "Temporary Vitality Regeneration Roll",
        "5E2689A2-0F7D-1E27-F4D5-CA09CA5C2591": "Temporary Vitality Roll",
        "1EBE0C5D-4D59-F08A-B118-13286A198ED5": "Weapon Attack Roll Assistance Roll",
        "2FE8DFB7-FE61-4862-AF71-3523262350A0": "Weapon Melee Attack Roll",
        "3F85CA97-F9B2-A83A-FDE8-E523FD99346C": "Weapon Ranged Attack Roll",
        "9C752002-0C85-40D8-8DC0-D43AECBB2207": "Armor Bending Roll",
        "5DFD335C-B12A-4B3C-9FF6-560E12D9045F": "Dying Stratum Roll",
        "FA17A3A2-3068-C84C-1EA5-C511F71FBD8B": "Gathering Roll",
        "54DC30E0-923C-4BBF-A8CC-570B0068E8A2": "Crafting Roll",
        "E1C8D281-0DC7-4883-8381-5630E23AD99D": "Excavation Roll",
        "77A044B7-7041-CA96-3C63-BB718B15A364": "Damage Over Time Roll",
        "9878714A-27C3-D737-88B3-E8C1EE63A20F": "Extra Damage Roll",
        "42A38751-5549-CDE7-528E-AED309A2B07D": "Extra Weapon Damage Roll",
        "ABF66E1E-DA79-4329-31FA-70D981032C06": "Skill Roll",
        "F1CB1CCF-138F-0B16-266F-3AFE1AB8C73D": "Extra Healing Roll",
        "C823C739-A9DE-AA5A-07B8-CB67F578F880": "Increase Luck Roll",
        "DE5B6A74-0024-FFDB-C5C6-B0248D956515": "Reduce Luck Roll",
        "DB30C685-3830-9AEA-D8FA-D92FEA762982": "Increase Mana Roll",
        "905613F5-A045-BC0A-3686-CD1EC15060C5": "Reduce Mana Roll",
        "99DC3B29-702D-08D0-346E-AA4359EA1D82": "Extra Damage Taken Roll",
        "CC2CEB6B-CEFB-481F-911A-A47A427D5EB2": "Lockpicking Roll",
        "5FC40097-3C6E-53ED-0947-486FCC6DE627": "Mana Drain Roll",
        "F5BC82EE-DBDF-4594-F850-0C49E4292AC7": "Temporary Max Vitality Roll",
        "67B41E3F-5BF3-33A0-B459-7B8768B71933": "Training Roll",
        "F020D412-8836-1074-612E-D703B7488CC7": "Ready",
        "C70D6C1A-5A4D-AB29-EE60-82BDFDC25392": "Disengage",
        "AEB8F842-8D30-D028-4B0C-48847C497BB4": "Withdraw",
        "70A2ABCA-C777-3887-9A7D-2B77EF757EC4": "Help",
        "B2D3417B-2700-11CB-E17D-38DECAF66F1A": "Spot Hidden Creatures",
        "5B518ED7-4CEF-72BE-F20B-912598267714": "Search for Hidden Inventory",
        "2371CC7D-0BAD-DA78-7067-32361F5DDDBC": "Regress Grapple: Restrain",
        "98BE66E8-2F3D-DFEF-B4CD-DBE1EAA9ED4D": "Regress Grapple: Escape",
        "3B98A7F7-1A94-4E3F-A85F-25BDC8430874": "Release Grapple",
        "414E3282-1E29-44B5-95C9-7DA1D55EFCCB": "Advance Grapple: Restrain",
        "4476C212-A776-CF84-67A6-5E79C77CB381": "Buck Riders",
        "AB7AE7EE-C8DD-264F-6115-8B75F6B13CD1": "Huo Stance",
        "65D8750E-69AD-D583-0FB1-84B1E6476479": "Shu Stance",
        "212A0039-0A7C-436D-BC59-C87C41C5B567": "Yun Stance",
        "E9FC70FC-7F7C-48AB-B2AC-E25172104583": "Wenhe Stance",
        "F77D6A8D-D5F2-44ED-81DB-74ADCFF5B366": "Beijxing Stance",
        "2DB5900E-FF79-9BDA-ADA1-BE4DD50BCFE6": "Shizen Stance",
        "B2A59EE2-7D38-D406-0C34-51F1E59DEF6A": "Courtesan Stance",
        "0E37C3D2-CFA6-A1B2-F352-D2121868C425": "Spider Stance",
        "A3DCD286-9228-40C7-7ABF-3955559C3D56": "Dragon Stance",
        "AE49A833-AD4C-3715-6155-BEA0EBA374DC": "Drunken Stance",
        "3C0D5144-0BE8-6159-948D-E8E978AC4E19": "Puppet Stance",
        "B82D8A08-18AC-CB5A-91DA-CB7CDD03EE3C": "South Stance",
        "A922EFAA-2C01-88B9-6CF3-06D8C177AB05": "Pain Stance",
        "C3FB8547-44FE-7DA8-9601-DF2CBE44019A": "Blooming Fang Stance",
        "4B808990-16EB-52F5-0E88-EF0809F4C299": "Barbarian",
        "D656F798-435B-26F9-0332-0E489BBDEC7F": "Bard",
        "6E4C0D81-46B8-BFF4-2D31-827EC8ACF3A7": "Champion",
        "2BCE19F7-76A3-EE20-3EA3-C2B8ADA88878": "Deathbringer",
        "63056B34-DBA2-E711-1456-ED5E032A058C": "Druid",
        "B9E74EDE-8D63-B137-F094-46054EF61512": "Hunter",
        "44223199-712F-A11F-BADD-EC10813AFBF7": "Machinist",
        "74D15961-05FC-1D0C-DDF6-F518F026F22B": "Monk",
        "D28986FA-DCD0-F760-9F58-9E0AEF386F38": "Paladin",
        "F573438B-0CA0-C945-B90F-5EFB6E1E1C99": "Priest",
        "F2D31321-42E4-926B-892A-DF0A41176D14": "Psion",
        "90474F60-446A-A55D-9B1F-9F974AD13D87": "Shaman",
        "92303965-8EFD-8D5E-C18F-B4FF3A38CA72": "Sorcerer",
        "BD274DB4-75BE-BF81-FB33-A225748563BC": "Spellblade",
        "35EDCE49-85F9-A36E-4407-547E0153DA05": "Summoner",
        "D3F66A5C-A446-2217-697F-C174E2E5801E": "Thief",
        "4DDA161E-31D6-9894-58C7-CD34B21734BD": "Warlock",
        "2BCF5CBC-1E87-E654-8310-E56EC051E559": "Wizard",
        "1ADB2848-6D7C-16F5-6681-234232DC13EC": "Trail Of The Artillerist",
        "26239004-79F7-DF41-C6AD-B3D9AA565B6C": "Trail Of The Berserker",
        "F2FDFE14-A998-81D5-024E-3CF1B0B26E43": "Trail Of The Broken Limits",
        "F6CFA733-CEBD-41EE-B357-2CCEA45FECF6": "Trail Of The Hallow Mind",
        "9DF0BF22-2C59-D288-6E7A-E0708737BCD3": "Trail Of The Painbearer",
        "68781B19-86F0-8233-4F14-F1DE713BE79A": "Trail Of The Reaver",
        "32C6C141-FBDB-45AF-85EA-7232284EBEC0": "Trail Of The Shatterguard",
        "2D67C292-177A-C7C1-8278-275AACE6DC3D": "Trail Of The Takedown",
        "4A5F251A-EADE-4E22-AA84-28B796B84121": "Trail Of The Untamed",
        "2050C757-11AC-12E0-BCFC-E921ABBC499E": "Song Of Color",
        "71C75E03-B9EA-0F1B-226E-0D0139966268": "Song Of Discord",
        "92CB1BB5-DF5F-CD84-A2AF-4EE1B85781B5": "Song Of Knowledge",
        "11DCFC7B-887A-7FD3-8423-DFC5B16AD336": "Song Of The Celestial Choir",
        "1DA56AF8-0D7A-4137-BE12-1142CC7BB78A": "Song Of The Dancer",
        "D25638CA-09AF-2722-FBA9-5074DBDE3410": "Song Of The Fey",
        "DB6A91D7-7F88-7FB2-1783-7393CF041B9C": "Song Of The Loom",
        "5D90B5B1-5AF4-4365-6468-2697BE57BFD2": "Song Of The Sea",
        "5FF654D1-19D8-4055-B1AB-06F5A0044806": "Song Of The Vocalist",
        "6FD9898C-F2F7-0D60-6E80-2CE855ABD6A7": "Training In Bushido",
        "4DF9E59E-1BE3-105A-277D-E7A87EE79C5D": "Training In Fey Archery",
        "73BB4DD3-386E-B2D0-B172-49968B3F3769": "Training In Precision",
        "C6FDF4E8-CFEC-E603-8994-496C3576E010": "Training In The Commander",
        "327BD65F-5AE8-F70F-4FFE-5FB3D50EB858": "Training In The Dragoon",
        "9441BB9E-7252-51FD-4385-835709322AC3": "Training In The Duelist",
        "E9E1745B-7B0B-4082-BE65-72EAFEAA2CB1": "Training In The Gunslinger",
        "0A9A7DD9-6446-41B4-959E-82C3F965E6F5": "Training In Juggernaut",
        "C6630706-C18B-AA42-BF23-58FDD517D1FC": "Training In The Sentinel",
        "BFA219C5-CB8E-BB94-3DA7-702E0E894775": "Harbinger of Blood",
        "522C7991-484B-DDFC-F50C-B1B520E07E70": "Harbinger of Corrosion",
        "7037C56E-B09E-02E2-E53F-7233EF1591CA": "Harbinger of Permafrost",
        "EBF9B1EB-6800-6251-4BF6-36BB50D97595": "Harbinger of Rot",
        "5D590449-A397-5839-0666-035D487D8C2B": "Harbinger of the Artifact",
        "458DF854-358B-41BE-53C1-F51A0EF0055C": "Harbinger of the Soulforge",
        "BB578862-6480-D244-0C6A-2543AA6C29AA": "Harbinger of the Spellbane",
        "9C4D3940-9EC8-EEFC-C417-1ECBCABE793D": "Harbinger of Undeath",
        "FBDDC2CF-8E49-005F-EEB7-ADBA5ECE045A": "Grove Of The Deep",
        "6ADDE9C0-261B-C011-826F-E8B6522414A3": "Grove Of The Desert",
        "BCFE1123-F449-4A98-A4C5-1A3EEB9DF3C5": "Grove Of The Forest",
        "9C58554D-BA6C-BE4C-30A0-B8A384DC5C38": "Grove Of The Heavens",
        "68F4DF94-3345-74AF-EC27-4CCA564D4333": "Grove Of The Infestation",
        "E0135F81-E291-0553-9FF8-0BCB67C342C4": "Grove Of The Mountain",
        "3F5E1288-D9E3-4B24-8985-333404AF172D": "Grove Of The Skinwalker",
        "313B4B34-2D4D-7632-9BF3-05D91298AF59": "Grove Of The Swamp",
        "7F640E10-E070-C716-5ED1-A5AA5D2C6971": "Grove Of The Void",
        "54D69C32-CE87-25D7-A8B9-D3FF8008CE06": "Grove Of The Waterway",
        "CEFB07FE-0663-45C6-A532-39E1E70EE2D0": "Conclave Of The Abberation",
        "0B3A4002-A031-7DCB-6E61-0F604311B485": "Conclave Of The Bounty Hunter",
        "8209208D-478B-C896-B674-E52D34497C9C": "Conclave Of The Construct",
        "CCE2F7CD-502B-C8AA-37D4-70FE8F416A52": "Conclave Of The Demon Slayer",
        "1C3122FE-AFA6-4FB1-9E36-AACAC3FB19A7": "Conclave Of The Dragon",
        "4C10C158-5474-4B43-AE85-058806DF3017": "Conclave Of The Marksman",
        "D9903CA2-4D2C-0352-FB50-8067D5898D9D": "Conclave Of The Monstrosity",
        "941C9CE1-2262-0D92-4448-0C309A0440DB": "Conclave Of The Ooze",
        "D3DE0245-0CBE-1FE3-04F8-D2BC22C9A849": "Core Of The Necroforge",
        "F6AA8864-18EE-0140-0C65-8EEEFE2FE5E4": "Core Of The Rimeguard",
        "090BED9F-3D77-FD4E-114C-3CA2963C896C": "Core Of The Voltaic",
        "0811463E-C4F6-72F5-791C-E8CA97F730EE": "Core Of The Pyromechanist",
        "E73758E2-453A-B5EA-A8AE-0418702C3E90": "Core Of The Quaking Bell",
        "0E819470-A8D6-FB8F-F1AE-74AFB05BC777": "Core Of The Graviturge",
        "1E05A4A2-6B1C-1F0D-1A65-17E83C04EBBC": "Core Of The Venomworks",
        "7D77CBED-1030-882D-64D9-C53F8BD7CD18": "Core Of The Dissolver",
        "F5EE40A5-D18A-4186-82D3-E21075B43CBA": "Tao Of Gentleness",
        "70863B88-1DB2-4464-AF5C-542B251E6013": "Tao Of Ninjitsu",
        "6372D1C5-6BB9-41A5-BFD0-885C852005F4": "Tao Of Senjing Ganrao",
        "84CDEE1D-44C2-AE0C-B5AF-BF79CF08D91F": "Tao Of The Blooming Fang",
        "294AB63D-0E01-A8C4-D936-30A0FC055F36": "Tao Of The Cloudrunner",
        "FDC0E3EB-402E-156E-9EBD-EF8C4E2DA59C": "Tao Of The Courtesan",
        "FF0AD09F-3CD3-3585-6D6F-AF14E13CB5AB": "Tao Of The Dancing Spider",
        "8AC31F16-0DC8-7FEB-FBE6-8139CBC59FE7": "Tao Of The Dragon Warrior",
        "D2FE0631-AD39-F0FA-7B69-8DE9642D54BB": "Tao Of The Drunken Master",
        "9CA1E148-712D-322B-DBFC-3EF6F18A300D": "Tao Of The Painted Shell",
        "5AE6E8F3-89E6-5D5C-DE25-D30B573B08C3": "Tao Of The Southern Star",
        "61C890AE-1120-24BA-481D-B19875C9EB92": "Tao Of The Ten Thousand Limbs",
        "814E499E-5294-679B-65B4-B4A8D5DAA5C0": "Oath Of Honor",
        "8C6BC8F9-F7E3-6F7D-22DD-06D3760366A6": "Oath Of Love",
        "BC71C175-ED2C-4BD2-87D4-C853CAE47D56": "Oath Of Mercy",
        "BEDCAD25-AC66-B6A5-AD3E-6B4D9DAF2422": "Oath Of Purification",
        "57E18214-3561-D675-C8A8-60A20FA09BC7": "Oath Of Revolution",
        "E25DE317-AB3A-45A1-AE7E-1F8F5A6C47D2": "Oath Of The Guardian",
        "21F13AF0-6DD9-E792-E115-DD6A4E54A7B9": "Oath Of The Spellbreaker",
        "A67BE9E8-392C-FAD1-4C84-8C9C8ECAB0CB": "Oath Of The Stars",
        "08B1A969-4874-61C8-41FD-C86A39A780D6": "Oath Of Vengeance",
        "F794E50D-95E8-A7AB-D7BD-CC2C3035CFEC": "Faith In Dreams",
        "7BAF9F56-B8FF-4FBE-886F-30F055A568B3": "Faith In Fate",
        "B516E119-A619-2C08-813B-49F9DF7FCA60": "Faith In Fire",
        "39E2635A-195A-B8B9-F7DD-1DA4E0EC53F6": "Faith In Heresy",
        "2122A0BD-C175-EF9A-D84D-750D301BD4F4": "Faith In Life",
        "582DB613-DDBA-458F-20D0-298BB278854A": "Faith In Light",
        "3D86CCB6-1E36-1588-7CA5-8C0DE846849A": "Faith In Karma",
        "3DB34758-2756-C99A-CC8D-7F9ABA230161": "Faith In Self Sacrifice",
        "C89BAEA4-FD78-25F1-32D3-6AAB4BFBFA50": "Faith In Time",
        "B818235F-3B74-E875-54F3-57BBA5D60E9D": "Faith In The Mask",
        "9DDD6B5D-BAE3-3989-1DF6-D2060DCD1B8F": "Faith In The Spirits",
        "2C0178B2-6D28-CFA7-729C-9C774BEF8D45": "Faith In The Storm",
        "B37A90CE-A8F4-4635-BBE2-82D651BFB955": "Mind Of The Clairvoyant",
        "40E0CACB-0625-3162-EE26-5A18BD63838E": "Mind Of The Hallucinarch",
        "57414350-DAC7-AD98-83CA-2C455D92007E": "Mind Of The Metamorph",
        "83E39FC7-66BB-B09B-7990-71437A0493C6": "Mind Of The Pyrokinetic",
        "DF593FA2-C331-4CCC-8DCD-4978D4DA77BE": "Mind Of The Telepath",
        "D07FEDBB-A83C-44DD-AA29-61B918DA52B8": "Mind Of The Telekinetic",
        "7134B17B-8B7E-2EF2-B33B-14DAE18514F4": "Vessel Of Aegis",
        "445E960B-817E-EDBB-995C-44EDFBB7B65D": "Vessel Of Cataclysm",
        "BAF467C4-1BC3-70BB-55E4-96D8413908D5": "Vessel Of Dispersion",
        "B7006465-D7D9-57FF-83A5-83AE70D09F25": "Vessel Of Enhancement",
        "8D0D4656-28B2-9160-43AA-BF379D5F5369": "Vessel Of Evolution",
        "271C80EB-50B8-A067-A07B-5B8D89248F60": "Vessel Of Restoration",
        "1B8B2014-FFFD-F7EF-BC80-B9A495B50DD2": "Vessel Of Spirits",
        "65A6036B-F6A6-811B-F85E-86F512B74EA2": "Vessel Of Stars",
        "621BEEDA-119E-5B7B-54A9-186C926C615D": "Blood Of The Angel",
        "55CE51A8-D8A4-A2FE-2B93-D5C3B1C43884": "Blood Of The Artifical Soul",
        "C9630A6D-D44E-4154-ADD6-FFF1FA4467AE": "Blood Of The Conduit",
        "799A2ACC-2532-DBDC-6458-7F487CD8EE60": "Blood Of The Dragon",
        "459A0C3F-3089-2CC8-1BAB-0B05E66D7A96": "Blood Of The Fey",
        "BA8ECBF1-2746-BF91-4BF1-03FBF4B09911": "Blood Of The Glacier",
        "F5E27A66-BF01-7CD2-C68E-CBE64A9F73E9": "Blood Of The Hemophage",
        "73786439-62A8-4226-99CB-419E32D119C0": "Blood Of The Oracle",
        "04C9B518-EFE2-578C-6B35-536B84538C2D": "Blood Of The Pyre",
        "32F40024-F4CF-4395-A1F9-2606CBDFE7EE": "Blood Of The Shadow",
        "E26F9653-FBDA-52BA-080B-8BBB422069CE": "Blood Of The Stars",
        "CFBFF802-8C7C-AAD7-3E02-930D012FC7BE": "Blood Of The Storm",
        "C4392CC6-ED12-0278-839A-96420C0DEB7E": "Blood Of The Wildsoul",
        "62471733-E4AA-40FB-551B-1AD623740861": "Blade Of The Chronoknight",
        "107529B3-B41B-1595-A83B-4A2F981819AE": "Blade Of The Eidolon",
        "11CFEA10-2B51-15D7-C40D-2B985A50A921": "Blade Of The Grimoire",
        "7C078D1C-6763-AB35-356C-7B3B38158541": "Blade Of The Shade",
        "3B42EAFA-8DD1-CCF6-7CD3-6E19C57C0A4B": "Blade Of The Spellbreaker",
        "87B3915B-F40A-C2A9-678B-1D1508ACBCED": "Blade Of The Valkyrie",
        "0DFDEEF9-B497-2E86-F425-C772528B1ED7": "Blade Of The Vanishing Edge",
        "5522DAD4-54BB-496D-D97E-01B25891EEC9": "Blade Of The Witcher",
        "F437FC6A-AEB0-8030-B1D9-8A18CFBD52D8": "Shard of Alucard",
        "FDDFF216-A24D-C129-BB48-DB543159B2B7": "Shard Of Korravex",
        "346EBE03-C187-65AD-E939-AF55FF5B24B2": "Shard of the Glass Warrior",
        "0BCF6373-E9E3-AD11-90B8-7D44FBC2AA62": "Shard of the Glass Mage",
        "901FFAAE-98A6-46C5-B4B6-D04F135BA9BF": "Shard of Caelix",
        "4199249B-B7F9-CAAA-01A5-1394E3E3FC2E": "Shard of Aurelion",
        "A99C15BA-7990-3449-DD73-1B3FE43531B8": "Shard of Irvatha",
        "D82D0B01-C890-8802-9650-8AD027221355": "Shard of Fhalora",
        "135EB0F1-BBAD-F5D3-28C1-9C4E6D019051": "Specialist In Assassination",
        "DA93B17F-9205-022A-D20D-1C396719FDB7": "Specialist In Corpsman",
        "AF821625-3E60-79DB-28E2-67AAEB68189F": "Specialist In Espionage",
        "E2C8228D-A3A4-415F-26BA-AD832865C0FC": "Specialist In Piracy",
        "D1FCB683-7F8A-D179-6C01-4982234B1A10": "Specialist In Sabotage",
        "4D7CFE7B-DBD0-9DBC-7933-D04E9A04C389": "Specialist In The Astral Grift",
        "C8A114DD-4380-D1C3-CFD0-F50C10B59F93": "Specialist In The Nullvein",
        "2840646C-3F3C-D38C-DE73-39ED914B01BF": "Specialist In The War Jester",
        "AD81DE70-D93B-FCCC-042A-379B252246E1": "Specialist In Thievery",
        "0E85B423-C980-04E1-D7BE-B3F87A8934F2": "Patron Of Chance",
        "4191B743-01A5-4E81-806C-E77E0478A2F5": "Patron Of Death",
        "16E69F5F-9D8C-4C81-F492-5008E7CCA0A5": "Patron Of Secrets",
        "972AD871-F294-5894-9BAB-2A3B12A6646B": "Patron Of The Angel",
        "7205CA73-B3EC-4C17-B346-7A8CD381DEF9": "Patron Of The Artifact",
        "3E3F2F87-5740-AA09-79C1-CD0A0599BEA4": "Patron Of The Deep",
        "95968E76-2744-E42F-8FC5-026EDF34249A": "Patron Of The Devil",
        "A41E445E-9884-958E-BE93-87F33A1F44F8": "Patron Of The Djinn",
        "8BBE01F6-13CC-727F-4431-9B66CD3BB7BA": "Patron Of The Fey",
        "AF3FA968-2776-CF37-AAB8-7B7E4BAC555B": "Patron Of The Lich",
        "CC1A807C-117A-5815-74F2-9C1253381F2E": "Patron Of The Plague",
        "2257ADAA-6B83-4DAF-7D99-5D2AEA180562": "Patron Of The Void",
        "8B08E0D0-BB18-6B35-32B6-A563A345D1E1": "Patron Of War",
        "4992C4FD-7882-DBB9-BE7C-0BA4157A438A": "Study Of Abjuration",
        "B068A115-A99F-30E5-8B43-A74C1DA8B6A4": "Study Of Charm",
        "14B166A9-668E-204D-A675-B76B0979442D": "Study Of Time",
        "5EEA5A21-4FCC-884C-ED46-370AFE880209": "Study Of Conjuration",
        "BDCFE0B2-7BC9-462A-878D-22886DCDC426": "Study Of Dark Necromancy",
        "7F372EFE-7AEA-6E06-9748-B8F815748CA9": "Study Of Divination",
        "B53BC269-EB0D-725A-C7F4-5D58C717F04A": "Study Of Evocation",
        "B69522BE-88B1-058C-BABB-656071158414": "Study Of Gravity",
        "225A6BFB-98F3-08CD-EA80-A8ABB6473365": "Study Of Illusion",
        "E11509DD-8F0F-41FB-A34F-7F9917136D7A": "Study Of Necromancy",
        "7449B08F-F68C-0003-239C-BB821BD485D7": "Study Of Transmutation",
        "CA6567EA-74E1-41CC-9C7C-E8EEA8C0B6D6": "Fury",
        "59F12E46-1F98-1352-1A13-BE202196C347": "Melody",
        "BD233002-F6C0-A136-6EE4-C899A9E92856": "Tactics",
        "C92D2BD6-DE2F-2A4D-7423-0C40CC8B3305": "Harmony",
        "8C9782A8-5EBF-C04F-CA3D-DF89B1C9EA18": "Stalk",
        "7926555F-184A-4E33-9630-A845D4C9335C": "Rite",
        "6A8183E1-349E-3960-B465-6C863097E193": "Psi",
        "2274AD74-E2F8-47AA-8FD1-7DE4713695B9": "Sanguine",
        "26A48978-7629-F0D3-BA6F-23DEBB429055": "Cunning",
        "30BD0A8F-DC53-4B80-B5C4-8FBB04F9F9C1": "Gift",
        "B56929A7-6BB8-81FA-BFF8-2CE4B0812030": "Mastery",
        "5FF2F49A-7667-D686-2BC6-32623375A091": "Aether",
        "A8084E61-46B9-FDB5-83CD-59482BA5B8D3": "Menace",
        "7A725B38-BA68-7651-4746-5D34B5690203": "Ether",
        "DADEF475-1E69-4EF4-8B46-06F3FC2B450D": "Orb Slots",
        "85F756FF-CC55-B50E-A749-A13FAAA8982E": "Cuirass Armors",
        "77D5AFC0-C991-B98A-2AD9-6922ED094BF7": "Half Plate Armors",
        "6A43A001-E717-DE2A-E533-944C20F70C77": "Plate Armors",
        "C65C0AB8-0129-04D8-5C9E-8BCDECCFC127": "Gambeson Armors",
        "75F431B7-2E3C-988E-29F1-A927118BE424": "Leather Jerkin Armors",
        "6BE03831-B72C-6FE3-7E4E-48EB6DC9B511": "Brigandine Armors",
        "EBC29BD4-10ED-12BD-5E78-854A8AD232E2": "Hauberk Armors",
        "798563E1-EB82-4ECE-CB48-9E459B509F92": "Lamellar Armors",
        "5F2B5D56-CA98-B407-B99E-131460AA2F0C": "Mail Shirt Armors",
        "AF8EA876-DA09-2032-DF5C-3C950DBF7CB2": "Bucklers",
        "F14311B1-5B45-9E9A-E12A-42C0E4915F41": "Bulwarks",
        "1CE8960D-FD6A-6E6F-C963-01C0CAC1AC71": "Cavalry Shields",
        "ABAA9AC7-0274-E299-16A7-E5136837CF2E": "Heavy Shields",
        "21DE8157-5C1E-33F2-7E52-B27A97C551B8": "Kite Shields",
        "D748B500-AEC7-8AA4-B103-3020410FB3DF": "Light Shields",
        "B7312FF1-9F2F-49BF-81E2-BC601D582541": "Medium Shields",
        "B614B04E-2AB9-6FB2-56D4-84B8675B074E": "Tower Shields",
        "337317A4-1CEB-37C7-699F-1A0A02A31709": "Natural Armors",
        "AB7DEAAE-62BF-4996-A510-5F2B192F8F14": "Natural Weapons",
        "6284CE8F-C929-7161-EC43-923DE40F4968": "Clubs",
        "48C941BC-2E9A-CAD8-1DA7-D90AE8DB1768": "Sickles",
        "742A06CA-5870-FA3B-603A-AEE94F5102F5": "Whips",
        "50740150-28E8-FB76-88BD-216B02569D3F": "Daggers",
        "67EFA62C-3A5C-9FEE-D54D-EF7615C063F4": "Light Hammers",
        "57B8F98F-460E-7D39-C495-D2E26439391C": "Shortswords",
        "AFFA2CC1-0468-ABBC-2FA3-40597B8B374D": "Scimitars",
        "5E58B1EB-B2AD-5F54-B4DD-D8DDA5E8BCE3": "Maces",
        "859394A9-EE4A-BD9A-C5A9-7FCD150E7344": "Handaxes",
        "2FB5E21A-7A0A-E4B8-604D-3A0A60A34172": "Javelins",
        "12D25118-B86A-80A5-01BC-C9427BD83D17": "Quarterstaffs",
        "7D08EF0E-0D7D-8CB0-70FA-0C741AF438E5": "Spears",
        "CF8B21A5-32CE-7E43-22E3-ABC56C457628": "Tridents",
        "2F238366-80B8-2BCF-EC81-387CE1A5D4DF": "Rapiers",
        "622AEA0A-D1A6-FB1C-83B4-FC67807D9197": "War Picks",
        "AD9D5036-D2CF-1C6A-9785-CCB5D35B96B5": "Morningstars",
        "D5906717-7237-CA1D-B089-18CF323A04DB": "Flails",
        "B5ECBC44-BAB8-E6B2-0D1C-CC2A5082BDD2": "Greatclubs",
        "E48B1524-C478-E245-AF07-2A1A145EE4D5": "Longswords",
        "1B08D135-FE7B-4180-6F38-A1FEEF733355": "Battleaxes",
        "3AC99772-BF88-6507-8360-EE3EAFC7540F": "Warhammers",
        "864FC3D6-0B39-7F59-0274-09B98850A41F": "Glaives",
        "5B8E8F69-AB95-617A-5E82-8F9C4D2C2485": "Halberds",
        "E4FB85CE-C211-BE13-B674-A2A591384C11": "Pikes",
        "7FA88F1A-084A-4A05-1B5D-27B56EDDED6F": "Greataxes",
        "545EB766-1371-C2E2-2664-0C191EAC9C3F": "Lances",
        "26BF8308-1F2B-656E-FF25-9EB2D1E0EEE0": "Double Bladed Scimitars",
        "FB124CCD-B381-452B-CAA1-B598E90A8534": "Greatswords",
        "44A52695-9CD1-804C-9ABA-178B70704D59": "Mauls",
        "8C25C0CD-AF02-6648-A158-87F4DEBB8651": "Light Crossbows",
        "488EE738-F198-9F9E-4F9F-FE26B06BA64F": "Nets",
        "D80255AC-6D02-0158-0796-76D110DE7778": "Blowguns",
        "9F33304D-BEB8-86B5-3928-A4D98293DF97": "Darts",
        "D7BB53E2-0544-9AC9-7DD3-4FA47A12C80C": "Slings",
        "6C92300B-B840-9E37-BF4D-46A166407E7B": "Shortbows",
        "E6CCEF87-419A-57CF-DC12-73324DB86CD1": "Hand Crossbows",
        "207C31FE-ABEE-96F1-2EA6-B98635F7D730": "Longbows",
        "7257525A-37A8-9DCE-1656-C7449FF2C305": "Heavy Crossbows",
        "FCED5C37-344C-1B6A-7598-E682452C1AA9": "Palm Pistols",
        "60509B0C-A1BB-B005-C834-98E5ACE40BAB": "Pistols",
        "BCC74411-8516-A30B-B79A-1DBED89C61A6": "Pepperboxes",
        "3BBEE883-286A-4A08-3CCB-52F283348345": "Muskets",
        "7F3F7FC7-0CCF-E01A-22BA-E0AA0A97686D": "Blunderbusses",
        "5310DE5D-1453-5468-EBBA-B1132AB19394": "Hand Mortars",
        "E54B8A46-A63F-AB3A-BAA9-C27826B0AF5F": "Bad News",
        "2D837940-0143-4636-9871-406BF89DCB1D": "Gunlances",
        "5C17EFAF-2F94-E2E4-02A2-791F241BD52B": "Bladed Fans",
        "81AF4123-10E6-8656-F9CA-DCE1AC3DC7E3": "Rope Darts",
        "F187EE82-1D32-4C53-9F69-E59DDF33D7C7": "Fist Weapons",
        "40DDC931-6479-B773-293E-CE570E99B975": "Bladed Umbrellas",
        "DE15C4F8-2710-8187-3788-2DA46D8724B8": "Scythes",
        "B12431F6-BB7A-8079-002F-111914B9E65A": "Colossal Melee Weapons",
        "B66B3311-4A62-5531-D446-CE4A565FD181": "Colossal Ranged Weapons",
        "F2D8C4B3-FA31-291C-995A-2046F84A289F": "Air Around",
        "0B279A55-5102-D704-8A57-0C1FF4989DFA": "Armor",
        "F19F7A27-C0EE-DCFF-BD8F-2FA3CC03F7BB": "Back",
        "E6D02ACB-D3E9-DD8B-762A-31FE8C8D898D": "Both Hands",
        "BD255B29-389B-53DC-6116-072B1A8DDD5F": "Bracers",
        "C48555B1-E374-9AAD-8CA0-C55D07AD6776": "Breast",
        "6203F9AE-6699-AB57-B3C7-92864A79520C": "Cloak",
        "3CAA3182-3DA6-F348-CEE3-09803F221466": "Clothing",
        "94805078-0B0F-FD3F-77E4-AA6EE4D2E44D": "Feet",
        "3805BDD7-3461-DDDB-F445-922A5A992987": "Head",
        "AF43D701-0755-C7E2-D26F-44E6F64AC3E2": "Legs",
        "CEF334BF-DE96-1BEA-F72A-A4C98FBF36AD": "Main Hand",
        "3CA73C13-5DC3-0DDF-CAD8-98D1CF573844": "Natural Armor",
        "5EDE9876-ED2B-3B93-C683-34428B5FDA5B": "Neck",
        "4FF85144-67EC-9D87-AE28-15137A1A2481": "Off Hand",
        "3AD8CEE8-D487-68B1-33F0-CFE04336F9B8": "Ring",
        "16ABAE95-5D18-474D-ADFF-8C20FC2439F1": "Tail",
        "B52059C5-526B-3F8C-E906-0D40FA23A593": "Waist",
        "0BACFBA4-0921-41CB-B586-2B68D5BF391B": "Visual Mount \u2014 Worn",
        "34D0A902-F9A4-406A-A29E-61E55BE0F338": "Visual Mount \u2014 Worn: Head",
        "11E3CC41-2645-4423-8841-8F4B531C4920": "Visual Mount \u2014 Worn: Torso",
        "E3DFF047-0ACE-4C14-A204-3B32572EF1DE": "Visual Mount \u2014 Worn: Hands",
        "CC4E28C3-8FD5-49D5-A537-6AAEE88756F7": "Visual Mount \u2014 Worn: Legs",
        "5E0B1C69-8936-4621-A2AE-9648E13384CB": "Visual Mount \u2014 Worn: Feet",
        "BC829CD7-69F4-4A90-89AC-9DE78C740FE5": "Visual Mount \u2014 Worn: Cloak",
        "633EA7B5-E49A-4DD5-9834-DEE5BCDF8AB7": "Visual Mount \u2014 Worn: Neck",
        "6BE8B58B-B97B-45B8-A34C-891EAAEB387D": "Visual Mount \u2014 Back Primary",
        "2035E00A-331D-4B24-8C5E-E768E6753456": "Visual Mount \u2014 Back Shield",
        "F99AF61A-D832-47CD-8464-E9AE0E1881BD": "Visual Mount \u2014 Back Bow",
        "F1A71448-07EF-462D-BF26-D3DB88F7E489": "Visual Mount \u2014 Back Quiver",
        "EDBF0393-95BC-452B-9E23-7ACE3BA34840": "Visual Mount \u2014 Back Pack",
        "493D1395-4A04-4F3C-8398-2DBF56960FF8": "Visual Mount \u2014 Left Hip",
        "3C23B69F-1A55-4665-B708-8F07398611AF": "Visual Mount \u2014 Right Hip",
        "AE73EEDF-AC07-4330-B957-B10CFE4CD2E0": "Visual Mount \u2014 Either Hip",
        "5DAAF4FA-800F-491D-A79D-D8610EA58023": "Visual Mount \u2014 Left Thigh",
        "A56D1DBB-C93E-4D84-83CF-BEE1701FD058": "Visual Mount \u2014 Right Thigh",
        "ADD9FA87-2436-482D-8FDC-B5FB7AD9A3A5": "Visual Mount \u2014 Waist Belt",
        "9EC53644-1E56-43AC-B43C-C922FF6DD725": "Visual Mount \u2014 Held Main Hand",
        "0066C87E-FCD4-4FF6-BE4B-A6D22F234565": "Visual Mount \u2014 Held Off Hand",
        "69E469E1-0DF4-4F9B-9B41-D7BB5CB70A33": "Visual Mount \u2014 Hidden",
        "1364260D-E37C-4257-AD16-5E745107811A": "Melee Weapon Type",
        "2BBC1E4E-5A42-41A4-8392-2C755D7A3C7C": "Ranged Weapon Type",
        "82A55683-3171-458E-ABCC-27739151D606": "Firearms",
        "166EBD0E-7FC0-7351-5F82-C84F9B48565D": "Arrows",
        "1F7C8699-5708-6D6A-4FD7-F69D28777AED": "Blowgun Needles",
        "DC50590B-2070-766A-43D5-76E5A0A8D5E5": "Crossbow Bolts",
        "DC474A8F-1F4B-CC10-1C8C-BDEDADF471C0": "Firearms 25 Caliber Bullets",
        "5C8FA3FC-A936-3350-9B2C-AE771839F8E0": "Firearms 300 Caliber Bullets",
        "C1D6CD9B-D11A-A03C-E83E-331C275E11A0": "Firearms 40 Caliber Bullets",
        "24F22A9C-6623-B7AE-F039-E9BF41DB1AE4": "Firearms 50 Caliber Bullets",
        "1BD82D6B-729B-D0A9-7B65-A1C96711C05A": "Firearms Mortar Shells",
        "FBBD1092-449F-4322-9AF5-588825C2E3BD": "Great Arrows",
        "AE3F2A46-7143-18E2-F8DB-42A765DF46B3": "Sling Bullets",
        "4E601894-014E-32FB-E138-2A261969B7B2": "Hunter Summon",
        "5D19BA1F-975B-4CB8-457C-0ECE28B72BF8": "Animated Summon",
        "281738CB-A6F8-5C43-FA15-464DEC6030C2": "Natural Armor Reaction (Skill Tier 14+)",
        "A8FAE765-7F06-7AF6-C452-6D80086C1B6D": "Natural Armor Reaction (Skill Tier 9+)",
        "156DBFAC-2D11-5257-0AD1-619760D890CD": "Natural Armor Reaction (Skill Tier 7+)",
        "1C5AB5E5-45E3-D088-375C-6206CE3A26BB": "Natural Armor Reaction (Skill Tier 5+)",
        "FAFC9034-187C-4E86-926C-AF8DFBF0BE99": "Natural Armor Reaction (Skill Tier 3+)",
        "2D894B13-AC1A-4BCD-8914-92EB4BDACC18": "Natural Weapon Form \u2014 Bite",
        "4C4FE4AE-E485-495B-8ED2-F22A35DA30E8": "Natural Weapon Form \u2014 Beak",
        "A4A9688B-1C46-4A04-BDFE-552CF774547E": "Natural Weapon Form \u2014 Gore",
        "5E805770-2DD5-4D6B-BC6D-8463D291C177": "Natural Weapon Form \u2014 Horn",
        "25C71284-9FE1-4FB5-982A-941913327B4A": "Natural Weapon Form \u2014 Tusk",
        "1D1BFF8B-39AC-4C8A-BD50-136A141E6A44": "Natural Weapon Form \u2014 Ram",
        "068FC154-D699-45DE-B085-F02B23F94DB9": "Natural Weapon Form \u2014 Tongue",
        "E03A9BC3-2D6E-4C5F-8FFB-D7BA35D99301": "Natural Weapon Form \u2014 Pincer",
        "7EBB7791-77C4-4C77-851D-9CCFAAAB3961": "Natural Weapon Form \u2014 Lash",
        "F7944C69-7A83-4BF1-9B39-C4EE05951309": "Natural Weapon Form \u2014 Claw",
        "F326ECEC-8545-48E6-80DC-B3901DD4CE37": "Natural Weapon Form \u2014 Talon",
        "B997BBBB-DC3F-4F8C-AB8E-A63C80AF133B": "Natural Weapon Form \u2014 Rake",
        "E749A3D6-F04A-4890-85B2-ACD31A722718": "Natural Weapon Form \u2014 Pseudopod",
        "DDB21DE1-F41C-4456-B99C-D1B9D8742B84": "Natural Weapon Form \u2014 Slam",
        "16DE3886-A2B7-4957-A751-AE08F048BADD": "Natural Weapon Form \u2014 Tentacle",
        "B8324075-E65F-455C-BD40-B09C95B02812": "Natural Weapon Form \u2014 Constrict",
        "FAEFBA34-2176-46E5-911D-51580EF6DA74": "Natural Weapon Form \u2014 Stinger",
        "FABD5931-2BE5-4A39-BD45-62529717A62F": "Natural Weapon Form \u2014 Tail",
        "4BC81F0D-4C96-44B0-AD91-422E0A6E5259": "Natural Weapon Form \u2014 Hoof",
        "06BBC9AA-3BED-43A4-9EC3-96072F827C04": "Natural Weapon Form \u2014 Stomp",
        "287DFA0C-FD83-4305-A41E-D26CE7CE1CCC": "Natural Weapon Form \u2014 Spine",
        "2C02D1AA-5FBD-470C-8154-B5304BE28D13": "Natural Weapon Form \u2014 Hurl",
        "83CA2730-7598-44D6-BDA2-CDE4B040E73B": "Natural Weapon Form \u2014 Other",
        "02FFED44-7A58-4EF2-EF07-2FFD980A3049": "Natural Weapon (min skill tier 14)",
        "34CEB0D1-1DE2-03F7-BB8A-834BF8F3565A": "Natural Weapon (min skill tier 9)",
        "D266179F-EAD6-AAF2-EC00-EAF45679AD0B": "Natural Weapon (min skill tier 7)",
        "39EBAEF7-1ED7-5AAF-E88B-8C50B96B5ED8": "Natural Weapon (min skill tier 5)",
        "7F6E7D26-77CE-801A-51F7-1CEE17153C70": "Natural Weapon (min skill tier 3)",
        "7E0421DF-EA86-90AA-E95D-30145B3F43BD": "Natural Weapon (min skill tier 1)",
        "D11FB4D0-3A08-A17D-5151-9AEAA1F78660": "Dead Eye",
        "45122975-6514-4CE0-9484-A874CE211016": "Double Concentration",
        "735EC3B3-8E5E-B806-706B-B43FE340757C": "Quick Study",
        "C80A28EC-E4DF-664C-FA7C-870A8A53C032": "Weapon Size: Tiny",
        "BD02A97E-8EB3-445A-8758-B01E089FFE03": "Weapon Size: Large",
        "F74CFA32-D114-191D-CC2F-C8DE12B8E871": "Weapon Size: Huge",
        "4C7C35F9-F948-581F-0F2D-11BAFC476122": "Weapon Size: Gargantuan",
        "C05381EC-D66A-15AC-46F0-42F5EA8D9383": "Weapon Size: Colossal",
        "44D45637-FCFE-FC95-BE32-DD47FCAEC116": "Weapon Size: Titantic",
        "64C7938A-010C-1527-6890-A4BC39362807": "Armor Size: Tiny",
        "83D21DE1-B6D9-877E-9B6E-56734C400643": "Armor Size: Large",
        "BE936924-6C8B-CBEC-3E77-6D47B1F98959": "Armor Size: Huge",
        "65532C69-CC39-2614-CABC-C4D5EB9ACE48": "Armor Size: Gargantuan",
        "7C0A9429-D170-041B-727B-5D3762D9CFC5": "Armor Size: Colossal",
        "A0DC40FE-BA7A-89FC-CA10-1C15BBAD6EDF": "Armor Size: Titantic",
        "107CF709-348E-4234-B92C-D7BA6F5579CB": "Grip Training",
        "F277610B-299C-49B4-9773-2F1A3F3E80FB": "Advanced Grip Training",
        "1DC3B3DE-BD4C-B77A-429D-12C7F2B2439D": "Overrun",
        "940FD768-1845-24CA-216B-498AA1B2395A": "Inhaled Poison",
        "FF534A71-6D75-FA02-6614-3DE578770FE5": "Contact Poison",
        "0B64D4D7-5D04-FEB6-D098-3EB925AC516B": "Injury Poison",
        "00E1B7B8-F92D-5D24-0FF0-40DC21672F47": "Ingested Poison",
        "D0E5D185-0E49-FBE3-EFA9-E99CADDE7B0C": "Arctic",
        "F66F5044-B272-A3B0-0432-7E39B27A25B1": "Coast",
        "7EA716CF-ABCE-CD3C-0B9E-2310BB8C9DD8": "Desert",
        "1A7C5177-77E3-F1A5-0423-D09C137CA2A4": "Forest",
        "0F7BF513-E0CF-822A-C0ED-12F4ECC03F47": "Grassland",
        "E7E1210B-7197-DD1F-5324-5FAA39395450": "Hill",
        "19817552-D32A-4B97-B404-745927E1B764": "Mountain",
        "FD2AC285-7609-49D5-B6BD-3287F920472F": "Swamp",
        "38FB8933-47F6-4A79-60CF-14E80BCF9BF5": "Underground",
        "19BCE18F-E1DC-D359-48A0-3B789741E058": "Underwater",
        "16333E5C-F1C9-163E-B688-05A05BE0B099": "Urban",
        "D4CA3D58-2C59-4515-AF01-169E7890F0D3": "Planar",
        "C8867600-ACD9-4088-A886-F6AB2BFA6FBB": "Outer Space",
        "DCE7C0B4-5ADD-4501-B53A-8F17808F2F4C": "Abyss",
        "130E2C92-D278-DEDE-3317-EB81F6EEAC78": "Archipelago",
        "270CFFA3-E469-16BD-0B3D-7FD416B249FC": "Asteroid",
        "E15FE1AD-692D-E640-9A4C-AF21D95ED7BD": "Asteroid Belt",
        "2533E837-2DF5-29F7-2E08-5F287D8A1A6C": "Atoll Underwater",
        "2ACBDDE4-1700-E444-A0BF-226D58FF254A": "Badlands",
        "A3C4F184-2339-FE0B-D804-56316B7F0CA1": "Bay",
        "A945F345-4B0B-3943-8851-B51BB7DFDFA4": "Black Hole",
        "F84D1999-6C79-E58C-537B-77AEB2D6490C": "Bodden",
        "CE4A8031-3CFD-6FE8-0518-C0FAF4BFEEFD": "Brush",
        "04C6725E-ED55-748C-DA58-3459A75D8603": "Canyon",
        "4EC766F1-258D-0BED-F7F6-5C51307F688C": "Cave",
        "381EED2E-EECF-F30B-53C9-BB6BD121A652": "Cave System",
        "2189DD55-92A3-B8FE-DAF7-DBE01D9AF9D7": "Chasm Underwater",
        "F84B81E6-D7BD-CBD5-A1EC-0C39226E3E69": "Cliff",
        "2D69106B-82C5-D88E-AEFD-A88B6D3F0E3B": "Coast Shore",
        "8CE8E265-7E44-D78D-1C89-5B08D78EA794": "Continent",
        "C2123333-EEA1-57EA-FF1A-CC01378DE998": "Copse",
        "57A4EE67-0F3F-C4F2-CA4B-F81D896F4975": "Coral Reef Atoll",
        "5A62FC7D-79E4-A7B0-244F-18D865FD5679": "Coral Reef Barrier",
        "A0BC86C5-403E-1034-B759-1292FA2403A8": "Coral Reef Fringing",
        "3503983E-A71B-6529-4002-67CEBF961607": "Coral Reef Platform",
        "83A8060B-5DD5-9D56-77A4-D47624EA5F9E": "Cove",
        "48EA5564-7ACE-BB0C-B756-9E2BBC730AB6": "Cracked Planet",
        "5E22CB3D-7815-16A0-C9EB-D28DA5D6B263": "Crater",
        "718E7C4E-3E8A-F95E-5CAF-932984CCF213": "Desert Ice",
        "A17E1321-2CCD-7C70-9F00-DA261C138F0F": "Desert Location",
        "E7E628D7-A21D-9136-E171-4A35BF375FF4": "Dimensional Plane",
        "7359FA1C-9C72-A490-A7BA-D9AA25CEB1EC": "Dimensional Pocket",
        "2E902352-952D-7E5C-8607-5DC99C9DDD21": "Estuary",
        "D37F3000-77CE-2508-E0D2-E03DDDD4E903": "Expanse",
        "7B8D5960-B94E-CCEA-3283-A07F70EA2677": "Field",
        "49D4B149-CC35-B607-AFB2-70BB7EEE196B": "Fjord",
        "1B619AAA-2B41-1F33-DD39-BC6B7CFF6D3A": "Forest Boreal Coniferous",
        "21322959-44EA-0157-CBC8-91A7EDE778C6": "Forest Cloud Water Subtropical",
        "D9385FAD-9078-1329-C3B5-AA794CE08DCA": "Forest Jungle Tropical",
        "BE674A0A-D7B9-DBED-A9E3-BBBA166CC831": "Forest Location",
        "768F7512-7D3E-6E90-8E91-72DC66A0089B": "Forest Temperate Seasonal",
        "AD5FD492-F4B8-B30F-1AEC-B83B99DF40AF": "Galactic Nebula",
        "ECAF373E-3B22-C666-FB53-2707ED576BCD": "Galactic Quadrant",
        "1C0133E8-0EF9-CA41-6A34-5160ACDA8B11": "Galactic Sector",
        "3A3F9742-5876-C5A1-C1ED-EBF9EFEB025C": "Galaxy",
        "B4AABF46-DBBA-F625-C2D1-FF5DD7176B8F": "Galaxy Cluster",
        "42DDFA6E-43FE-E320-5FAB-999FADF4BA84": "Galaxy Supercluster",
        "F922ECF7-2053-2F23-EEEF-E5B86C72C2E5": "Glacier",
        "B8F4138E-2663-9767-998E-0FA2EAC3196F": "Gorge Rift",
        "E83F15DB-2FA1-991A-D117-74B0022D3338": "Grassland Location",
        "EE83AA36-981D-EC06-A7BE-2FF328180A8D": "Grove",
        "7554CE49-B27C-11F1-8C29-61872DCF8F69": "Gulf Lagoon",
        "AA0DDA05-58FF-D6F8-5958-E2F5424EC65C": "Headland",
        "D6549CC9-C7E1-F24F-D0CE-2C626360F126": "Highlands",
        "0DBBBB72-BEAF-DD44-7903-8D37BE097B12": "Hill Location",
        "C2A6D6F1-3078-3B9A-3AF5-9D87B59F613E": "Inland Sea",
        "0D180E23-D233-0522-4393-D513DF5C39F8": "Island",
        "EB39CEE1-4B20-DDB2-3FD8-51C04BE2DB96": "Island Floating",
        "80770BB4-26D3-C637-DA35-3E549B61F096": "Isthmus",
        "3D7A96C2-A736-A722-5C4A-49D77B205563": "Jungle",
        "1F557F3F-B61E-7672-9368-9F320BF09158": "Lake",
        "88F0C54B-9B37-9B57-7F5D-D117B73E70BA": "Lake Dry",
        "0384E40E-523D-0BE4-D069-220585742363": "Landmass",
        "3E3B74C8-AF60-F5F1-A316-E4D3B1501D72": "Lava River",
        "39DE636C-8087-E69F-D7A4-DC220D772AD2": "Magical Realm",
        "203017D9-9617-1DE3-9FD6-2C0E0BD965BE": "Meadow",
        "DCE7B411-99FB-9517-2E2B-21B2DD0F0125": "Megastructure",
        "40664291-C6E9-01A6-2D3D-8FD1861AA940": "Moor",
        "CC224B6E-4A3A-1874-5038-BE285AEA784D": "Mountain Pass",
        "E831D078-0533-33A9-76FE-5070AC95F373": "Mountain Range",
        "2C96B6CF-0B79-1C4D-A414-FEA6A7BEC8AB": "Mountain Location",
        "544506F5-85D7-A84A-40E9-4E15544F5BCB": "Multiverse",
        "FB03E84D-6902-1885-DDF0-5BFD0D59A2C5": "Natural Wonder",
        "103C97E3-AEBE-4964-788E-45E35FF246A6": "Nebula",
        "97A88B52-CFA1-A67F-A2FF-60FD5475BBBE": "Oasis",
        "DABF4143-1969-C974-4903-C1212E57B94C": "Ocean",
        "CFF971CB-DE1E-408C-FC40-A199C092001F": "Peninsula",
        "C0EC8294-FFBD-2CF7-20DE-2B64B56C5723": "Plain",
        "9D7BAB5B-5197-318A-4D96-EF05580BC8AF": "Planar Sphere Grouping",
        "55C4EEFF-1638-18E4-662F-E028BD91E853": "Plane Of Existence",
        "31130EAF-53BA-6D61-3744-872DE27F5BC3": "Planet",
        "68022F7B-B788-2B4F-FE21-367F0ABB6EBA": "Planetary Orbit",
        "109D10A8-1E25-82E0-A6D4-AE628732BD2B": "Planetary Ring",
        "DA1FE3CB-8621-5252-85EE-F22EFE35C2FA": "Planetoid",
        "7AAA3989-0233-88C9-5A1A-3F89923B6192": "Planetoid Moon",
        "87C01352-EAA6-E667-8C9E-DE24D563320F": "Planetoid Rogue",
        "29A40478-B83D-89DD-A758-C50BEB866530": "Plateau",
        "2779D40C-19AE-4F1D-39B6-9134E67A268E": "Pocket Universe",
        "DE790F66-C77A-570A-579F-71A9E44B2884": "Pond",
        "04745434-A050-1300-ADA4-DB9C151E9A0A": "Rapids",
        "7A9EB5DD-3EAE-DCCA-3518-8D4EBFD6131C": "Region",
        "B846648B-EC46-DBEE-2788-516A55DD7F12": "River",
        "CD92F978-1CBE-330C-0CC3-71E3C1A32525": "River Basin",
        "354B23D4-782A-3984-5562-69358E77D5E4": "Rock Formation",
        "4DAC1B4A-2324-BF69-C00C-DF6575D47041": "Rolling Hills",
        "45C4332F-7E72-DDB0-22FD-01B1BAEFC819": "Salt Flat",
        "5F6620B5-F321-98FB-DC2B-DFD71B3D2750": "Savannah",
        "E5890CE0-37BB-B295-B094-85C2B9FAD943": "Sea",
        "E4DF1F3A-78BC-A901-6118-8C549AB811D8": "Shoal",
        "C6E8D41C-390B-47C8-35AC-EA8BF4656BBD": "Sinkhole",
        "3BE9E979-BA75-6B17-783B-41E7BC0E7E96": "Solar System",
        "2D9328A2-9707-F14F-33E5-2C99BBA29AFA": "Spring Location",
        "5603C5F8-4610-2227-20C3-422104EA74E2": "Star",
        "70C050DA-232C-B766-3F88-82538AA8B812": "Star System",
        "A85D289B-C245-12B3-B5E8-B862B0372AE2": "Star System Sector",
        "8ED7DCC2-2A9D-B650-2188-17504321E60B": "Steppe",
        "C4A65F4F-C3FA-FF3F-FDD1-E3BAC58D5E56": "Strait",
        "F76F59F0-67A5-4492-05B2-19DB315AD6DF": "Stream",
        "3A92ACA4-46BF-BEE1-C112-8B7B41AABC96": "Subcontinent",
        "1A36EA86-18D3-C5DE-3C77-240EDFFAB432": "Summit",
        "E0407389-A0AC-7C17-89E1-F451F7E2BF59": "Supercontinent",
        "37C34B4D-6DB6-EE95-0128-3D40D3DEC5CE": "Swampland",
        "15DE60F1-65E9-E3DC-E47C-41C53D0BFD79": "Taiga",
        "9B9D7A42-A55A-96AE-435B-549ACE26DD7E": "Territory",
        "1489C64C-AA0E-BF03-A01B-E60E07B8B2E8": "Tundra",
        "97914953-9682-C3BC-7BEE-A02846D689F9": "Underground Subterranean",
        "60217EE8-AC0D-5023-9C5C-17581D35D4B8": "Universe",
        "4E16C1F0-A18A-39AF-6B8E-46C59C7A72ED": "Vale",
        "C6CA860F-F58D-7129-87C4-893A3E78090C": "Valley",
        "6260383B-E837-84F5-4C75-F44310D6654A": "Void",
        "7BE97A94-7FC0-642C-379E-788DCDA7B293": "Volcano",
        "59691E2F-1807-5582-91E4-D65E5E6EA167": "Volcano Underwater",
        "80591D2E-F992-6BE5-094E-2C9D60726DA5": "Wasteland",
        "6D060053-343F-A8F8-D3B5-6317D7222BE6": "Waterfall",
        "2D6F5A13-0863-F61D-9239-54FF344C0DAD": "Wetland",
        "3FAE421C-80F8-4A96-5DDC-A461C7506FF3": "Woods",
        "22037F8C-242B-243B-B299-F5D3735021FF": "World",
        "FA5A9A83-FB7B-F756-A22E-7ADF7DB80140": "Wormhole",
        "4FF85609-6DA6-429E-8CA0-BCE6844D2EAD": "Arcology",
        "13511E61-2267-7485-0BC9-E618025D352A": "Capital",
        "553334AB-7F90-FAA4-3BB1-61F072A01ECD": "Caravan",
        "E9C4F105-E156-8DC4-4753-9F9427621B05": "Citadel",
        "3510737A-8101-7904-89B3-C0BCF1101601": "Conurbation",
        "FB30C45A-AC2F-FDE0-B530-6E7C426FA237": "District",
        "FB7A648E-43E8-B396-4DB0-06D828EC2B2E": "Dungeon",
        "8D97DB1D-E7A4-BC55-4C5B-9FF0CC90AD4D": "Ecumenopolis",
        "39B22A7F-144F-EB84-BF1D-DDE45C9BAC6B": "Hamlet",
        "39BFCB73-8610-A7A8-869E-7BD8D746FC6F": "Large City",
        "15F48526-5526-FD30-8C4B-38E916A66918": "Large Town",
        "928612AF-D88D-4197-3AAB-BC362BE5F8E0": "Megalopolis",
        "2113FCC8-3025-372F-E254-9B850D7F417F": "Metropolis",
        "8D9F3FF2-306B-D569-A651-EE1C89A87860": "Military Base",
        "32442427-714D-66F7-DFA4-7C5D80356FF5": "Military Camp",
        "E53C0243-22DB-72BE-2ABD-21BD858BEE60": "National Territory",
        "2303C056-CA49-6F72-D682-8C8ADE33432D": "Neighborhood",
        "93B18FB2-ACF0-0C13-439D-17490C2C2BF3": "Orbital Station",
        "530DDF73-26CF-9A06-32D4-6724A13CE661": "Outpost",
        "6746D551-BCB2-5D05-FF18-675F0C6CAF8C": "Quarter",
        "4C3F9C1F-37AF-DE4D-B6F5-BD0558513DA2": "Slum",
        "DCAD0629-C1D1-97C9-E05C-5DFB1FE998F8": "Space Station",
        "614DED75-B621-26A9-D7A7-8C6EF3140249": "Starbase",
        "B25E2BCC-76E5-992F-BDAA-B550A8B3127E": "State",
        "028A33EB-3EAA-BD59-70B2-BE7F13C7F420": "Town",
        "9E928A19-47B8-E96B-CB0E-491778C60EF6": "Trade Post",
        "64311343-FA0E-EB48-E091-CFD2FAD68EF4": "Village",
        "921C4897-40E4-6336-A171-DA1FDA6A40AF": "Ward",
        "E332C998-1B31-430A-8796-6D991689F60E": "Abbey",
        "018F9A3D-E3AF-ECBE-AE14-7781C5AE849C": "Acropolis Citadel",
        "D0BF3EF3-177C-8AD2-3673-EF10C4452A8C": "Airport",
        "C6EAE41C-7898-2A43-9003-029314CB1E71": "Allotment",
        "DC69D264-F1AD-97F1-FCB3-C53138BC74BC": "Altar",
        "D53B454A-1DA8-9358-E266-A93553FEE7D4": "Amphitheatre",
        "D868C84E-C132-1B2B-B2EC-A4679D33BAF4": "Apartment",
        "901C6A86-F359-A99F-1D63-4CDA0F040210": "Apartment Building Tenement",
        "60ED1493-67CD-6715-BE15-FE74DEE26DCE": "Apothecary Building",
        "0C28BA28-6CE7-96E1-2817-CED702C122D4": "Aqueduct",
        "62BB03C9-7E47-DBB6-FD7D-B0A026172182": "Arcane Circle",
        "452C9F80-57B0-2DF2-ABD9-F333E2796D25": "Archive",
        "BB134EEF-09DC-8A8F-DAED-1762CE9ECC7C": "Arsenal",
        "AFCABD67-8AAE-194F-AEEC-5AF60A654087": "Art Gallery",
        "0B856F82-037C-730C-A36F-E2889CAB2678": "Asylum",
        "DBE04183-FCE3-1DBC-33E5-961A1EA483EF": "Aviary",
        "F30890EA-DC2E-B1CF-3AEE-66751777F2A9": "Bakery",
        "7A93E220-3578-5912-3856-B0160E9A0856": "Bank Treasury",
        "04F77A14-C227-1D47-B487-46C14A75695C": "Barber Dentist Surgery",
        "0ACC97BD-521B-E6AD-BCC7-C2AB1256C384": "Barracks",
        "F4329ECF-140A-B898-41DA-FB0AFF071B01": "Bathhouse",
        "D7C86CF3-8B6D-00EC-9308-468F0FBB2FD6": "Boathouse Wharf",
        "6E7D0306-0C35-B0EB-D135-6FBCD50017C5": "Bookstore",
        "88B5DA41-090D-4528-8A11-761851166F0F": "Brewery Winery",
        "B6A69701-483A-55CF-7AAB-292237A0C10E": "Brothel Whorehouse",
        "24F413F7-B170-CD44-E6DA-7C1ECB6171ED": "Bunker",
        "27B5484B-ACFC-87A7-B2B4-E549E405B506": "Cabin Lodge",
        "4E0E0C0F-3AC5-62E5-2ADD-3A7B0E1D9691": "Cafe Tearoom",
        "29B47648-35D9-2051-3CF8-5E5FA1CD2B72": "Caravanserai",
        "652CFE6D-20D4-76FD-421C-F8C2BEA49E90": "Casino",
        "F676CF26-49CD-89EB-79F5-C594FFC55902": "Castle",
        "031CE1BD-22BF-7A83-3B12-EDC30FEB8907": "Catacomb",
        "B1004AD8-7CBB-9DFD-428C-721538BBBAB3": "Cathedral Great Temple",
        "F05BF8F6-1C95-C64D-DA2B-8C1C8D7E51BB": "Cemetery",
        "927A5B4C-0320-13B9-D710-25F635BF001B": "Chapel",
        "761A327D-78B6-9F7D-6473-1D992072CBF2": "Clinic",
        "BA7A3107-1B40-D50C-A147-E3DC90E45022": "College Academy",
        "D1F38F68-95A2-13F2-AD27-5CAC6B8E4FC1": "Consulate",
        "879F020A-9FC3-B6A4-6D5E-3E0C9D722662": "Cottage",
        "92546C78-D18D-C83F-EFBF-A5D8EBB5A83F": "Courthouse",
        "E05E77E1-F35F-12E7-111F-EB582D78C862": "Craftsman Blacksmith Smithy",
        "E2C8138B-8805-08A0-C8E2-C79AD86B720B": "Craftsman Leatherworker",
        "0C569B27-1F4C-AE8D-F3C6-19F4241557CD": "Craftsman Tanner",
        "AEFB6B35-A12E-7BAD-1D40-67A8169176E7": "Crypt",
        "CFFB0D03-2192-BEA6-1EDC-3C3920B18202": "Customs House",
        "7A265D17-07A1-C59C-46EC-EEB72C6A723F": "Dam",
        "7FB0DB3C-F52E-EBBD-D3C6-AC2B1BF528D0": "Dance Club",
        "ED4A5C96-E0DA-8CAE-136D-E7D0BD14728A": "Datacenter",
        "782A92F2-93B6-DA4A-0419-D1124317BABB": "Dojo",
        "CEECB777-7F28-3D7A-4951-B54C55168F92": "Drug Den",
        "0A29E071-0E93-3368-2391-0EEAE4445485": "Embassy",
        "E2E31010-3F23-7038-4AD0-4DC1ABE897E6": "Estate",
        "7C5A5192-D827-5005-004E-FC522CEA06C0": "Factory",
        "333C4F19-2FD9-80EE-9DC2-565685AE7D50": "Farm",
        "EC7FB5BE-A124-EC02-E9B6-0B5BA4C26D47": "Fishery",
        "467E5469-87A2-44DE-7203-8B3C58D49044": "Fort",
        "76095EE6-F532-2D76-57BA-7981B07294BE": "Fortress",
        "52FC742A-34E9-CB4A-8DEF-68A27759D258": "Foundry",
        "2B7928A2-E96F-E4BC-1E08-A74529225264": "Garage",
        "11A12BCF-4538-89D2-3888-9A03790072C4": "Garden",
        "877C16B3-96E9-25BD-D12D-10F51A1CAFC0": "Gatehouse",
        "6A72E939-402C-DA16-C2EB-AAA95BCC17E3": "General Store",
        "DAEDF534-4EC3-E916-F2CC-E3E0E31E8BC0": "Government Complex",
        "2B130403-B088-8FF5-B202-8922759BABDD": "Graveyard",
        "3238A6F9-05EA-32E1-F19A-B7EF1B667788": "Great Hall",
        "5B41F7E5-5D43-7137-114B-A2EFF22D996D": "Guildhall",
        "B1B7CD9F-E9B8-B333-5988-D3C0057FE04A": "Gym",
        "56D7BA20-D044-F330-026F-1FB555C42C59": "Hangar",
        "9C1B45F3-ADA7-3471-CF66-E05E88716574": "Henge",
        "5B36A87C-F464-647D-7DCD-499CA499528D": "Hideout",
        "71CBD568-8072-66E8-37BD-D981A572B835": "Hospital",
        "BF94F6AD-C025-6102-C3A8-50E8FE367EC6": "Hospitality Camping",
        "9758A401-365F-8AD2-329C-B124B000C8E2": "Hospitality Hotel",
        "36F16EF2-FC9D-57DD-DE24-D44469C1CBAC": "Hospitality Motel",
        "69C3F7FB-2FE5-21A1-04DE-636C9B3387D1": "Hospitality Resort",
        "CDC76E93-5AD1-E80D-08C5-7B2F10080649": "Hospitality Spa",
        "390CA9BA-6324-BA20-7224-C0897297FFFD": "House",
        "139AFF5A-528C-A922-5436-5A2852C82F90": "House Large",
        "952D01EA-8A43-3DEF-BB12-E4F6DD69FD45": "Hydroponics Agricultural Complex",
        "9ACC3705-F8A5-1ED2-22BA-308C52D94DEF": "Inn",
        "4350D01A-56C5-CA6F-BCC1-32D6C2117F46": "Jeweler Building",
        "2CDC463C-5582-FDF2-F04B-9192674F3DAC": "Keep",
        "B992A172-D3D1-4BF4-A9FB-19448D14D2D2": "Kiosk Small Store",
        "EB59D8AE-9995-800A-4696-3254B1FD6A13": "Laboratory",
        "B71C82DA-CC53-C15E-9DC9-052AF2734E5F": "Laboratory Magical",
        "C45FF93F-1106-6B2F-D6DB-25213C8F1D8B": "Lair Building",
        "A7D57843-FAB7-F534-A9ED-DAFD5AF188C6": "Library",
        "79A20201-5CF1-C9F3-A5CE-34B8578FD498": "Lighthouse",
        "B0768EB7-8EE7-500F-628D-336163307C17": "Manor House Meeting Hall",
        "DC3DC1CB-1E0A-86B0-1F24-75DF34EFD580": "Mansion Villa",
        "551A7082-B43B-6302-DA50-330AE0401B05": "Market Square",
        "79A4423C-9B40-08F4-DC89-C170AB2B8808": "Market Stall",
        "E988F6F8-ABBF-9395-1931-80CA1BAB1F9A": "Megalith",
        "0BB1AF70-531F-5635-DB98-79FF1B815AC8": "Memorial War Memorial",
        "E2642195-EDA0-141A-2147-77E13647D85F": "Military Base Complex",
        "CC2CBD07-A4BC-E872-12EF-37CC91005D49": "Mill",
        "8A81EE5E-5185-A6AB-29A1-E69F0B2D4B20": "Mine",
        "C64044AF-3A5E-DE56-BB5F-5400FECD5CC0": "Ministry City Hall",
        "2269DB7C-237E-6EC0-7B80-DA7CE0AC67B6": "Missile Launch Facility",
        "E69EFD66-F8CC-0847-D4C3-41D1E9DFD255": "Monastery",
        "76066F6C-B169-3025-E3C0-9DEA1A55CDA4": "Monument Statue Large",
        "074B01B3-D3FB-7D5D-7248-DBB0BAD7CA3B": "Museum",
        "C5248D97-B2E5-2046-A5CD-15820694BC31": "Obelisk",
        "1DF25B9D-33A7-CDA5-9EB4-9A98C3407241": "Observatory Telescope",
        "279B83E1-99A0-B23D-804B-62DB1DEFF888": "Office",
        "181DA10F-9C6F-3365-63C3-C466258620D6": "Opera House",
        "91B65E7C-D87A-349E-21EA-9BFB53533D2B": "Orphanage",
        "944306E6-2D20-5D23-E5E3-6F1984285E34": "Orrery",
        "10341BAB-04C6-8829-EC7A-F647487F6317": "Palace",
        "EEDA8505-F8C2-2E1E-2DEC-B0BD79F35871": "Park",
        "DF9823AC-E1BB-E716-486C-FBEBDF270964": "Parliament",
        "F6CED23C-3BE7-2904-C18A-C77C589CE0B1": "Pier",
        "46A29A8A-8AC2-8381-B670-73BB1190A326": "Plaza",
        "E64E94A5-60A7-26FF-DE15-DEA120685D00": "Police Fire Station",
        "209D3374-7C85-97DF-7010-ED1B83B656D9": "Portal",
        "53D2F0E7-F84E-D678-8239-768DE86083CA": "Post Office",
        "35A212B5-98D0-FEA4-CC56-B7CF90BD1087": "Power Plant",
        "05DEF6F9-8090-5240-41F9-A45ED1DA95BE": "Prison",
        "7D3A1294-4F49-A284-C8BF-7AE38A5ED33A": "Quarry",
        "422E4A30-0ECD-77A3-095F-B8F3972F3689": "Racing Track Hippodrome",
        "24493929-317B-30CE-398D-23030C0586DD": "Refinery Industrial Complex",
        "33AD66E3-BD6B-A262-27AE-8DA825477576": "Reservoir",
        "1F4E1F50-6ED2-BE4D-5BD9-25BDD5BDB5DF": "Retirement Home",
        "F8E5B117-B27E-E5AC-1482-73078CAA2BA0": "School",
        "43BDB501-B32B-144B-28E6-812AF56C6E7A": "Seaport",
        "6F78A7FF-2A5E-727A-3904-02F282811EA9": "Shed",
        "A773884A-CAD6-76CB-5DCE-F025A6D91931": "Shop Cobbler",
        "ACA3E968-C358-FCC5-0EBA-42E2068C200F": "Shop Generic",
        "64958272-483E-EEA4-EE07-A945F2A8F62A": "Shop Magic",
        "4FB12CDC-6812-18FA-95E4-044A9EE66F50": "Shop Tailor",
        "21CB6BFF-BCCA-98A1-816E-29D96A867ECA": "Shopping Mall Commercial Complex",
        "3D83726F-7B34-9CB9-142B-C52E818117A3": "Shrine",
        "FCB7F0DD-461E-82DC-B522-DE4FD47D1CD3": "Silo",
        "DD8437E1-8615-D32E-C689-E6A0CD8DBE71": "Skyscraper",
        "606FA106-BCBC-4533-A454-081F0D9E7ECB": "Slaughterhouse",
        "02B6141A-3CB2-F5A2-0159-9D72121C5880": "Smelter",
        "5569DDAD-4BFE-6406-E3D0-D95FE4F44E05": "Spaceport",
        "91B071D9-E775-FA05-2847-5E5FF739C27B": "Spire",
        "4C1CBB1D-E4DD-FB2E-A784-3A2BF80D232C": "Stables",
        "24D859C0-AA57-D265-2FAF-212BD790A8CD": "Stadium",
        "62A2EE7E-B093-6F94-598E-1823912C2286": "Statue",
        "0AE91E6D-A890-D3A2-FE54-F6CBEF86A19B": "Storage House",
        "3FD5CB9B-0194-9D42-CCBF-BBFC2E80044E": "Store",
        "C552CB52-F198-12ED-FA4E-7F60E606108A": "Supermarket Megastore",
        "6C2A5A2A-75C9-A2F2-A277-8122404F15B5": "Tattoo Parlor",
        "E75F440A-B675-0C34-AEDD-568FDAD06675": "Tavern Pub Bar Restaurant",
        "069D9D1E-4C1F-B438-AA1C-CA1133E67B37": "Technology Complex",
        "F00CE88F-4D41-A36D-8883-8C3CAFAAD744": "Temple Church",
        "4172601E-FA34-6702-01F6-42BBE5EACCD1": "Theatre Concert Hall",
        "FC73E87B-BD88-590F-5409-8C2BDA8974A8": "Theme Park Entertainment Complex",
        "67EBE476-52BE-E493-A8B8-A972DBC506D2": "Timberyard",
        "D8C10B5A-06DB-EA50-ED0F-BF5F72370A0D": "Tower",
        "BAFCF694-703D-6D90-C6FD-62F0B55E06E4": "Tower Guard",
        "246C5FEC-3852-73BA-08C4-2C6BA3D0AFEE": "Tower Mage",
        "8C5E6FE2-A769-097B-42DF-C704A99FA567": "Tower Telecomms",
        "77371A15-CD6D-8215-2B47-F7DA63CE291D": "Tower Wall",
        "1794E87A-4330-59B0-ED7D-F3BBDE99FBF4": "Tower Water",
        "CED1BEFE-54AD-8AEB-9874-EAD2E1A39618": "Town Square",
        "B37046C6-F143-867D-D7CA-991F34572968": "Transportation Hub",
        "9760E476-0F8E-8874-B9FC-BC89A5CA79AF": "Transportation Station",
        "7E94D181-2193-B1ED-988B-2C497AD6EAE5": "Underground Vault",
        "3090FD9D-D14C-555E-19A2-D18E6A4A692D": "University Educational Complex",
        "23805AB3-9F2D-29EF-A7FD-A446638C8ED2": "Warehouse Granary",
        "1425763D-BEB3-7626-9B00-8B08AA74BCEE": "Water Pump",
        "553AF1FD-6292-BB80-598A-6207E656551A": "Well",
        "7F03B43E-A5CA-E4DA-0E74-957AAE7EF494": "Well Large",
        "4D752252-071F-8ACD-B8D3-9DF91AF5D58F": "Workshop",
        "680B2C74-6995-6E9C-9C72-1122B3221691": "World Wonder",
        "6FF37FE6-A877-9DD5-F9AB-D87B4C7C7469": "Arena",
        "2DDC4440-C14A-2F83-F418-5B85B96348E8": "Ship",
        "1F14D30F-8083-2DCC-C6E2-BF1D35ACD56A": "Butchery",
        "2FD990D9-55CE-AEC0-0D7E-ACF21BB9D332": "Sewers",
        "64E8A3F8-45B0-7D29-0F43-BFB208F654FF": "Ghost Train",
        "9490C429-4FDA-E669-390C-C6798696F312": "Train",
        "3D3D1A72-6A1D-002D-1ED0-04ED18F3D3CA": "Windmill",
        "E4B7F803-C689-A9A5-0FB7-EB8D9946874E": "Sun State Night",
        "04494E0F-FD0B-B2E7-3E15-94922127ADA2": "Sun State Sunrise",
        "7650DB9F-465F-DDA6-9D7E-E064F4BC910F": "Sun State Day",
        "7BA5009E-B362-AE2F-ABB6-D06D54D306EA": "Sun State Sunset",
        "72D05502-08AA-159C-AA98-D6548840F964": "Ashfall",
        "95D01E12-0C33-928F-4DE8-570AD806D10B": "Clear",
        "242858C1-C334-3A4C-7C5C-9706495750DD": "Cloudy",
        "1A485B48-C8F4-DF38-BB69-4FE828FDC8A5": "Dust Storm",
        "6B3F3EA7-DF1A-7F16-38D2-12542984DBD7": "Hail",
        "351702BB-5901-87AF-85EC-C8A6FBB7ECF9": "Hazy",
        "AFF257FE-DA6E-02E3-86FA-E06FF598180A": "Heavy Rain",
        "BE024638-C2F8-8F7B-2C08-BF017BBFB56F": "Heavy Snow",
        "7DF71D1B-2794-00E9-C672-3A95E279E521": "Partly Cloudy",
        "5DF3C480-7754-4872-302E-63CC3C4A9F03": "Raining",
        "C4097260-89C0-CB3C-19DD-B76A305EC039": "Sleet",
        "5ADA1900-D1AD-198D-A299-EB7EC01ADCBD": "Snowing",
        "828845FB-4210-2C7A-23CE-4223EDAD52D5": "Thunderstorm",
        "407B4AC5-27C4-60AD-FD56-9189FCDC8AE6": "Frigid",
        "EE3151A4-5BA0-52EB-85C8-B4E829E888BF": "Chill",
        "126B1B2D-5ED1-1DA4-AE38-34301FAEF2C2": "Cool",
        "4C543268-FEF1-23FE-4AFF-5A01A4F81953": "Temperate",
        "02673CAF-5E3B-966B-24EF-A6C8883169D8": "Warm",
        "41F03902-005B-8110-850D-B95DC7A01CB3": "Hot",
        "96DC27AA-0BBA-D76C-BA6E-C9DDAD103069": "Scorching",
        "6BB72BB2-74A1-B2F6-D856-D4A7561C87A6": "Still",
        "EC7ACDFA-A5FE-77B7-3451-C5C080DD71B5": "Breeze",
        "9283858C-98CD-FA04-72FC-5D2B9166A9D8": "Strong Wind",
        "29D3FFBA-3DB6-15C1-F88C-B72CFADAE907": "Gale",
        "EBC4D926-EF60-DD81-248E-54F6F31F29E0": "Storm Wind",
        "0CC8A592-CF4C-7BE4-DD0C-17A41D690A05": "Bright Light",
        "61D1498F-9175-6906-4B26-8356C28B28C1": "Dim Light",
        "99D3E371-AC3F-7839-28E7-770FE50D24C1": "Pitch Black",
        "67F42B5B-E3D1-0818-0197-1F36B20FC630": "Magical Darkness",
        "3FEEDE53-20B7-DEE8-C64B-8D0738E667A9": "Undead",
        "FE5CD056-4302-EBB7-BAE4-E8BC0CCC1FCD": "Plant",
        "01671C87-2DB5-B7C0-6312-FCCD4C20C128": "Ooze",
        "0D7FEDA8-DC2A-6048-5C13-73219F1F0B4F": "Monstrosity",
        "3A28EC64-DA47-09A0-AD1B-31B32627094F": "Humanoid",
        "D1429E13-BDC0-8D8A-011A-522DF622FA2C": "Giant",
        "208CF3F2-DE5C-77BC-21D5-3654094FE435": "Fiend",
        "492112D6-F574-43B2-9DFE-C37FE82A0763": "Fey",
        "D3E7CACD-C46B-1C27-39BC-3E4803D6AED5": "Elemental",
        "88D96DCB-894B-F4B2-7EEE-4306D63566F2": "Dragon",
        "BAF03D85-934E-4781-7C5F-26EE18BC8614": "Construct",
        "5169158E-D7ED-A3E6-7627-A934EBBD9CAD": "Celestial",
        "68B30308-92E2-38A9-E73B-5CA95EBFD424": "Beast",
        "EDD2EF50-DC2D-75F3-367F-A6A9D63D9316": "Aberration",
        "E5F142A7-D1C5-4ED9-BBC6-C7F8FEDF5D57": "Ambusher Role",
        "80C0326D-4585-60A8-5708-033FAE0EC680": "Artillery Role",
        "57D8FB10-DD22-A7D3-210D-01AADFE03373": "Brute Role",
        "D381A7F3-A0E2-FC3F-8EC2-39FF1AEC91AE": "Controller Role",
        "EE995E91-1D61-F2DC-E7BB-AA5651E561C7": "Leader Role",
        "FC1A548D-2BDF-D613-3645-59FCCFC0FD6D": "Minion Role",
        "D8A5BF1C-75A9-0B3A-C730-0CB31DB3F712": "Skirmisher Role",
        "583D47A6-9E33-1DB7-1305-2969E875122F": "Soldier Role",
        "E03C63EE-6D22-0F0D-0E13-FBA5FD5995B6": "Support Role",
        "7497DA6C-402A-212C-A1A3-CFE30C1906BD": "Light Cavalry",
        "F447DB78-35EB-BB77-E5CC-BF0FBE2377A8": "Shock Cavalry",
        "E2EBA358-809D-BA9D-0A25-C82844B76370": "Heavy Cavalry",
        "1306C042-A7D0-1C4D-2AE7-3E614450712C": "Missile Cavalry",
        "E2CEA842-2B66-5D3C-C20D-0454E18215F4": "Monstrous Cavalry",
        "8CF73E8B-507E-62B5-03F6-A8139E21FAB9": "Flying Cavalry",
        "382D2E23-8E52-D2C6-894B-63C03C83B380": "Hybrid Cavalry",
        "28A29340-0491-F2E2-229E-757B0412DF51": "Manifestation Of Clairvoyance",
        "2F81920D-CDB8-8183-E3BC-C6DA16337C60": "Manifestation Of Metamorphosis",
        "088D272A-90C4-738E-A49B-621FB95046CF": "Manifestation Of Pyrokinesis",
        "4659B268-8213-6C36-81DB-39877F546282": "Manifestation Of Telekinesis",
        "5479CD63-381D-321E-8FCF-894691D324F0": "Manifestation Of Telepathy",
        "96E272A4-8DDE-443C-0FCF-3A24ECFFB7C2": "Arcane Sphere of Magic",
        "57F117E8-6659-4F2D-AED2-82D6005492B9": "Divine Sphere of Magic",
        "B4D1AA5E-3B7B-4CE6-BA1E-DC43A5EEBF38": "Primal Sphere of Magic",
        "DD1EFCA2-2A4C-AD3D-B814-A325B2D22D85": "Circle of Abjuration",
        "54058786-9840-7A02-90F6-36151FA0A3F2": "Circle of Charm",
        "9931FE30-8ACF-40E2-8E69-EB78925364DF": "Circle of Conjuration",
        "5886822F-FA79-E5CA-C255-DCC7D375CB52": "Circle of Divination",
        "A28D2D20-BCE9-1CE0-4371-7F42231E9C43": "Circle of Evocation",
        "EC1F7FF4-9E4C-DAE0-633A-B0BE7F4A2788": "Circle of Illusion",
        "F5D2429C-6BA8-901F-2E23-30C780107C47": "Circle of Necromancy",
        "CC4C52BD-A341-0CAC-6C0B-671C9CC1C2EC": "Circle of Transmutation",
        "C53BE2B6-07EA-4B3B-9664-1AD286C44AF9": "Circle",
        "0FEF0148-6B62-4601-A8A1-A5A1A22905D8": "Cone",
        "0DBFA54E-F921-4835-B159-2A4AEFA62408": "Cube",
        "E8B770D7-1BC3-4035-A29C-B99047884CC1": "Cylinder",
        "56D1C490-B589-4B17-889A-59D866E38D54": "Line",
        "981032B8-4F0B-43C9-8D98-67C693E4DB42": "Sphere",
        "3F14BF23-09A6-4C05-AFD9-EE0CCD2596A3": "Square",
        "A18765B6-F35A-47E2-F112-DF1582C37B37": "Full Caster",
        "E8FB3E1F-2B16-4889-831C-99FC9E34853E": "Half Caster",
        "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B": "No Bending Powers",
        "7C713184-C2B3-2270-2ADA-1B3C47CF2FFE": "Abolian",
        "11797B93-B552-807F-C1D7-B75DAB51EC34": "Abyssal",
        "77AC72F7-688C-093D-1E29-067C8ECDC548": "Aquan",
        "D31BAE4B-F984-13F2-537D-156D07F2F7BE": "Auran",
        "9CE184D4-669F-C2FC-1FA3-F6D3E55561A0": "Common",
        "CE922467-93C7-3589-86B8-B5C1B12F24DB": "Domir",
        "F3DD13A6-DBA1-104A-E16D-78CD3513E97C": "Draconic",
        "F968E89D-C2FF-FA26-951F-02587238161A": "Druidic",
        "16F6B377-200C-3FBC-966B-6E9B957A2119": "Dwarvish",
        "3BDE75C8-41C3-6DE0-8CDC-388ED5D89670": "Elvish",
        "48655553-071F-29AC-071F-E7E9E4D53235": "Enochian",
        "16F6B377-200C-3FBC-966B-6E9B957A2110": "Gnomish",
        "DFCE3528-A8AF-ACFF-B837-7A89B1E85FB3": "Grel",
        "EA0C0C09-5B81-A5E2-D325-82330B54A196": "Ignan",
        "03E06BE0-F073-0D9B-E804-A9F014FAFF07": "Infernal",
        "3FB72788-E5FE-2B64-2D1F-2A14BCC6284E": "Nagh",
        "2AC81DE7-B375-9903-CABB-72BAFF74589B": "Orcish",
        "305B9EAE-E108-C9EE-D31A-475F75AA3380": "Primordial",
        "32E190D7-0A38-4071-81F7-0EC82089CCD4": "Qini",
        "E2528842-8503-6034-9AE2-1C28C1893A22": "Sign Language",
        "62DCCEE7-C228-2081-F171-F49FA62120D2": "Sylvan",
        "AC7B499B-0F30-B16D-D924-183E9473BDE0": "Terran",
        "A1ECE347-CF64-8454-67CF-9CA8BDEBFD7D": "Thieves Cant",
        "E7039ED2-EA0E-4218-A3BF-931A63F983DA": "Umbral",
        "1DAED3A6-061B-E97C-666C-E7052D35D795": "Cymbals",
        "CEC78DC1-BBD3-C002-C417-AF27527D5BDD": "Drums",
        "C8B52433-7E4D-B8E1-296E-BE22246545BB": "Flutes",
        "B789A689-BF68-FD5B-4AB4-A62CB0982AA4": "Harps",
        "D32C5490-F221-382F-5F10-78C118E746AA": "Horns",
        "DB1F3A9C-996D-4CD9-AC59-7607CF044826": "Keyboards",
        "B6005F12-E943-618E-BE29-1E047FC1D1E8": "Pipes",
        "0831E19B-EB88-2B7E-DC7E-55739032AEAF": "Stringed Bow",
        "FBD8C681-C1CE-B2D5-9D2C-B41CFA9E16D7": "Stringed Plucked",
        "13C64193-606F-CA6E-2148-C899AB761ED7": "Zithers",
        "8D31485E-8590-7829-2918-2BEA0F1C125C": "Spring",
        "C3A3E1D8-1393-370F-C3D5-FEA77B0EB518": "Summer",
        "69DDD63C-1DEF-A3C2-DF5C-D022747821CA": "Autumn",
        "467B3256-C3F2-3426-217D-A8A779ED62FB": "Winter",
        "F66879A9-5BDC-4996-8419-AF162CFCDC5F": "Acid",
        "0C528CF8-1B5A-453C-9BDE-73CBBC239A2A": "Bludgeoning",
        "8C455214-9F98-43C7-B9BC-1C74EE60805D": "Cold",
        "A8469481-849E-4BBA-986E-7C418DCA06A1": "Fire",
        "25F9052F-B963-43CB-991E-EB315E08A549": "Force",
        "944EC0D7-3320-42B1-B28D-68980DAA9719": "Lightning",
        "D66B715F-E086-4C4B-A887-4BDB38AE32EB": "Necrotic",
        "C62E5227-0AB4-4C34-9058-DE97E36B0706": "Piercing",
        "4EBFF986-A4AA-4709-BE68-E97D29B66D18": "Poison",
        "B61FDA44-4707-4539-B39B-54FA1FCBAA71": "Psychic",
        "5850D66F-70E8-467D-9A5C-93464A5A12C4": "Radiant",
        "422B9C6D-9558-47CD-AC21-1FB3B45EF33E": "Slashing",
        "F79CF36E-F439-44C3-9668-050683A30F1C": "Thunder",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "Tiny",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "Small",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "Medium - Size",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "Large",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "Huge",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "Gargantuan",
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "Colossal",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "Titanic",
        "C79A906F-BA10-B705-1CB9-6A7C5DFAEBEF": "Custom Full Ability",
        "E350D4F5-B29D-17C0-4AB4-0CAA0398C74A": "Custom Ability",
        "41FF250E-4146-C8C2-1324-DD6911BDB372": "Custom Quick Ability",
        "EEB78637-0F73-8369-D230-8C29512B759E": "Custom Free Ability",
        "BF71B9FC-32EF-29EF-9560-7219EBE600CD": "Custom Reaction Ability",
        "7DBEB6D4-D147-703A-022E-05B290BB95C3": "Friend",
        "9399856B-2132-7574-1684-91139A2831DD": "Enemy",
        "BBF5D6A6-FB9B-E07D-0497-B60EC68D2EBD": "Neutral",
        "FDC86C34-8F96-3361-E0A9-FCFAFF0522D9": "Campaign Difficulty Easy",
        "410CC547-393F-0922-9C58-48F618A27742": "Campaign Difficulty Normal",
        "DF66C93B-B190-4A4C-8E15-72E79D8F7C08": "Campaign Difficulty Hardcore",
        "0D629F19-23AC-18BE-B79C-73CB52703F66": "Male",
        "1214C099-5021-24B5-5D8D-608B832CE70A": "Female",
        "338C4063-2F1E-6A9D-5451-8E6ED3266353": "Unspecified Gender",
        "host": "Host",
        "adv": "Advantage",
        "dis": "Disadvantage",
        "class": "Class",
        "subclass": "Subclass"
    },
    "sizeTemplates": {
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": {
            "armor": "A8836DBE-5C5C-5A08-751D-FF08B3637F3E",
            "weapon": "7D13C52F-E3FD-8063-AC46-27E568C2545A",
            "equipment": "D2529D01-B3BF-5FEC-599C-CC1E03922239"
        },
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": {
            "armor": "97D7508A-D7DD-AECE-2EC6-A75B64A2759B",
            "weapon": "97D7508A-D7DD-AECE-2EC6-A75B64A2759B",
            "equipment": "97D7508A-D7DD-AECE-2EC6-A75B64A2759B"
        },
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": {
            "armor": null,
            "weapon": null,
            "equipment": null
        },
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": {
            "armor": "3C952B94-A2E3-0970-7B95-3C13BE0595CA",
            "weapon": "721321D5-D7C9-37E1-9FBD-C836E3819DC1",
            "equipment": "EFF024C1-15C4-0345-C5D8-51294038DBEC"
        },
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": {
            "armor": "9F230C20-7D5A-F350-BD1A-75C1164F300C",
            "weapon": "EA8D2DDA-8F88-F664-3D41-1728D2966BB7",
            "equipment": "9FAE19D4-5E4F-032C-7681-0EC502FFB0D7"
        },
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": {
            "armor": "840830AC-F3BC-7C01-6057-03FC55452811",
            "weapon": "8F7950C8-A21E-2DB0-0815-ED92B8746AC3",
            "equipment": "C4F901E3-185E-3749-4EF0-878C6E09D888"
        },
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": {
            "armor": "7B1C6D49-B1E4-6C4D-4310-B95560EF04C2",
            "weapon": "05F18B31-E1E4-C23C-7389-80CA58E89440",
            "equipment": "8A11DECE-EA06-94DC-73C6-F87E8B907AA2"
        },
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": {
            "armor": "8966BA38-43A7-51A1-8C77-BBC22D89CEC8",
            "weapon": "44D45637-FCFE-FC95-BE32-DD47FCAEC116",
            "equipment": "27244D0E-9DFD-95C6-D1D7-3890830A30EC"
        }
    }
}
